
import { Vue } from "vue-class-component"; //基本需要\
import * as echarts from "echarts";
import html2canvas from "html2canvas";
import { flamegraph } from "d3-flame-graph";
import * as d3 from "d3";
import {
  dispatchDeepPerformanceCpuCpuThreads,
  dispatchDeepPerformanceCpuCpuVersions,
  dispatchDeepPerformanceCpuCpuVersionsOld,
  dispatchDeepPerformanceCpuCpuByFrame,
  dispatchDeepPerformanceCpuStack,
  dispatchDeepPerformanceCpuFunctionCos,
  dispatchUploadCpuReportNew,
  dispatchDeepPerformanceCpuDetail,
  dispatchDeepPerformanceCpuStackMerge,
  dispatchDeepPerformanceCpuUsageList,
  dispatchDeepPerformanceCpuUsageListQQ,
  dispatchDeepPerformancefuncList,
  dispatchDeepPerformanceCpuCpuConfig,
  dispatchDeepPerformanceFpsInsideTrend,
  dispatchDeepPerformanceCpuPerfTrend,
  dispatchDeepPerformanceCpuUsageTrend,
  dispatchDeepPerformanceCpuCpuFunctionOverviewNew,
  dispatchDeepPerformanceCpuCpuTrend,
  dispatchDeepPerformanceCpuFunctionModuleTrend,
  dispatcDeepPerformanceCpuPutConfig,
  dispatchDeepPerformanceCpuCpuFunction,
  dispatchDeepPerformanceCpuCpuConfigSoList,
  dispatchDeepPerformanceCpuReport,
  dispatchDeepPerformanceCpuPutDetail,
  dispatchDeepPerformanceCpuReportText,
  dispatchCpuFuncDeivceOptions,
  dispatchCpuFuncScenesOptions,
  dispatchDeepPerformanceTrendNode,
  dispatcDeepPerformanceCpufuncTrend,
  dispatchDeepPerformanceCpuCustomTrend,
  dispatchDeepPerformanceCpuCustomData,
  dispatchDeepPerformanceCpuUsageListModuleQQ,
  dispatchDeepPerformanceCputhreadByFrame,
  dispatchDeepPerformanceFrameProblem,
  dispatchDeepPerformanceCpuThreadTrend,
  dispatchDeepPerformanceCpuThreadList,
  dispatchCpuTrend,
} from "@/store/performance/actions";
import { readDeepPerformanceSelectOptionsOld } from "@/store/performance/getters";
import { readIsLoggedIn, readUserProfile } from "@/store/main/getters";
import { store } from "@/store";
import {
  readGetdeepCpuThreads,
  readGetdeepCpuVersions,
  readGetdeepCpuVersionsOld,
  readGetdeepFpsInsideTrend,
  readGetdeepCpuPerfTrend,
  readGetdeepCpuUsageList,
  readGetdeepCpuUsageListQQ,
  readGetdeepCpuUsageTrend,
  readGetdeepCpuFunctionOverview,
  readGetdeepCpuTrend,
  readGetdeepCpuByFrame,
  readGetdeepCpuStack,
  readGetdeepCpuFunctionCos,
  readGetdeepCpuConfigSoList,
  readGetdeepCpuConfig,
  readGetdeepCpuModuleTrend,
  readGetdeepCpuFunction,
  readDeepPerformancePageList,
  readGetdeepCpuDetail,
  readGetdeepCpuReport,
  readGeCpuDeviceOptions,
  readGeCpuSceneOptions,
  readGetdeepfuncList,
  readGetdeepTrendNode,
  readGetdeepCpuFuncTrend,
  readGetdeepCpuCustomTrend,
  readGetdeepCpuCustomData,
  readGetdeepCpuUsageListMouduleQQ,
  readGetdeepCpuThreadByFrame,
  readGetDeepFrameProblem,
  readGetdeepCpuThreadTrend,
  readGetdeepCpuThreadList,
  readGeCpuTrend,
} from "@/store/performance/getters"; //引入仓库接口
import { ElMessage } from "element-plus";
import { dateConversion, getLocalProject } from "@/utils";

export default class TestReport extends Vue {
  public flame_thread = [];
  public serchDataShow = false;
  public openBtn() {
    this.serchDataShow = !this.serchDataShow;
  }
  public localProject = Number(getLocalProject());
  //   是否自动手动下拉框数据
  public get report_data_list() {
    let obj: any = { tiemline: "" };
    obj = readGetdeepCpuReport(store);
    obj.tiemline = dateConversion(obj.time);
    return readGetdeepCpuReport(store);
  }
  public get cpu_trend_data() {
    return readGeCpuTrend(store);
  }
  public replaceSpacesWithHyphens(str) {
    return str.replace(/ /g, "-");
  }
  public removeEmptyArrays(obj) {
    for (const key in obj) {
      const item = obj[key];
      let allEmpty = true;
      for (const prop in item) {
        if (item[prop].length === 0) {
          delete item[prop];
        } else {
          allEmpty = false;
        }
      }
      if (allEmpty) {
        delete obj[key];
      }
    }
  }
  public get cpu_thread_trend() {
    return readGetdeepCpuThreadTrend(store).data;
  }
  public get frameProblem() {
    return readGetDeepFrameProblem(store);
  }
  public get cpu_thread_by_frame() {
    let obj = {
      0: { thread: [2, 4, 6, 8, 11, 13], os: [2, 4, 1, 3, 5, 6] },
      1: { thread: [122, 2, 4, 15], os: [41, 12, 213, 123] },
    };
    return readGetdeepCpuThreadByFrame(store);
    // return obj
  }

  public get cpu_thead_options() {
    if (this.cpu_thread_trend) {
      return Object.keys(this.cpu_thread_trend);
    } else {
      return [];
    }
  }
  public importanta_data(find?, key?) {
    let fps_problem = [];
    let list = ["FPS", "CPU", "GPU", "线程耗时(ms)", "模块函数(ms)"];

    this.fps_top.forEach((v) => {
      v.index_name = "FPS";
      v.top
        .filter((m) => m.color == "red" || m.color_new == "red")
        .forEach((k) => {
          k.timeline = v.time;
          k.index_name = v.index_name;
          fps_problem.push(k);
        });
    });

    let cpu_problem = [];
    //  this.top_cpu.filter(
    //   (v) => v.color == "red" || v.color_new == "red"
    // );
    this.top_cpu.forEach((v) => {
      v.index_name = "CPU";
      v.top
        .filter((m) => m.color == "red" || m.color_new == "red")
        .forEach((k) => {
          k.timeline = v.time;
          k.index_name = v.index_name;
          cpu_problem.push(k);
        });
    });
    let gpu_problem = [];
    this.top_gpu.forEach((v) => {
      v.index_name = "GPU";
      v.top
        .filter((m) => m.color == "red" || m.color_new == "red")
        .forEach((k) => {
          k.timeline = v.time;
          k.index_name = v.index_name;
          gpu_problem.push(k);
        });
    });
    let thread_problem = [];
    //    this.top_thread_3.filter(
    //   (v) => v.color == "red" || v.color_new == "red"
    // );
    this.top_thread_3.forEach((v) => {
      v.index_name = "线程耗时(ms)";
      v.top
        .filter((m) => m.color == "red" || m.color_new == "red")
        .forEach((k) => {
          k.timeline = v.time;
          k.index_name = v.index_name;
          thread_problem.push(k);
        });
    });
    let module_problem = [];
    //  this.top_moudle_5.filter(
    //   (v) => v.color == "red" || v.color_new == "red"
    // );
    this.top_moudle_5.forEach((v) => {
      v.index_name = "模块函数(ms)";
      v.top
        .filter((m) => m.color == "red" || m.color_new == "red")
        .forEach((k) => {
          k.timeline = v.time;
          k.index_name = v.index_name;
          module_problem.push(k);
        });
    });

    if (this.important_flag) {
      this.name_list.push(Object.keys(this.frameProblem));
      this.options_list_name = this.name_list.flat();
    }

    // this.options_list={}

    this.options_list_name.forEach((i) => {
      if (!this.options_list[i]) {
        this.options_list[i] = {};
      }

      list.forEach((v) => {
        if (v === "FPS") {
          if (this.fps_top.filter((n) => i == n.time).length > 0) {
            this.options_list[i][v] = this.fps_top
              .filter((n) => i == n.time)[0]
              .top.filter((m) => m.color == "red" || m.color_new == "red");
          }
        }
        if (v === "CPU") {
          if (this.top_cpu.filter((n) => i == n.time).length > 0) {
            this.options_list[i][v] = this.top_cpu
              .filter((n) => i == n.time)[0]
              .top.filter((m) => m.color == "red" || m.color_new == "red");
          }
          // this.options_list[i][v]=this.top_cpu.filter(n=>i==n.time)[0].top
        }
        if (v === "GPU") {
          if (this.top_gpu.filter((n) => i == n.time).length > 0) {
            this.options_list[i][v] = this.top_gpu
              .filter((n) => i == n.time)[0]
              .top.filter((m) => m.color == "red" || m.color_new == "red");
          }
          // this.options_list[i][v]=this.top_gpu.filter(n=>i==n.time)[0].top
        }
        if (v === "线程耗时(ms)") {
          if (this.top_thread_3.filter((n) => i == n.time).length > 0) {
            this.options_list[i][v] = this.top_thread_3
              .filter((n) => i == n.time)[0]
              .top.filter((m) => m.color == "red" || m.color_new == "red");
          }
          // this.options_list[i][v]=this.top_thread_3.filter(n=>i==n.time)[0].top
        }
        if (v === "模块函数(ms)") {
          if (this.top_moudle_5.filter((n) => i == n.time).length > 0) {
            this.options_list[i][v] = this.top_moudle_5
              .filter((n) => i == n.time)[0]
              .top.filter((m) => m.color == "red" || m.color_new == "red");
          }
          // this.options_list[i][v]=this.top_moudle_5.filter(n=>i==n.time)[0].top
        }
      });
    });

    this.table_test_overview_important = [];
    //    for(let x in this.options_list ){
    //              const item = this.options_list[x];
    //   let allEmpty = true;
    //        for (const prop in item) {
    //     if (item[prop].length !== 0) {
    //       allEmpty = false;
    //       break;
    //     }
    //   }
    // console.log(this.options_list)
    //   if (allEmpty) {
    //     let list=['avg_fps','single_frame_time']

    //     list.forEach((v,index)=>{
    //       // console.log(this.fps_top.filter(v=>v.time==x)[0].top.filter(p=>p.name==x))

    //        if(index==0){
    //            let data=this.fps_top.filter(v=>v.time==x)[0].top.filter(p=>p.name==v)[0]
    //       //  let text = (this.fps_top[x].new[v] > this.frameProblem[x].old[v] ? "↑" : "↓") +Math.abs(this.frameProblem[x].new[v]  - this.frameProblem[x].old[v] ).toFixed(2);
    //        let textAll= data.text;
    //           item.FPS.push({value:data.value ,color:"#303133",color_new:"#303133",index_name:'FPS',name:v,timeline:x,old:data.old ,text: textAll
    //                   }); // 替换为您想要添加的值

    //        }else{
    //          console.log(this.top_moudle_5.filter(v=>v.time==x)[0].top.filter(p=>p.name==v).length)
    //            let data:any={}
    //           if(this.top_moudle_5.filter(v=>v.time==x)[0].top.filter(p=>p.name==v).length>0){
    //             data=this.top_moudle_5.filter(v=>v.time==x)[0].top.filter(p=>p.name==v)[0]
    //           }else{
    //                console.log(this.moTreend_data.chinese)
    //           }
    //       //  let text = (this.fps_top[x].new[v] > this.frameProblem[x].old[v] ? "↑" : "↓") +Math.abs(this.frameProblem[x].new[v]  - this.frameProblem[x].old[v] ).toFixed(2);
    //        let textAll= data.text;
    //          console.log(this.frameProblem[x].old,v)
    //             item['线程耗时(ms)'].push({value:data.value  ,color:"#303133",color_new:"#303133",index_name:'线程耗时(ms)',name:v,timeline:x,old:data.old,text: textAll
    //                   }); // 替换为您想要添加的值
    //        }
    //     })

    //   }
    //     }

    for (let i in this.options_list) {
      for (let n in this.options_list[i]) {
        this.options_list[i][n].forEach((x) => {
          this.table_test_overview_important.push({
            model:
              this.report_data_list?.device_level +
              "-" +
              this.report_data_list?.device_name,
            scene: this.report_data_list?.scene,
            risk: this.risk,
            index_name: i,
            index_detail: x.index_name,
            index_detail_name: this.chinese_name(x.name),
            value: x.value,
            color: x.color,

            color_new: x.color_new,
            text: x.text,
            edit: false,
            edit_name: false,
            edit_vale: false,
            edit_detail: false,
          });
        });
      }
    }

    this.removeEmptyArrays(this.options_list);
    this.mergeRows(this.table_test_overview_important);
  }
  public add_important_data() {
    let list_add = [];

    Object.keys(this.frameProblem).forEach((v) => {
      this.options_list_name.push(v);
      list_add.push(v);
    });
    this.message_error = [];
    let fps_problem = [];
    let list = ["FPS", "CPU", "GPU", "线程耗时(ms)", "模块函数(ms)"];

    this.fps_top.forEach((v) => {
      v.index_name = "FPS";
      v.top
        .filter((m) => m.color == "red" || m.color_new == "red")
        .forEach((k) => {
          k.timeline = v.time;
          k.index_name = v.index_name;
          fps_problem.push(k);
        });
    });

    let cpu_problem = [];
    //  this.top_cpu.filter(
    //   (v) => v.color == "red" || v.color_new == "red"
    // );
    this.top_cpu.forEach((v) => {
      v.index_name = "CPU";
      v.top
        .filter((m) => m.color == "red" || m.color_new == "red")
        .forEach((k) => {
          k.timeline = v.time;
          k.index_name = v.index_name;
          cpu_problem.push(k);
        });
    });
    let gpu_problem = [];
    this.top_gpu.forEach((v) => {
      v.index_name = "GPU";
      v.top
        .filter((m) => m.color == "red" || m.color_new == "red")
        .forEach((k) => {
          k.timeline = v.time;
          k.index_name = v.index_name;
          gpu_problem.push(k);
        });
    });
    let thread_problem = [];
    //    this.top_thread_3.filter(
    //   (v) => v.color == "red" || v.color_new == "red"
    // );
    this.top_thread_3.forEach((v) => {
      v.index_name = "线程耗时(ms)";
      v.top
        .filter((m) => m.color == "red" || m.color_new == "red")
        .forEach((k) => {
          k.timeline = v.time;
          k.index_name = v.index_name;
          thread_problem.push(k);
        });
    });
    let module_problem = [];
    //  this.top_moudle_5.filter(
    //   (v) => v.color == "red" || v.color_new == "red"
    // );
    this.top_moudle_5.forEach((v) => {
      v.index_name = "模块函数(ms)";
      v.top
        .filter((m) => m.color == "red" || m.color_new == "red")
        .forEach((k) => {
          k.timeline = v.time;
          k.index_name = v.index_name;
          module_problem.push(k);
        });
    });
    // this.importanta_data()
    list_add.forEach((i) => {
      if (!this.options_list[i]) {
        this.options_list[i] = {};
      }
      list.forEach((v) => {
        if (v === "FPS") {
          if (this.fps_top.filter((n) => i == n.time).length > 0) {
            this.options_list[i][v] = this.fps_top
              .filter((n) => i == n.time)[0]
              .top.filter((m) => m.color == "red" || m.color_new == "red");
          }
        }
        if (v === "CPU") {
          if (this.top_cpu.filter((n) => i == n.time).length > 0) {
            this.options_list[i][v] = this.top_cpu
              .filter((n) => i == n.time)[0]
              .top.filter((m) => m.color == "red" || m.color_new == "red");
          }
          // this.options_list[i][v]=this.top_cpu.filter(n=>i==n.time)[0].top
        }
        if (v === "GPU") {
          if (this.top_gpu.filter((n) => i == n.time).length > 0) {
            this.options_list[i][v] = this.top_gpu
              .filter((n) => i == n.time)[0]
              .top.filter((m) => m.color == "red" || m.color_new == "red");
          }
          // this.options_list[i][v]=this.top_gpu.filter(n=>i==n.time)[0].top
        }
        if (v === "线程耗时(ms)") {
          if (this.top_thread_3.filter((n) => i == n.time).length > 0) {
            this.options_list[i][v] = this.top_thread_3
              .filter((n) => i == n.time)[0]
              .top.filter((m) => m.color == "red" || m.color_new == "red");
          }
          // this.options_list[i][v]=this.top_thread_3.filter(n=>i==n.time)[0].top
        }
        if (v === "模块函数(ms)") {
          if (this.top_moudle_5.filter((n) => i == n.time).length > 0) {
            this.options_list[i][v] = this.top_moudle_5
              .filter((n) => i == n.time)[0]
              .top.filter((m) => m.color == "red" || m.color_new == "red");
          }
          // this.options_list[i][v]=this.top_moudle_5.filter(n=>i==n.time)[0].top
        }
        this.message_error.push(
          this.options_list[i][v].filter(
            (m) => m.color == "red" || m.color_new == "red"
          )
        );
        //      const item = this.options_list[i];
        // let allEmpty = true;

        // for (const prop in item) {
        //   if (item[prop].length !== 0) {
        //     allEmpty = false;
        //     break;
        //   }
        // }

        // if (allEmpty) {
        //   item.FPS.push("某些东西"); // 替换为您想要添加的值
        // }
        // this.options_list[i][v]
        //   // .filter((m) => m.color == "red" || m.color_new == "red")
        //   .forEach((x) => {
        //     this.table_test_overview_important.push({
        //       model:
        //         this.report_data_list?.device_level +
        //         "-" +
        //         this.report_data_list?.device_name,
        //       scene: this.report_data_list?.scene,
        //       risk: this.risk,
        //       index_name: i,
        //       index_detail: x.index_name,
        //       index_detail_name: this.chinese_name(x.name),
        //       value: x.value,
        //       color: x.color,

        //       color_new: x.color_new,
        //       text: x.text,
        //       edit: false,
        //       edit_name: false,
        //       edit_vale: false,
        //       edit_detail: false,
        //     });
        //   });
      });
    });
    for (let x in this.options_list) {
      const item = this.options_list[x];
      let allEmpty = true;
      for (const prop in item) {
        if (item[prop].length !== 0) {
          allEmpty = false;
          break;
        }
      }

      if (allEmpty) {
        let list = ["avg_fps", "single_frame_time"];

        list.forEach((v, index) => {
          let text =
            (this.frameProblem[x].new[v] > this.frameProblem[x].old[v]
              ? "↑"
              : "↓") +
            Math.abs(
              this.frameProblem[x].new[v] - this.frameProblem[x].old[v]
            ).toFixed(2);
          let textAll = "(" + text + ")";
          if (index == 0) {
            item.FPS.push({
              value: this.frameProblem[x].new[v],
              color: "#303133",
              color_new: "#303133",
              index_name: "FPS",
              name: v,
              timeline: x,
              old: this.frameProblem[x].old[v],
              text: textAll,
            }); // 替换为您想要添加的值
          } else {
            item["线程耗时(ms)"].push({
              value: this.frameProblem[x].new[v],
              color: "#303133",
              color_new: "#303133",
              index_name: "线程耗时(ms)",
              name: v,
              timeline: x,
              old: this.frameProblem[x].old[v],
              text: textAll,
            }); // 替换为您想要添加的值
          }
        });
      }
    }
    const filteredObj = {};

    const indexNames = this.table_test_overview_important.map(
      (item) => item.index_name
    );

    for (const key in this.options_list) {
      if (!indexNames.includes(key)) {
        filteredObj[key] = this.options_list[key];
      }
    }

    for (let i in filteredObj) {
      list.forEach((v) => {
        filteredObj[i][v].forEach((x) => {
          this.table_test_overview_important.push({
            model:
              this.report_data_list?.device_level +
              "-" +
              this.report_data_list?.device_name,
            scene: this.report_data_list?.scene,
            risk: this.risk,
            index_name: i,
            index_detail: x.index_name,
            index_detail_name: this.chinese_name(x.name),
            value: x.value,
            color: x.color,

            color_new: x.color_new,
            text: x.text,
            edit: false,
            edit_name: false,
            edit_vale: false,
            edit_detail: false,
          });
        });
      });
    }
    this.removeEmptyArrays(this.options_list);

    this.mergeRows(this.table_test_overview_important);
  }
  public timeline: any = "" || [];
  public get fps_top() {
    let fps_list = ["avg_fps", "jank", "var_fps"];
    let list = [];

    let times = [];
    for (let i in this.frameProblem) {
      times.push(i);
    }
    times.forEach((v) => {
      list.push({ time: v, data: [] });
    });
    list.forEach((v) => {
      fps_list.forEach((i) => {
        v.data.push({
          name: i,
          value: this.frameProblem[v.time].new[i],
          old: this.frameProblem[v.time].old[i],
          edit: false,
        });
      });
    });
    let baseline: any = this.getThreshold(
      this.removeEmptyParentObjects(this.cpu_set_up.config),
      this.report_data_list,
      this.configuration_form.scene_id
    ).baseline;

    let threshold: any = this.getThreshold(
      this.removeEmptyParentObjects(this.cpu_set_up.config),
      this.report_data_list,
      this.configuration_form.scene_id
    ).threshold;

    let is_bad_risk = !this.getThreshold(
      this.removeEmptyParentObjects(this.cpu_set_up.config),
      this.report_data_list,
      this.configuration_form.scene_id
    ).is_bad_risk;
    list.forEach((i) => {
      i.top = i.data;
      i.top.forEach((v) => {
        if (v.name == "avg_fps") {
          if (baseline[v.name]) {
            if (v.value < baseline[v.name]) {
              v.color = "red";
            } else {
              v.color = "#00b050";
            }
          } else {
            v.color = "#303133";
          }
          if (is_bad_risk) {
            if (threshold[v.name]) {
              if (
                Math.abs(v.value - v.old) / v.old >
                threshold[v.name]?.replace("%", "") / 100
              ) {
                v.color_new = v.value > v.old ? "#00b050" : "red";
                let text =
                  (v.value > v.old ? "↑" : "↓") +
                  Math.abs(v.value - v.old).toFixed(2);
                v.text = "(" + text + ")";
              } else {
                v.color_new = "#303133";
                let text =
                  (v.value > v.old ? "↑" : "↓") +
                  Math.abs(v.value - v.old).toFixed(2);
                v.text =
                  v.value == v.old ? "(--)" : text ? "(" + text + ")" : "";
              }
            } else {
              v.color_new = "#303133";
              let text =
                (v.value > v.old ? "↑" : "↓") +
                Math.abs(v.value - v.old).toFixed(2);
              v.text = v.value == v.old ? "(--)" : text ? "(" + text + ")" : "";
            }
          } else {
            v.color_new = "#303133";
            let text =
              (v.value > v.old ? "↑" : "↓") +
              Math.abs(v.value - v.old).toFixed(2);
            v.text = v.value == v.old ? "(--)" : text ? "(" + text + ")" : "";
          }
        } else {
          if (baseline[v.name]) {
            if (v.value > baseline[v.name]) {
              v.color = "red";
            } else {
              v.color = "#00b050";
            }
          } else {
            v.color = "#303133";
          }
          if (is_bad_risk) {
            if (threshold[v.name]) {
              if (
                Math.abs(v.value - v.old) / v.old >
                threshold[v.name]?.replace("%", "") / 100
              ) {
                v.color_new = v.value > v.old ? "red" : "#00b050";
                let text =
                  (v.value > v.old ? "↑" : "↓") +
                  Math.abs(v.value - v.old).toFixed(2);
                v.text = "(" + text + ")";
              } else {
                v.color_new = "#303133";
                let text =
                  (v.value > v.old ? "↑" : "↓") +
                  Math.abs(v.value - v.old).toFixed(2);
                v.text =
                  v.value == v.old ? "(--)" : text ? "(" + text + ")" : "";
              }
            } else {
              v.color_new = "#303133";
              let text =
                (v.value > v.old ? "↑" : "↓") +
                Math.abs(v.value - v.old).toFixed(2);
              v.text = v.value == v.old ? "(--)" : text ? "(" + text + ")" : "";
            }
          } else {
            v.color_new = "#303133";
            let text =
              (v.value > v.old ? "↑" : "↓") +
              Math.abs(v.value - v.old).toFixed(2);
            v.text = v.value == v.old ? "(--)" : text ? "(" + text + ")" : "";
          }
        }
      });
    });
    return list;
  }
  public get top_cpu() {
    let avg_list = ["avg_cpu_total", "avg_cpu"];
    let list = [];

    let times = [];
    for (let i in this.frameProblem) {
      times.push(i);
    }
    times.forEach((v) => {
      list.push({ time: v, data: [] });
    });
    list.forEach((v) => {
      avg_list.forEach((i) => {
        v.data.push({
          name: i,
          value: this.frameProblem[v.time].new[i],
          old: this.frameProblem[v.time].old[i],
          edit: false,
        });
      });
    });
    let baseline: any = this.getThreshold(
      this.removeEmptyParentObjects(this.cpu_set_up.config),
      this.report_data_list,
      this.configuration_form.scene_id
    ).baseline;

    let threshold: any = this.getThreshold(
      this.removeEmptyParentObjects(this.cpu_set_up.config),
      this.report_data_list,
      this.configuration_form.scene_id
    ).threshold;

    let is_bad_risk = !this.getThreshold(
      this.removeEmptyParentObjects(this.cpu_set_up.config),
      this.report_data_list,
      this.configuration_form.scene_id
    ).is_bad_risk;
    list.forEach((i) => {
      i.top = i.data;
      i.top.forEach((v) => {
        if (baseline[this.type_moudle(v.name)]) {
          if (v.value > baseline[this.type_moudle(v.name)]) {
            v.color = "red";
          } else {
            v.color = "#00b050";
          }
        } else {
          v.color = "#303133";
        }
        if (is_bad_risk) {
          if (threshold[this.type_moudle(v.name)]) {
            if (
              Math.abs(v.value - v.old) / v.old >
              threshold[this.type_moudle(v.name)]?.replace("%", "") / 100
            ) {
              v.color_new = v.value > v.old ? "red" : "#00b050";
              let text =
                (v.value > v.old ? "↑" : "↓") +
                Math.abs(v.value - v.old).toFixed(2);
              v.text = "(" + text + ")";
            } else {
              v.color_new = "#303133";
              let text =
                (v.value > v.old ? "↑" : "↓") +
                Math.abs(v.value - v.old).toFixed(2);
              v.text = v.value == v.old ? "(--)" : text ? "(" + text + ")" : "";
            }
          } else {
            v.color_new = "#303133";
            let text =
              (v.value > v.old ? "↑" : "↓") +
              Math.abs(v.value - v.old).toFixed(2);
            v.text = v.value == v.old ? "(--)" : text ? "(" + text + ")" : "";
          }
        } else {
          v.color_new = "#303133";
          let text =
            (v.value > v.old ? "↑" : "↓") +
            Math.abs(v.value - v.old).toFixed(2);
          v.text = v.value == v.old ? "(--)" : text ? "(" + text + ")" : "";
        }
      });
    });
    return list;
  }
  public get top_gpu() {
    let gpu_list = [
      "gpu_usage",
      "shaders_busy",
      "vertices_shaded",
      "fragments_shaded",
      "read_total",
      "write_total",
    ];
    let list = [];

    let times = [];
    for (let i in this.frameProblem) {
      times.push(i);
    }
    times.forEach((v) => {
      list.push({ time: v, data: [] });
    });
    list.forEach((v) => {
      gpu_list.forEach((i) => {
        v.data.push({
          name: i,
          value: this.frameProblem[v.time].new[i],
          old: this.frameProblem[v.time].old[i],
          edit: false,
        });
      });
    });
    let baseline: any = this.getThreshold(
      this.removeEmptyParentObjects(this.cpu_set_up.config),
      this.report_data_list,
      this.configuration_form.scene_id
    ).baseline;

    let threshold: any = this.getThreshold(
      this.removeEmptyParentObjects(this.cpu_set_up.config),
      this.report_data_list,
      this.configuration_form.scene_id
    ).threshold;

    let is_bad_risk = !this.getThreshold(
      this.removeEmptyParentObjects(this.cpu_set_up.config),
      this.report_data_list,
      this.configuration_form.scene_id
    ).is_bad_risk;
    list.forEach((i) => {
      i.top = i.data;
      i.top.forEach((v) => {
        if (baseline[this.type_moudle(v.name)]) {
          if (v.value > baseline[this.type_moudle(v.name)]) {
            v.color = "red";
          } else {
            v.color = "#00b050";
          }
        } else {
          v.color = "#303133";
        }
        if (is_bad_risk) {
          if (threshold[this.type_moudle(v.name)]) {
            if (
              Math.abs(v.value - v.old) / v.old >
              threshold[this.type_moudle(v.name)]?.replace("%", "") / 100
            ) {
              v.color_new = v.value > v.old ? "red" : "#00b050";
              let text =
                (v.value > v.old ? "↑" : "↓") +
                Math.abs(v.value - v.old).toFixed(2);
              v.text = "(" + text + ")";
            } else {
              v.color_new = "#303133";
              let text =
                (v.value > v.old ? "↑" : "↓") +
                Math.abs(v.value - v.old).toFixed(2);
              v.text = v.value == v.old ? "(--)" : text ? "(" + text + ")" : "";
            }
          } else {
            v.color_new = "#303133";
            let text =
              (v.value > v.old ? "↑" : "↓") +
              Math.abs(v.value - v.old).toFixed(2);
            v.text = v.value == v.old ? "(--)" : text ? "(" + text + ")" : "";
          }
        } else {
          v.color_new = "#303133";
          let text =
            (v.value > v.old ? "↑" : "↓") +
            Math.abs(v.value - v.old).toFixed(2);
          v.text = v.value == v.old ? "(--)" : text ? "(" + text + ")" : "";
        }
      });
    });

    return list;
  }
  public get top_thread_3() {
    let list = [];

    let times = [];
    for (let i in this.frameProblem) {
      times.push(i);
    }
    times.forEach((v) => {
      list.push({ time: v, data: [] });
    });
    let baseline: any = this.getThreshold(
      this.removeEmptyParentObjects(this.cpu_set_up.config),
      this.report_data_list,
      this.configuration_form.scene_id
    ).baseline;

    let threshold: any = this.getThreshold(
      this.removeEmptyParentObjects(this.cpu_set_up.config),
      this.report_data_list,
      this.configuration_form.scene_id
    ).threshold;

    let is_bad_risk = !this.getThreshold(
      this.removeEmptyParentObjects(this.cpu_set_up.config),
      this.report_data_list,
      this.configuration_form.scene_id
    ).is_bad_risk;
    list.forEach((v) => {
      this.thrend_data.chinese.forEach((i) => {
        v.data.push({
          name: i,
          value: this.frameProblem[v.time].new[i],
          old: this.frameProblem[v.time].old[i],
          edit: false,
        });
      });
    });
    // this.thrend_data.chinese.forEach((v) => {
    //   list.push({
    //     name: v,
    //     value: this.frameProblem[this.timeline].new[v],
    //     old: this.frameProblem[this.timeline].old[v],
    //   });
    // });
    list.forEach((i) => {
      i.top = i.data
        .filter((v) => v.name != "single_frame_time" && v.name != "FrameTime")
        .sort((a, b) => b.value - a.value)

        .slice(0, 3);
      i.top.push({
        name: "single_frame_time",
        value: this.frameProblem[i.time].new.single_frame_time,
        old: this.frameProblem[i.time].old.single_frame_time,
      });
      i.top.forEach((v) => {
        if (baseline[this.type_moudle(v.name)]) {
          if (v.value > baseline[this.type_moudle(v.name)]) {
            v.color = "red";
          } else {
            v.color = "#00b050";
          }
        } else {
          v.color = "#303133";
        }
        if (is_bad_risk) {
          if (threshold[this.type_moudle(v.name)]) {
            if (
              Math.abs(v.value - v.old) / v.old >
              threshold[this.type_moudle(v.name)]?.replace("%", "") / 100
            ) {
              v.color_new = v.value > v.old ? "red" : "#00b050";
              let text =
                (v.value > v.old ? "↑" : "↓") +
                Math.abs(v.value - v.old).toFixed(2);
              v.text = "(" + text + ")";
            } else {
              v.color_new = "#303133";
              let text =
                (v.value > v.old ? "↑" : "↓") +
                Math.abs(v.value - v.old).toFixed(2);
              v.text = v.value == v.old ? "(--)" : text ? "(" + text + ")" : "";
            }
          } else {
            v.color_new = "#303133";
            let text =
              (v.value > v.old ? "↑" : "↓") +
              Math.abs(v.value - v.old).toFixed(2);
            v.text = v.value == v.old ? "(--)" : text ? "(" + text + ")" : "";
          }
        } else {
          v.color_new = "#303133";
          let text =
            (v.value > v.old ? "↑" : "↓") +
            Math.abs(v.value - v.old).toFixed(2);
          v.text = v.value == v.old ? "(--)" : text ? "(" + text + ")" : "";
        }
      });
    });
    //   let top = list.filter(
    //     (v) => v.name != "single_frame_time" && v.name != "FrameTime"
    //   );
    //   let top_3 = top
    //     .sort((a, b) => b.value - a.value)

    //     .slice(0, 3);

    //   top_3.push({
    //     name: "single_frame_time",
    //     value: this.frameProblem[this.timeline].new.single_frame_time,
    //     old: this.frameProblem[this.timeline].old.single_frame_time,
    //   });

    //  top_3.forEach(v=>{
    //      if (baseline[this.type_moudle(v.name)]) {
    //        if(v.value>baseline[this.type_moudle(v.name)]){
    //      v.color='red'
    //        }else{
    //          v.color='#303133'
    //        }
    //      }else{
    //        v.color="#303133"
    //      }
    //      if (is_bad_risk) {
    //       if (threshold[this.type_moudle(v.name)]) {
    //         if (
    //           Math.abs(v.value - v.old) / v.old >
    //           threshold[this.type_moudle(v.name)]?.replace("%", "") / 100
    //         ) {
    //           v.color_new = v.value > v.old ? "red" : "#00b050";
    //           let text =
    //             (v.value > v.old ? "↑" : "↓") +
    //             Math.abs(v.value - v.old).toFixed(2);
    //           v.text = "(" + text + ")";
    //         } else {
    //           v.color_new = "#303133";
    //           let text =
    //             (v.value > v.old ? "↑" : "↓") +
    //             Math.abs(v.value - v.old).toFixed(2);
    //           v.text = v.value == v.old ? "(--)" : text ? "(" + text + ")" : "";
    //         }
    //       } else {
    //         v.color_new = "#303133";
    //         let text =
    //           (v.value > v.old ? "↑" : "↓") +
    //           Math.abs(v.value - v.old).toFixed(2);
    //         v.text = v.value == v.old ? "(--)" : text ? "(" + text + ")" : "";
    //       }
    //     } else {
    //       v.color_new = "#303133";
    //       let text =
    //         (v.value > v.old ? "↑" : "↓") + Math.abs(v.value - v.old).toFixed(2);
    //       v.text = v.value == v.old ? "(--)" : text ? "(" + text + ")" : "";
    //     }
    //  })
    //  console.log(top_3)
    return list;
  }
  public get top_moudle_5() {
    let list = [];

    let times = [];
    for (let i in this.frameProblem) {
      times.push(i);
    }
    times.forEach((v) => {
      list.push({ time: v, data: [] });
    });
    list.forEach((v) => {
      this.moTreend_data.chinese.forEach((i) => {
        v.data.push({
          name: i,
          value: this.frameProblem[v.time].new[i],
          old: this.frameProblem[v.time].old[i],
          edit: false,
        });
      });
    });
    let baseline: any = this.getThreshold(
      this.removeEmptyParentObjects(this.cpu_set_up.config),
      this.report_data_list,
      this.configuration_form.scene_id
    ).baseline;

    let threshold: any = this.getThreshold(
      this.removeEmptyParentObjects(this.cpu_set_up.config),
      this.report_data_list,
      this.configuration_form.scene_id
    ).threshold;

    let is_bad_risk = !this.getThreshold(
      this.removeEmptyParentObjects(this.cpu_set_up.config),
      this.report_data_list,
      this.configuration_form.scene_id
    ).is_bad_risk;
    list.forEach((i) => {
      let top_5 = [];
      top_5 = i.data.sort((a, b) => b.value - a.value).slice(0, 5);
      i.top = top_5;
      i.top.forEach((v) => {
        if (baseline.module) {
          if (v.value > baseline.module) {
            v.color = "red";
            // item.data.push({
            //   name: v.name,
            //   color: "red",
            //   new: String(v.value),
            //   baseline: baseline[this.type_moudle(v.type)],
            // });
          } else {
            v.color = "#00b050";
          }
        } else {
          v.color = "#303133";
        }
        if (is_bad_risk) {
          if (threshold.module) {
            if (
              Math.abs(v.value - v.old) / v.old >
              threshold.module?.replace("%", "") / 100
            ) {
              v.color_new = v.value > v.old ? "red" : "#00b050";
              let text =
                (v.value > v.old ? "↑" : "↓") +
                Math.abs(v.value - v.old).toFixed(2);
              v.text = "(" + text + ")";
            } else {
              v.color_new = "#303133";
              let text =
                (v.value > v.old ? "↑" : "↓") +
                Math.abs(v.value - v.old).toFixed(2);
              v.text = v.value == v.old ? "(--)" : text ? "(" + text + ")" : "";
            }
          } else {
            v.color_new = "#303133";
            let text =
              (v.value > v.old ? "↑" : "↓") +
              Math.abs(v.value - v.old).toFixed(2);
            v.text = v.value == v.old ? "(--)" : text ? "(" + text + ")" : "";
          }
        } else {
          v.color_new = "#303133";
          let text =
            (v.value > v.old ? "↑" : "↓") +
            Math.abs(v.value - v.old).toFixed(2);
          v.text = v.value == v.old ? "(--)" : text ? "(" + text + ")" : "";
        }
      });
    });
    // (this.moTreend_data as any).chinese.forEach((v) => {
    //   list.push({
    //     name: v,
    //     value: this.frameProblem[this.timeline].new[v],
    //     old: this.frameProblem[this.timeline].old[v],
    //   });
    // });
    // const top5Modules = list
    //   .sort((a, b) => b.value - a.value)

    //   .slice(0, 5);
    // console.log(top5Modules);

    // top5Modules.forEach((v) => {
    //   if (baseline.module) {
    //     if (v.value > baseline.module) {
    //       v.color = "red";
    //       // item.data.push({
    //       //   name: v.name,
    //       //   color: "red",
    //       //   new: String(v.value),
    //       //   baseline: baseline[this.type_moudle(v.type)],
    //       // });
    //     } else {
    //       v.color = "#303133";
    //     }
    //   } else {
    //     v.color = "#303133";
    //   }
    //   if (is_bad_risk) {
    //     if (threshold.module) {
    //       if (
    //         Math.abs(v.value - v.old) / v.old >
    //         threshold.module?.replace("%", "") / 100
    //       ) {
    //         v.color_new = v.value > v.old ? "red" : "#00b050";
    //         let text =
    //           (v.value > v.old ? "↑" : "↓") +
    //           Math.abs(v.value - v.old).toFixed(2);
    //         v.text = "(" + text + ")";
    //       } else {
    //         v.color_new = "#303133";
    //         let text =
    //           (v.value > v.old ? "↑" : "↓") +
    //           Math.abs(v.value - v.old).toFixed(2);
    //         v.text = v.value == v.old ? "(--)" : text ? "(" + text + ")" : "";
    //       }
    //     } else {
    //       v.color_new = "#303133";
    //       let text =
    //         (v.value > v.old ? "↑" : "↓") +
    //         Math.abs(v.value - v.old).toFixed(2);
    //       v.text = v.value == v.old ? "(--)" : text ? "(" + text + ")" : "";
    //     }
    //   } else {
    //     v.color_new = "#303133";
    //     let text =
    //       (v.value > v.old ? "↑" : "↓") + Math.abs(v.value - v.old).toFixed(2);
    //     v.text = v.value == v.old ? "(--)" : text ? "(" + text + ")" : "";
    //   }
    // });
    return list;
    //  this.frameProblem[timeLines]
  }
  public toggleCheckByName(obj, name) {
    if (obj.name && obj.name === name) {
      obj.check = !obj.check;
    }

    if (Array.isArray(obj.children)) {
      obj.children.forEach((child) => {
        this.toggleCheckByName(child, name);
      });
    }
  }
  public get custom_table() {
    return readGetdeepCpuCustomData(store).data;
  }
  public async look(row) {
    this.stackData_all.forEach((item) => {
      this.toggleCheckByName(item, row.name);
    });
    if (row.check) {
      this.tableList.forEach((v) => {
        if (v.name === row.name) {
          v.check = true;
        }
      });
      await dispatchDeepPerformanceTrendNode(store, {
        project: this.localProject,
        id_test: this.id_test,
        node_id: row.id,
      });
      this.series_list.push({
        name: row.name,
        type: "line",

        showSymbol: false,
        id: row.id,
        itemStyle: {
          normal: {
            lineStyle: {
              width: 1,
            },
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
        },
        yAxisIndex: 0,
        data: this.ratelist.map((item) => (item === null ? 0 : item)),
      });
    } else {
      this.tableList.forEach((v) => {
        if (v.name === row.name) {
          v.check = false;
        }
      });
      let target_index = this.series_list.findIndex((v) => v.name == row.name);
      this.series_list.splice(target_index, 1);
    }
    this.selectData(this.trendInex);
    this.drawAnalyseTrend();
  }
  public get historyData() {
    return readGetdeepCpuFuncTrend(store);
  }
  public recordSearch() {
    this.flame_thread.forEach((v) => {
      let obj = (this.stackData_obj as any).children.filter(
        (child) => child.name === v
      );

      this.$nextTick(() => {
        let newObj = {
          ...this.stackData_obj,
          children: obj,
        };
        this.renderFlame("#" + this.replaceSpacesWithHyphens(v), newObj);
      });
    });
  }
  public checkFlame() {
    this.flame_thread.forEach((v) => {
      let obj = (this.stackData_obj as any).children.filter(
        (child) => child.name === v
      );

      this.$nextTick(() => {
        let newObj = {
          ...this.stackData_obj,
          children: obj,
        };
        this.renderFlame("#" + this.replaceSpacesWithHyphens(v), newObj);
      });
    });

    //  let newObj = {
    //   ...this.stackData_obj,
    //   children: filteredChildren
    // };

    // this.renderFlame("#chart", newObj);
  }
  public get qf_inside() {
    return readGetdeepCpuUsageListQQ(store);
  }
  public get qf_module() {
    return readGetdeepCpuUsageListMouduleQQ(store);
  }
  public drawCpuInsideTrendQF() {
    let data = [];
    this.qf_inside.cpu.columns
      .filter((v) => v != "timeline")
      .forEach((v, index) => {
        data.push({
          name: v,
          type: "line",
          symbol: "circle", //拐点设置为实心，
          // smooth: true, // 平滑曲线
          data: this.qf_inside.cpu.rows[v],
          // itemStyle: {
          //   normal: {
          //     label: {
          //       // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
          //       show: true,
          //     },
          //   },
          // },
          yAxisIndex: v === "Freq MHz" ? 1 : 0,
        });
      });

    let yaxis = [
      {
        name: "",
        type: "value",
      },
      {
        type: "value",
        splitLine: {
          show: false,
        },
      },
    ];
    let performance_line: any = document.getElementById("cpu_inside");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      color: [
        "#5470c6",
        "#91cc75",
        "#fac858",
        "#ee6666",
        "#73c0de",
        "#3ba272",
        "#fc8452",
        "#935bab",
        "#d872bc",
        "black", // 新颜色1，橙色
        "pink",
      ],
      tooltip: {
        trigger: "axis",
        confine: true,
      },
      grid: {
        left: "4%",
        right: "4%",
        bottom:
          this.localProject == 34
            ? this.getMaxLabelHeight(this.qf_inside.cpu.rows.timeline) - 150
            : "25%",
        top: "10%",
        // containLabel: true,
      },
      // title: {
      //   left: "center",

      //   text: "日稳定包函数耗时趋势图(百分比)",
      // },
      dataZoom: [
        //给x轴设置滚动条
        {
          // end: 100 - 1500 / 31, //默认为100
          type: "slider",
          show: true,
          xAxisIndex: [0],
          // handleSize: 0, //滑动条的 左右2个滑动条的大小
          height: 14, //组件高度
          left: 30, //左边的距离
          right: 40, //右边的距离
          bottom: 40, //右边的距离
          handleColor: "#ddd", //h滑动图标的颜色
          handleStyle: {
            borderColor: "#cacaca",
            borderWidth: "1",
            shadowBlur: 2,
            background: "#ddd",
            shadowColor: "#ddd",
          },
          fillerColor: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
            {
              //给颜色设置渐变色 前面4个参数，给第一个设置1，第四个设置0 ，就是水平渐变
              //给第一个设置0，第四个设置1，就是垂直渐变
              offset: 0,
              color: "#1eb5e5",
            },
            {
              offset: 1,
              color: "#5ccbb1",
            },
          ]),
          backgroundColor: "#ddd", //两边未选中的滑动条区域的颜色
          showDataShadow: false, //是否显示数据阴影 默认auto
          showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
          handleIcon:
            "M-292,322.2c-3.2,0-6.4-0.6-9.3-1.9c-2.9-1.2-5.4-2.9-7.6-5.1s-3.9-4.8-5.1-7.6c-1.3-3-1.9-6.1-1.9-9.3c0-3.2,0.6-6.4,1.9-9.3c1.2-2.9,2.9-5.4,5.1-7.6s4.8-3.9,7.6-5.1c3-1.3,6.1-1.9,9.3-1.9c3.2,0,6.4,0.6,9.3,1.9c2.9,1.2,5.4,2.9,7.6,5.1s3.9,4.8,5.1,7.6c1.3,3,1.9,6.1,1.9,9.3c0,3.2-0.6,6.4-1.9,9.3c-1.2,2.9-2.9,5.4-5.1,7.6s-4.8,3.9-7.6,5.1C-285.6,321.5-288.8,322.2-292,322.2z",
          filterMode: "filter",
        },
        //下面这个属性是里面拖到
        {
          type: "inside",
          show: true,
          xAxisIndex: [0],
          disabled: true, // 禁用鼠标滚动缩放
          //  start: 0,//默认为1
          //  end: 100-1500/31,//默认为100
        },
      ],
      legend: {
        x: "center",
        y: "bottom",
        padding: [0, 0, 0, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: yaxis,

      animation: false,
      xAxis: {
        type: "category",
        data: this.qf_inside.cpu.rows.timeline,
      },

      series: data,
    });

    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    });
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = "cpu_inside" + "-" + ".png";
    res.chinese = "CPU局内趋势图";
    this.resBase64.push(res);
  }
  public drawCpuThreadByFrame() {
    let data = [];
    let xAxis = this.cpu_thread_by_frame.x;
    if (JSON.stringify(this.cpu_thread_by_frame) != "{}") {
      let lables = Object.keys(this.cpu_thread_by_frame.data[this.cpu_thread]);

      lables.forEach((v) => {
        data.push({
          name: v,
          type: "line",
          symbol: "circle", //拐点设置为实心
          data: this.cpu_thread_by_frame.data[this.cpu_thread][v],
        });
      });
    }
    // console.log(this.cpu_thread_by_frame,this.cpu_thread)

    // this.qf_inside.cpu.columns

    //   .forEach((v, index) => {
    //     data.push({
    //       name: v,
    //       type: "line",
    //       symbol: "circle", //拐点设置为实心，
    //       // smooth: true, // 平滑曲线
    //       data: this.qf_inside.cpu.rows[v],
    //       // itemStyle: {
    //       //   normal: {
    //       //     label: {
    //       //       // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
    //       //       show: true,
    //       //     },
    //       //   },
    //       // },

    //     });
    //   });

    let yaxis = [
      {
        name: "%",
        type: "value",
      },
    ];
    let performance_line: any = document.getElementById("cpu_thread");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
        confine: true,
      },
      grid: {
        left: "4%",
        right: "4%",
        top: "10%",
        bottom: "30%",
      },
      legend: {
        bottom: 0,
        left: "center",

        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      // title: {
      //   left: "center",

      //   text: "日稳定包函数耗时趋势图(百分比)",
      // },
      dataZoom: [
        //给x轴设置滚动条
        {
          // end: 100 - 1500 / 31, //默认为100
          type: "slider",
          show: true,
          xAxisIndex: [0],
          // handleSize: 0, //滑动条的 左右2个滑动条的大小
          height: 14, //组件高度
          left: 30, //左边的距离
          right: 40, //右边的距离
          bottom: 60, //右边的距离
          handleColor: "#ddd", //h滑动图标的颜色
          handleStyle: {
            borderColor: "#cacaca",
            borderWidth: "1",
            shadowBlur: 2,
            background: "#ddd",
            shadowColor: "#ddd",
          },
          fillerColor: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
            {
              //给颜色设置渐变色 前面4个参数，给第一个设置1，第四个设置0 ，就是水平渐变
              //给第一个设置0，第四个设置1，就是垂直渐变
              offset: 0,
              color: "#1eb5e5",
            },
            {
              offset: 1,
              color: "#5ccbb1",
            },
          ]),
          backgroundColor: "#ddd", //两边未选中的滑动条区域的颜色
          showDataShadow: false, //是否显示数据阴影 默认auto
          showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
          handleIcon:
            "M-292,322.2c-3.2,0-6.4-0.6-9.3-1.9c-2.9-1.2-5.4-2.9-7.6-5.1s-3.9-4.8-5.1-7.6c-1.3-3-1.9-6.1-1.9-9.3c0-3.2,0.6-6.4,1.9-9.3c1.2-2.9,2.9-5.4,5.1-7.6s4.8-3.9,7.6-5.1c3-1.3,6.1-1.9,9.3-1.9c3.2,0,6.4,0.6,9.3,1.9c2.9,1.2,5.4,2.9,7.6,5.1s3.9,4.8,5.1,7.6c1.3,3,1.9,6.1,1.9,9.3c0,3.2-0.6,6.4-1.9,9.3c-1.2,2.9-2.9,5.4-5.1,7.6s-4.8,3.9-7.6,5.1C-285.6,321.5-288.8,322.2-292,322.2z",
          filterMode: "filter",
        },
        //下面这个属性是里面拖到
        {
          type: "inside",
          show: true,
          xAxisIndex: [0],
          disabled: true, // 禁用鼠标滚动缩放
          //  start: 0,//默认为1
          //  end: 100-1500/31,//默认为100
        },
      ],

      yAxis: yaxis,

      animation: false,
      xAxis: {
        type: "category",
        data: xAxis,
        //  axisLabel:
        //   {
        //         formatter: function (value) {
        //           return value?.split("").join("\n");
        //         },
        //       },
      },

      series: data,
    });
    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    });
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = "cpu_thread_by_frame" + this.cpu_thread + ".png";
    res.chinese = "CPU线程占比局内趋势";
    this.resBase64.push(res);
  }
  public drawHistory() {
    let performance_line: any = document.getElementById("history_trend");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
        confine: true,
      },
      // title: {
      //   left: "center",

      //   text: "日稳定包函数耗时趋势图(百分比)",
      // },
      legend: {
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        name: "ms",
        //  nameLocation: "top",
        // 坐标轴名称与轴线之间的距离。
        // nameGap: 35,
        // nameRotate: 90,
        axisTick: false,
        //左侧线
        // axisLine: {
        //   show: true,
        // },
        //  splitLine: {
        //   show: true,
        // },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "15%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: this.historyData.date_list,
      },

      series: {
        name: this.historyData.func_name,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: this.historyData.value[0],
      },
    });
  }
  public historyShow = false;
  public async view_trend(name, thread) {
    this.historyShow = true;
    await dispatcDeepPerformanceCpufuncTrend(store, {
      project: this.localProject,
      name: name,
      is_auto: this.auto_query,
      type: this.type_query,
      subtype: this.subtype_query,
      device_id: this.dataConsumeOptions.device,
      scene_id: this.dataConsumeOptions.scene,
      thread: thread,
    });
    this.drawHistory();
  }
  public get device_options() {
    return readGeCpuDeviceOptions(store).data;
  }
  public async cpu_thead_change() {
    if (this.cpu_thread_activeName == "first_cpu_thread") {
      this.drawCpu_cpu_thread_iteration();
    }
    if (this.cpu_thread_activeName == "second_cpu_thread") {
      this.cpu_thread_list_head();
      this.cpu_thread_list_data();
      if (this.thrad_list_data.map((v) => v.label_name).length <= 2) {
        await dispatchDeepPerformanceCputhreadByFrame(store, {
          project: this.localProject,
          id_test: this.id_test,
        });
        if (this.cpu_thread_activeName == "second_cpu_thread") {
          this.drawCpuThreadByFrame();
        }
      } else {
        this.cpu_thread_data_2_series = this.thrad_list_data.map(
          (v) => v.label_name
        );
        this.cpu_thread_data_2_data = [];
        this.thrad_list_head.forEach((v) => {
          this.cpu_thread_data_2_data.push({
            name: v,
            type: "line",
            smooth: true, // 平滑曲线
            itemStyle: {
              normal: {
                label: {
                  // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
                  show: true,
                },
              },
            },
            symbol: "circle", //拐点设置为实心
            data: this.thrad_list_data.map((x) => x.new[v]),
          });
        });
        this.drawCpu_cpu_thread_inside_2();
      }
    }
    if (this.cpu_thread_activeName == "third_cpu_thread") {
      this.cpu_thread_list_head();
      this.cpu_thread_list_data();
    }
  }
  public async serchChange() {
    this.currentPage = 1;
    this.input_list = this.tableList.filter((v) => {
      return v.name.toUpperCase().includes(this.serch.toUpperCase());
    });

    this.total = this.input_list.length;
    this.tableList_new = this.input_list.slice(
      (this.currentPage - 1) * 10,
      this.currentPage * 10
    );
  }
  public get ratelist() {
    return readGetdeepTrendNode(store);
  }
  public updateCheckById(obj, name, value) {
    if (obj.name && obj.name === name) {
      obj.check = value;
    }

    if (Array.isArray(obj.children)) {
      obj.children.forEach((child) => {
        this.updateCheckById(child, name, value);
      });
    }
  }
  public async checkChange(item, id, name, thread) {
    this.stackData_all.some((v) => this.updateCheckById(v, name, item));

    // (this.$refs.table as any).toggleRowExpansion(this.stackData_all[0], true);

    await dispatchDeepPerformanceTrendNode(store, {
      project: this.localProject,
      id_test: this.id_test,
      node_id: id,
    });
    if (item) {
      this.series_list.push({
        name: name,
        type: "line",

        showSymbol: false,
        id: id,
        itemStyle: {
          normal: {
            lineStyle: {
              width: 1,
            },
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
        },
        yAxisIndex: 0,
        data: this.ratelist.map((item) => (item === null ? 0 : item)),
      });
    } else {
      let target_index = this.series_list.findIndex((v) => v.name == name);
      this.series_list.splice(target_index, 1);
    }
    // // this.tree_func()
    this.selectData(this.trendInex);
    this.drawAnalyseTrend();
  }
  public inputValue = "";
  public searchByName(obj, query, result, path = []) {
    if (obj.name && obj.name.includes(query)) {
      const reversedPath = [...path, obj].reverse();
      reversedPath.forEach((item) => {
        const newItem = { ...item };
        delete newItem.children;
        result.push(newItem);
      });
    }

    if (Array.isArray(obj.children)) {
      obj.children.forEach((child) => {
        this.searchByName(child, query, result, [...path, obj]);
      });
    }
  }
  public async close1(arr, state) {
    arr.forEach((v) => {
      (this.$refs.table as any).toggleRowExpansion(v, state);
      if (document.getElementById(v?.id) != null) {
        document.getElementById(v?.id).style.color = "#fff";
      }
      if (v.children) {
        //  回调函数 重复关闭
        this.close1(v.children, state);
      }
    });
    this.isExpand = false;
  }
  public isExpand = false;
  public async serchChange_enter() {
    this.currentPage = 1;
    let list = this.tableList.filter((v) => {
      return v.name.toUpperCase().includes(this.serch.toUpperCase());
    });

    this.total = list.length;
    this.tableList_new = list.slice(
      (this.currentPage - 1) * 10,
      this.currentPage * 10
    );
    if (this.inputValue) {
      let result = [];
      this.stackData_all.forEach((item) => {
        this.searchByName(item, this.inputValue, result);
      });
      this.close1(this.stackData_all, false);

      await result.forEach((v) => {
        (this.$refs.table as any).toggleRowExpansion(v, true);
      });
      let c = result.filter((v) => v.name.includes(this.inputValue));
      c.forEach((v, index) => {
        if (document.getElementById(v.id) != null) {
          document.getElementById(v.id).style.color = "orange";
          if (index == 0) {
            //                    const parentEl = document.getElementById(v.id).parentElement;
            // parentEl.style.overflow = 'visible'
            document.getElementById(v.id).scrollIntoView();
          }
        }
      });
    } else {
      this.close1(this.stackData_all, false);
    }
  }
  public getTop10(data) {
    const result = [];
    if (data.value) {
      result.push({
        thread: data.thread,
        name: data.name,
        time: data.value,
        rate: data.rate,
        old_value: 0,

        difference: 0 - data.value,
        average_value: 0,
        id: data.id,
      });
    }
    if (data.children && data.children.length > 0) {
      data.children.forEach((item) => {
        result.push(...this.getTop10(item));
      });
    }
    result.sort((a, b) => b.time - a.time);
    return result;
  }
  public get func_list() {
    return readGetdeepfuncList(store);
  }
  public ms(i, data) {
    let avg_ms = "";
    let ms = "";

    if (i.filter((v) => v.name == data)[0]) {
      avg_ms = i.filter((v) => v.name == data)[0].average_value + "(ms)";
      ms = i.filter((v) => v.name == data)[0].old_value + "(ms)";
    } else {
      avg_ms = 0 + "(ms)";
      ms = 0 + "(ms)";
    }
    return [avg_ms, ms];
  }
  public table_func() {
    this.tableList = this.getTop10(this.stackData_obj).slice(1);

    this.tableList.forEach((v) => {
      let found = false;
      this.series_list.forEach((item) => {
        if (
          Array.isArray(item.id)
            ? item.id.filter((x) => x == v.id).length > 0
            : item.id == v.id
        ) {
          v.check = true;
          found = true;
          return false; // 跳出循环
        }
        if (!found) {
          v.check = false;
        }
      });
    });

    let names = this.tableList.map((item) => item.id);
    const result = Object.entries(this.func_list).filter(
      ([key, value]) => !names.includes(key)
    );

    // 将结果转换为对象
    const filteredObj: any = Object.fromEntries(result);

    for (let i in this.func_list) {
      this.tableList.forEach((v) => {
        if (v.id === i) {
          v.thread = this.func_list[i].thread;
          v.average_value = this.func_list[i].value;
          v.old_value = this.func_list[i].old_value;
          v.difference = this.func_list[i].diff_value;
        }
      });
    }

    for (let i in filteredObj) {
      if (filteredObj[i].name != "FrameTime") {
        this.tableList.push({
          name: filteredObj[i].name,
          thread: filteredObj[i].thread,
          id: i,
          time: 0,
          rate: 0,
          average_value: filteredObj[i].value,
          old_value: filteredObj[i].old_value,
          difference: filteredObj[i].diff_value,
          check: false,
        });
      }
    }
    this.currentPage = 1;
    //  console.log(this.tableList,'表格合并数据查询')
    for (let i = 0; i < this.tableList.length; i++) {
      for (let j = i + 1; j < this.tableList.length; j++) {
        if (
          this.tableList[i].name === this.tableList[j].name &&
          this.tableList[i].thread === this.tableList[j].thread
        ) {
          this.tableList[i].time += this.tableList[j].time;
          this.tableList[i].rate += this.tableList[j].rate;
          this.tableList[i].old_value += this.tableList[j].old_value;
          this.tableList[i].average_value += this.tableList[j].average_value;
          // Merge ids into an array
          if (!Array.isArray(this.tableList[i].id)) {
            this.tableList[i].id = [this.tableList[i].id];
          }
          this.tableList[i].id.push(this.tableList[j].id);
          this.tableList.splice(j, 1);
          j--; // Decrement j to account for the removed element
        }
      }
    } //业务需求相同的线程name进行合并 id进行合并为数组

    this.tableList.forEach((v) => {
      v.time = v.time.toFixed(2);
      v.rate = v.rate.toFixed(2);
      v.average_value = v.average_value.toFixed(4);
      v.old_value =
        typeof v.old_value === "undefined" || isNaN(v.old_value)
          ? "0"
          : v.old_value % 1 === 0
          ? v.old_value
          : v.old_value.toFixed(4);
      v.difference = (v.average_value - v.old_value).toFixed(4);
    });
    this.tableList = this.tableList.filter((item) => item.name !== "others"); //业务需求过滤掉others函数
    this.tableList_new = this.tableList.slice(
      (this.currentPage - 1) * 10,
      this.currentPage * 10
    );
    this.total = this.tableList.length;
    this.serch = "";
  }
  public handleCurrentChange(val) {
    this.currentPage = val;
    if (this.serch != "") {
      this.tableList_new = this.input_list.slice(
        (this.currentPage - 1) * 10,
        this.currentPage * 10
      );
    } else {
      this.tableList_new = this.tableList.slice(
        (this.currentPage - 1) * 10,
        this.currentPage * 10
      );
    }
  }
  public tableList_new = [];
  public tableList = [];
  public serch = "";
  public currentPage = 1;
  public total = 1;
  public input_list = [];
  public sortFun(attr, rev) {
    if (rev == undefined) {
      rev = 1;
    } else {
      rev = rev ? 1 : -1;
    }
    return (a, b) => {
      a = a[attr];
      b = b[attr];

      return this.customSort(a, b, rev);
    };
  }
  public customSort(a, b, rev) {
    if (a === undefined || a === "-") {
      return rev === 1 ? 1 : -1;
    } else if (b === undefined || b === "-") {
      return rev === 1 ? -1 : 1;
    } else {
      return (a - b) * rev;
    }
  }
  public sort_change(column) {
    let form: any = {};

    this.currentPage = 1;

    if (this.serch != "") {
      this.input_list.sort(
        this.sortFun(column?.prop, column?.order === "ascending")
      );
      this.tableList_new = this.input_list.slice(
        (this.currentPage - 1) * 10,
        this.currentPage * 10
      );
      this.total = this.input_list.length;
    } else {
      this.tableList.sort(
        this.sortFun(column?.prop, column?.order === "ascending")
      );

      this.tableList_new = this.tableList.slice(0, 10);
    }
  }
  public get scene_options() {
    return readGeCpuSceneOptions(store).data;
  }
  public handleNodeClick(data) {
    if (!data.children) {
      if (data.label == "测试概况") {
        const targetElement = document.querySelector("#report_scroll");
        targetElement.scrollIntoView();
      }
      if (data.label == "FPS") {
        const targetElement = document.querySelector("#fps_scroll");
        targetElement.scrollIntoView();
      }

      if (data.label == "CPU性能") {
        const targetElement = document.querySelector("#cpu_scroll");
        targetElement.scrollIntoView();
      }
      if (data.label == "GPU性能") {
        const targetElement = document.querySelector("#gpu_scroll");
        targetElement.scrollIntoView();
      }
      if (data.label == "线程耗时") {
        const targetElement = document.querySelector("#thread_scroll");
        targetElement.scrollIntoView();
      }
      if (data.label == "模块函数耗时") {
        const targetElement = document.querySelector("#func_scroll");
        targetElement.scrollIntoView();
      }
      if (data.label == "函数耗时堆栈") {
        const targetElement = document.querySelector("#ms_scroll");
        targetElement.scrollIntoView();
      }
    }
  }
  public get treeData() {
    let list = [];
    list = [
      {
        label: "CPU性能分析报告",
        children: [
          {
            label: "测试概况",
          },

          {
            label: "FPS",
          },
          {
            label: "CPU性能",
          },
          {
            label: "GPU性能",
          },
          {
            label: "线程耗时",
          },
          {
            label: "模块函数耗时",
          },
          {
            label: "函数耗时堆栈",
          },
        ],
      },
    ];

    return list;
  }
  public auto_query: any = [];
  public auto_data = [
    { id: 2, label: "自动", check: false },
    { id: 0, label: "手动", check: false },
  ];
  public framesInfo_all = {
    framesCount: 0,
    sumTime: 0,
    FPS: 0,
    frameTime: 0,
  };
  getThreshold(config, basic, scene) {
    // 获取场景的阈值配置

    var sceneConfig = config[scene];

    // 如果没有场景配置，则获取全局配置
    var currentConfig = sceneConfig ? sceneConfig : config["All"] || {};

    // 获取平台阈值，如果没有平台配置，则获取全平台配置
    var platformConfig = currentConfig[basic.platform];

    currentConfig = platformConfig
      ? platformConfig
      : currentConfig["All"] || {};

    // 是否存在风险
    var isBadRisk = currentConfig["is_bad_risk"] || false;
    // var enable_threshold = currentConfig["enable_threshold"] || false;
    // var enable_baseline = currentConfig["enable_baseline"] || false;

    // 基线
    var baseline = {};

    if (currentConfig["enable_baseline"] || false) {
      var baselines = currentConfig["baseline"] || {};

      baseline = this.getBaselineForLevel(baselines, basic["level"]);
    }

    // 阈值
    var threshold = {};
    if (!isBadRisk && (currentConfig["enable_threshold"] || false)) {
      var thresholds = currentConfig["threshold"] || {};
      threshold = this.getBaselineForLevel(thresholds, basic["level"]);
    }

    var result = {
      baseline: baseline,
      threshold: threshold,
      is_bad_risk: isBadRisk,
    };

    return result;
  }
  public configChange() {
    this.configuration_table(
      this.configuration_form.scene_id,
      this.configuration_form.moudle
    );
  }

  public fpl_lt_name(data) {
    // console.log(this.cpu_set_up.config)
    // console.log(this.report_data_list)
    // console.log(this.cpu_set_up.config, "最终数据");
    if (this.cpu_set_up.config) {
      let baselineList = this.getThreshold(
        this.removeEmptyParentObjects(this.cpu_set_up.config),
        this.report_data_list,
        this.configuration_form.scene_id
      ).baseline;
      //  console.log(baselineList)
      let name_lt = "";
      let fpl_lt = Object.keys(baselineList);
      // console.log(baselineList);
      if (fpl_lt.length != 0) {
        if (fpl_lt.some((item) => item.includes("低帧"))) {
          name_lt = fpl_lt[fpl_lt.findIndex((item) => item.includes("低帧"))];
        }
        if (data == "低帧(<25)占比") {
          if (name_lt) {
            return name_lt;
          } else {
            return "低帧(<25)占比";
          }
        } else if (data == "删除") {
          return "";
        } else {
          // console.log(data, "监听");
          return data;
        }
      } else {
        if (data == "删除") {
          return "";
        } else {
          return data;
        }
      }
    } else {
      // console.log(data, "监听1");
      if (data == "删除") {
        return "";
      } else {
        return data;
      }
    }
  }
  public editorOption = {
    theme: "snow", // 主题
    // debug: 'info',
    placeholder: "请输入其他说明",
    modules: {
      toolbar: {
        container: [
          ["bold", "italic", "underline", "strike"],
          // ["blockquote",],
          [{ header: 1 }, { header: 2 }],

          [{ script: "sub" }, { script: "super" }],

          [{ size: ["small", false, "large", "huge"] }],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ color: [] }, { background: [] }],

          ["link"],

          // ["clean", "link", "image"]
          // ['addBtn']
        ], // 自定义工具栏选项
      },
    },
  };
  public fps_rate = "低帧(<25)占比";
  public fps_lt_params() {
    let baselineList = this.getThreshold(
      this.removeEmptyParentObjects(this.cpu_set_up.config),
      this.report_data_list,
      this.configuration_form.scene_id
    ).baseline;
    let name_lt = "";

    let fpl_lt = Object.keys(baselineList);

    if (fpl_lt.length != 0) {
      if (fpl_lt.some((item) => item.includes("低帧"))) {
        name_lt = fpl_lt[fpl_lt.findIndex((item) => item.includes("低帧"))];
      }
    }
    if (name_lt) {
      this.fps_rate = name_lt;
      this.params[5].name = name_lt;
      this.params[5].value = name_lt;
    }
  }
  public message_error = [];
  public configuration_table(scene, moudle) {
    let list = [];
    this.configuration_table_baseline = [];
    this.gear_position_all = [];
    this.configuration_table_threshold = [];
    this.gear_position_all = [];
    this.gear_position_all_threshold = [];

    for (let i in this.configuration_name) {
      // console.log(i, "指标进入");
      list.push({ name: this.fpl_lt_name(i), baseline: [], threshold: [] });
    }

    if (this.cpu_set_up.config) {
      console.log("");
    } else {
      this.cpu_set_up.config = {};
      this.scene_options_old_table.forEach((v) => {
        this.cpu_set_up.config[v.scene_id] = {};
        this.moudle.forEach((n) => {
          this.cpu_set_up.config[v.scene_id][n] = {};
          //   is_bad_risk: false,
          //   enable_threshold: false,
          //   enable_baseline: false,
          //   baseline: {
          //     "0,1": {
          //       avg_fps: 25,
          //     },
          //     "2,3": {
          //       avg_fps: 15,
          //     },
          //   },
          //   threshold: {
          //     All: {
          //       avg_fps: "10%",
          //     },
          //   },
          // };
        });
      });
    }

    if (JSON.stringify(this.cpu_set_up.config[scene][moudle]) == "{}") {
      this.configuration_obj = {
        is_bad_risk: false,
        enable_threshold: true,
        enable_baseline: false,
        baseline: {
          "0,1": {
            avg_fps: 25,
            var_fps: 25,
            jank: "",
            big_jank: "",
            lag_pcnt: "",
            fps_lt_25_pcnt: "",
            avg_cpu: 80,
            avg_cpu_total: 90,
            core_cpu: 90,
            avg_cpu_freq: "",
            frame_time: 40,
            thread: "",
            module: "",
            gpu_usage: 90,
            gpu_bus_busy: "",
            shaders_busy: "",
            vertices_shaded: "",
            fragments_shaded: "",
            read_total: "",
            write_total: "",
            GClock: "",
          },
          "2,3": {
            avg_fps: 15,
          },
        },
        threshold: {
          All: {
            avg_fps: "10%",
            var_fps: "10%",
            jank: "10%",
            big_jank: "10%",
            lag_pcnt: "10%",
            fps_lt_25_pcnt: "10%",
            avg_cpu: "10%",
            avg_cpu_total: "10%",
            core_cpu: "10%",
            avg_cpu_freq: "10%",
            frame_time: "10%",
            thread: "10%",
            module: "10%",
            gpu_usage: "10%",
            gpu_bus_busy: "10%",
            shaders_busy: "10%",
            vertices_shaded: "10%",
            fragments_shaded: "10%",
            read_total: "10%",
            write_total: "10%",
            GClock: "10%",
          },
        },
      };
    } else {
      this.configuration_obj = JSON.parse(
        JSON.stringify(this.cpu_set_up.config[scene][moudle])
      );
    }

    list.forEach((v) => {
      for (let i in this.configuration_obj.baseline) {
        if (this.configuration_obj.baseline[i][v.name]) {
          v.baseline.push(this.configuration_obj.baseline[i][v.name]);
        } else {
          if (v.name == "") {
            v.baseline.push("删除");
          } else {
            v.baseline.push(
              v.name?.indexOf("低帧") != -1
                ? this.indicator_default.fps_lt_25_pcnt.baseline
                : ""
            );
          }
        }
      }

      for (let i in this.configuration_obj.threshold) {
        if (this.configuration_obj.threshold[i][v.name]) {
          v.threshold.push(this.configuration_obj.threshold[i][v.name]);
        } else {
          if (v.name == "") {
            v.threshold.push("删除");
          } else {
            v.threshold.push(
              v.name?.indexOf("低帧") != -1
                ? this.indicator_default.fps_lt_25_pcnt.threshold
                : ""
            );
          }
        }
      }
    });

    for (let i in this.configuration_obj.baseline) {
      this.configuration_table_baseline.push({ name: i, value: i.split(",") });
      this.gear_position_all.push(
        JSON.parse(JSON.stringify(this.gear_position))
      );
    }
    for (let i in this.configuration_obj.threshold) {
      this.configuration_table_threshold.push({ name: i, value: i.split(",") });
      this.gear_position_all_threshold.push(
        JSON.parse(JSON.stringify(this.gear_position))
      );
    }
    this.configuration_table_data = list;

    this.is_bad_risk = this.configuration_obj.is_bad_risk;
    this.baseline_check = this.configuration_obj.enable_baseline;
    this.threshold_check = this.configuration_obj.enable_threshold;

    // this.cpu_set_up.CPUConfig[this.configuration_form.scene_id][this.configuration_form.moudle].baseline
    // return list
  }
  public determine(data, value, i) {
    let list = [];
    data.forEach((v, index) => {
      if (index !== i) {
        list.push(v.value);
      }
    });

    value[i]?.forEach((item) => {
      if (list.flat().includes(item.value)) {
        item.disabled = true;
      } else {
        item.disabled = false;
      }
    });
    if (list.length == 0) {
      value[i].forEach((item) => {
        item.disabled = false;
      });
    }

    return value[i];
  }
  public async save_button() {
    let obj = this.cpu_set_up.config;

    this.configurationShow = false;
    this.fps_loading = true;
    this.cpu_loading = true;
    this.gpu_loading = true;
    this.thread_loading = true;
    this.moudle_loading = true;
    this.test_loading = true;
    let b = (this as any).$message({
      //Message 消息提示
      message: "阈值配置中",
      showClose: true,
      duration: 0,
    });
    let baseline = {};
    let threshold = {};
    // console.log(this.configuration_table_data)
    this.configuration_table_baseline.forEach((v, index) => {
      baseline[v.value.join(",")] = {};
      // console.log(this.configuration_table_data)
      this.configuration_table_data.forEach((item) => {
        baseline[v.value.join(",")][item.name] = item.baseline[index];
      });
      // for (let i in this.indicator_default) {
      //   console.log(i)
      //      baseline[v.value.join(",")][i] = this.configuration_table_data.filter(
      //     (x) => x.name == i
      //   )[0].baseline[index];

      // }
    });
    this.configuration_table_threshold.forEach((v, index) => {
      threshold[v.value.join(",")] = {};

      this.configuration_table_data.forEach((item) => {
        threshold[v.value.join(",")][item.name] = item.threshold[index];
      });
      //      threshold[v.value.join(",")][i] = this.configuration_table_data.filter(
      //   (x) => x.name == i
      // )[0].threshold[index];
    });

    obj[this.configuration_form.scene_id][
      this.configuration_form.moudle
    ].is_bad_risk = this.is_bad_risk;
    obj[this.configuration_form.scene_id][
      this.configuration_form.moudle
    ].enable_baseline = this.baseline_check;
    obj[this.configuration_form.scene_id][
      this.configuration_form.moudle
    ].enable_threshold = this.threshold_check;
    obj[this.configuration_form.scene_id][
      this.configuration_form.moudle
    ].baseline = baseline;
    obj[this.configuration_form.scene_id][
      this.configuration_form.moudle
    ].threshold = threshold;
    let old_test = this.versionsOldOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.old_verson
    )[0].id_test;

    // this.cpu_set_up.config=this.removeEmptyParentObjects(this.cpu_set_up.config)
    // console.log(this.cpu_set_up)
    // delete this.cpu_set_up.config;

    this.fps_lt_params();
    await dispatchDeepPerformanceCpuPutDetail(store, {
      project: this.localProject,
      id_test: this.id_test,
      settings: JSON.stringify(this.cpu_set_up),
      old_test: old_test,
      label: "All",
    });
    b.close();
    ElMessage.success({
      message: "配置成功",
      showClose: true,
      type: "success",
    });
    this.fps_loading = false;
    this.cpu_loading = false;
    this.gpu_loading = false;
    this.thread_loading = false;
    this.moudle_loading = false;
    // if (this.localProject == 7) {
    //   await dispatchDeepPerformanceCpuCustomData(store, {
    //     project: this.localProject,

    //     id_test: this.id_test,
    //     old_test: old_test,
    //   });
    // }
    this.cpu_index = "AppCPU";

    await this.fps_detail_creat();
    this.cpuPerfTrend_creat();
    this.gpu_inside_api();

    this.cpu_tabs_detail_show = true;
    this.thread_tabs_detail_show = true;
    this.moudel_tabs_detail_show = true;

    this.test_loading = false;
  }
  public baseline_check = false;
  public threshold_check = true;
  public gear_position_all = [];
  public gear_position = [
    { name: "All", value: "All", background: "#FF02", disabled: false },
    { name: "超高", value: "0", background: "#FF0000", disabled: false },
    { name: "高", value: "1", background: "#FF7F7F", disabled: false },
    { name: "中", value: "2", background: "orange", disabled: false },
    { name: "低", value: "3", background: "#008000", disabled: false },
    { name: "超低", value: "4", background: "#90EE90", disabled: false },
  ];
  public gear_position_all_threshold = [];
  public baseLine_chinese(item) {
    const ary = item.split(",");
  }
  public get delete_text() {
    return readUserProfile(store)?.username;
  }
  public async delete_btn_text() {
    let old_test = this.versionsOldOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.old_verson
    )[0].id_test;

    await dispatchDeepPerformanceCpuReportText(store, {
      project: this.localProject,
      id_test: this.id_test,
      old_test: old_test,
      risk: this.risk,
      text: "",
    });

    let text = { core: [], important: [], options: {}, options_list_name: [] };
    this.table_test_overview = text.core;
    this.table_test_overview_important = text.important;
    this.options_list = text.options;
    this.options_list_name = text.options_list_name;
    this.com_color_risk();
    this.importanta_data();
  }
  getBaselineForLevel(baselines, level) {
    // 获取对应档位的基线
    for (const key in baselines) {
      const baseline = baselines[key];
      const levels = key.split(",");

      if (levels.includes(String(level))) {
        return baseline;
      }
    }

    return baselines["All"] || {};
  }
  public obj(data) {
    return JSON.stringify(data) != "{}";
  }
  //   public getThreshold(config, basic) {
  //   // 获取场景的阈值配置
  //   console.log(config,basic)
  //   let baseline={}
  //   let threshold={}
  //   var sceneConfig = config[basic.scene_id];

  //     var currentConfig = sceneConfig ? sceneConfig : config['All'] || {};
  //     if(this.obj(config[basic.scene_id][basic.platform])){
  //       if(config[basic.scene_id][basic.platform].enable_baseline==false){
  //         baseline={}
  //       }
  //       else{
  //         if(config[basic.scene_id][basic.platform].baseline[basic.level]){
  //           baseline=config[basic.scene_id][basic.platform].baseline[basic.level]
  //         }else{
  //           baseline={}
  //         }
  //       }
  //       if(config[basic.scene_id][basic.platform].enable_threshold==false){
  //         threshold={}
  //       }
  //       else{
  //         if(config[basic.scene_id][basic.platform].threshold[basic.level]){
  //           threshold=config[basic.scene_id][basic.platform].threshold[basic.level]
  //         }else{
  //           threshold={}
  //         }
  //       }

  //     }
  //     else{
  //       console.log(111)
  //       if(this.obj(config[basic.scene_id]['All'])){
  //           if(config[basic.scene_id]['All'].enable_baseline==false){
  //         baseline={}
  //       }else{
  //         if(config[basic.scene_id]['All'].baseline[basic.level]){
  //           baseline=config[basic.scene_id]['All'].baseline[basic.level]
  //         }else{
  //           baseline={}
  //         }
  //       }
  //       if(config[basic.scene_id]['All'].enable_threshold==false){
  //         threshold={}
  //       }
  //       else{
  //         if(config[basic.scene_id]['All'].threshold[basic.level]){
  //           threshold=config[basic.scene_id]['All'].threshold[basic.level]
  //         }else{
  //           threshold={}
  //         }
  //       }

  //       }else{
  //           console.log(111222)
  //         if(this.obj(config['All'][basic.platform])){
  //             if(config['All'][basic.platform].enable_baseline==false){
  //         baseline={}
  //       }else{
  //         if(config['All'][basic.platform].baseline[basic.level]){
  //           baseline=config['All'][basic.platform].baseline[basic.level]
  //         }else{
  //           baseline={}
  //         }
  //       }
  //        if(config['All'][basic.platform].enable_threshold==false){
  //         threshold={}
  //       }
  //       else{
  //         if(config['All'][basic.platform].threshold[basic.level]){
  //           threshold=config['All'][basic.platform].threshold[basic.level]
  //         }else{
  //           threshold={}
  //         }
  //       }

  //         }else{
  //                  console.log(11122232322)
  //            if(this.obj(config['All']['All'])){
  //             if(config['All']['All'].enable_baseline==false){
  //         baseline={}
  //       }else{
  //         if(config['All']['All'].baseline[basic.level]){
  //           baseline=config['All']['All'].baseline[basic.level]
  //         }else{
  //           baseline={}
  //         }
  //          if(config['All']['All'].enable_threshold==false){
  //         threshold={}
  //       }
  //       else{
  //         if(config['All']['All'].threshold[basic.level]){
  //           threshold=config['All']['All'].threshold[basic.level]
  //         }else{
  //           threshold={}
  //         }
  //       }
  //       }

  //         }
  //         }
  //       }
  //     }
  //   // // 如果没有场景配置，则获取全局配置
  //   // var currentConfig = sceneConfig ? sceneConfig : config['All'] || {};
  //   //  console.log(currentConfig)

  //   // // 获取平台阈值，如果没有平台配置，则获取全平台配置
  //   // var platformConfig = currentConfig[basic.platform];
  //   // currentConfig = platformConfig ? platformConfig : currentConfig['All'] || {};
  //   //    console.log(currentConfig)

  //   // // 是否存在风险
  //   // var isBadRisk = currentConfig['is_bad_risk'] || false;

  //   // // 基线
  //   // var baseline = {};
  //   // console.log(currentConfig)
  //   // if (currentConfig['enable_baseline'] || false) {
  //   //   var baselines = currentConfig['baseline'] || {};
  //   //   baseline = this.getBaselineForLevel(baselines, basic['level']);
  //   // }

  //   // // 阈值
  //   // var threshold = {};
  //   // if (!isBadRisk && (currentConfig['enable_threshold'] || false)) {
  //   //   var thresholds = currentConfig['threshold'] || {};
  //   //   threshold = this.getBaselineForLevel(thresholds, basic['level']);
  //   // }

  //   var result = {
  //     'baseline': baseline,
  //     'threshold': threshold,
  //     // 'is_bad_risk': isBadRisk
  //   };
  //   // console.log(result)
  //   console.log(result)
  //   return result;
  // }
  public configuration_obj: any = {};
  public selectShow = true;
  public overall() {
    let frameTimeList = this.cpu_by_frame.series[0].slice(
      0,
      this.cpu_by_frame.series[0].length
    );
    this.framesInfo_all.framesCount = frameTimeList.length;
    (this.framesInfo_all.sumTime as any) = this.calculateSum(
      frameTimeList
    ).toFixed(2);
    let frameTime = this.calculateAverage(frameTimeList);

    (this.framesInfo_all.FPS as any) = (1000 / frameTime).toFixed(2);
    (this.framesInfo_all.frameTime as any) = frameTime.toFixed(2);
  }
  public get function_list_data() {
    return readGetdeepCpuFunction(store).data;
  }
  public depth(num) {
    return num * 10;
  }
  public getName(item, i) {
    if (item.indexOf("_") != -1) {
      return item.split("_")[1].split("-")[0];
    } else {
      return item.split("-")[0];
    }
  }
  public htmlCanvas_problem(item) {
    var getPixelRatio = (context) => {
      // 获取设备的PixelRatio
      var backingStore =
        context.backingStorePixelRatio ||
        context.webkitBackingStorePixelRatio ||
        context.mozBackingStorePixelRatio ||
        context.msBackingStorePixelRatio ||
        context.oBackingStorePixelRatio ||
        context.backingStorePixelRatio ||
        0.5;
      // this.b = (this as any).$message({
      //   //Message 消息提示
      //   message: "报告发送中...",
      //   showClose: true,
      //   duration: 0,
      // });
      return (window.devicePixelRatio || 0.5) / backingStore;
    };
    let shareContent: any = "";

    if (item === "func_trend") {
      shareContent = document.getElementById("func_trend");
    } else if (item == "problem_trend") {
      shareContent = document.getElementById("problem_trend");
    } else {
      // let b = window.frames["bdIframe"];
      // shareContent = b.document.getElementById("chart");
      // let b = window.frames["bdIframe"];
      shareContent = document.getElementById("chart");
      shareContent.style.fontSize = "12px";

      shareContent.style.whiteSpace = "nowrap";
      shareContent.style.textOverflow = "ellipsis";
      shareContent.style.overflow = "hidden";
      shareContent.style.fontFamily = "Verdana";
      shareContent.style.marginLeft = "4px";
      shareContent.style.marginRight = "4px";
      shareContent.style.lineHeight = "1.5";
    }

    // console.log(shareContent)
    var width = shareContent.offsetWidth;
    var height = shareContent.offsetHeight;
    var canvas = document.createElement("canvas");
    var context = canvas.getContext("2d");
    var scale = getPixelRatio(context); // 将canvas的容器扩大PixelRatio倍，再将画布缩放，将图像放大PixelRatio倍。
    canvas.width = width * scale;
    canvas.height = height * scale;
    canvas.style.width = width + "px";
    canvas.style.height = height + "px";
    context.scale(scale, scale);

    var opts = {
      scale: 1,
      canvas: canvas,
      dpi: window.devicePixelRatio,
      // 获取元素宽高 让其以一个规律或者固定宽高伸展
      width: (shareContent as any) + 400,
      height: (shareContent as any) + 500,
      // 将截图部分 移入中心位置
      scrollX: 200,
      scrollY: 250,
    };
    // 解决图片超出显示区后底色变成黑色的问题
    context.fillStyle = "#fff";

    context.fillRect(0, 0, canvas.width, canvas.height);
    var dataUrl = html2canvas(shareContent, opts).then(function (canvas) {
      context.imageSmoothingEnabled = false;
      (context as any).webkitImageSmoothingEnabled = false;
      (context as any).msImageSmoothingEnabled = false;
      context.imageSmoothingEnabled = false;
      return canvas.toDataURL("image/png", 1.0);
    });

    dataUrl.then((result) => {
      let res: any = {};
      res.file_base64 = result;
      res.filename = item + ".png";
      res.chinese = "测试概况";

      this.resBase64.push(res);
      if (this.localProject != 7) {
        this.htmlCanvas2("chart");
      } else {
        this.htmlCanvas1("tree");
      }

      //     let upload_data: any;
      // let old_test = this.versionsOldOptions.filter(
      //   (v) => v.chinese === this.dataConsumeOptions.old_verson
      // )[0].id_test;
      //     upload_data = {
      //   // project: Number(this.$route.query.project),
      //   project: this.localProject,
      //   id_test: Number(this.id_test),
      //   old_test: old_test,
      //   thread: this.trendOptions.thread,
      //   so:  this.trendOptions.so,
      //   file_list: this.resBase64,
      //   title: this.formMail.title,
      //   recv: this.formMail.addressee,
      //   cc: this.formMail.CC_List,

      //   send: this.formMail.Sender,
      // };
      //  dispatchUploadCpuReport(store, upload_data)
    });
  }
  public htmlCanvas(item) {
    var getPixelRatio = (context) => {
      // 获取设备的PixelRatio
      var backingStore =
        context.backingStorePixelRatio ||
        context.webkitBackingStorePixelRatio ||
        context.mozBackingStorePixelRatio ||
        context.msBackingStorePixelRatio ||
        context.oBackingStorePixelRatio ||
        context.backingStorePixelRatio ||
        0.5;
      // this.b = (this as any).$message({
      //   //Message 消息提示
      //   message: "报告发送中...",
      //   showClose: true,
      //   duration: 0,
      // });
      return (window.devicePixelRatio || 0.5) / backingStore;
    };
    let shareContent: any = "";

    if (item === "func_trend") {
      shareContent = document.getElementById("func_trend");
    } else if (item == "problem_trend") {
      shareContent = document.getElementById("problem_trend");
    } else {
      // let b = window.frames["bdIframe"];
      // shareContent = b.document.getElementById("chart");
      // let b = window.frames["bdIframe"];
      shareContent = document.getElementById("chart");
      shareContent.style.fontSize = "12px";

      shareContent.style.whiteSpace = "nowrap";
      shareContent.style.textOverflow = "ellipsis";
      shareContent.style.overflow = "hidden";
      shareContent.style.fontFamily = "Verdana";
      shareContent.style.marginLeft = "4px";
      shareContent.style.marginRight = "4px";
      shareContent.style.lineHeight = "1.5";
    }

    // console.log(shareContent)
    var width = shareContent.offsetWidth;
    var height = shareContent.offsetHeight;
    var canvas = document.createElement("canvas");
    var context = canvas.getContext("2d");
    var scale = getPixelRatio(context); // 将canvas的容器扩大PixelRatio倍，再将画布缩放，将图像放大PixelRatio倍。
    canvas.width = width * scale;
    canvas.height = height * scale;
    canvas.style.width = width + "px";
    canvas.style.height = height + "px";
    context.scale(scale, scale);

    var opts = {
      scale: 1,
      canvas: canvas,
      dpi: window.devicePixelRatio,
      // 获取元素宽高 让其以一个规律或者固定宽高伸展
      width: (shareContent as any) + 400,
      height: (shareContent as any) + 500,
      // 将截图部分 移入中心位置
      scrollX: 200,
      scrollY: 250,
    };
    // 解决图片超出显示区后底色变成黑色的问题
    context.fillStyle = "#fff";

    context.fillRect(0, 0, canvas.width, canvas.height);
    var dataUrl = html2canvas(shareContent, opts).then(function (canvas) {
      context.imageSmoothingEnabled = false;
      (context as any).webkitImageSmoothingEnabled = false;
      (context as any).msImageSmoothingEnabled = false;
      context.imageSmoothingEnabled = false;
      return canvas.toDataURL("image/png", 1.0);
    });

    dataUrl.then((result) => {
      let res: any = {};
      res.file_base64 = result;
      res.filename = item + ".png";
      res.chinese = "函数堆栈趋势图";

      this.resBase64.push(res);

      this.htmlCanvas_problem("problem_trend");

      //     let upload_data: any;
      // let old_test = this.versionsOldOptions.filter(
      //   (v) => v.chinese === this.dataConsumeOptions.old_verson
      // )[0].id_test;
      //     upload_data = {
      //   // project: Number(this.$route.query.project),
      //   project: this.localProject,
      //   id_test: Number(this.id_test),
      //   old_test: old_test,
      //   thread: this.trendOptions.thread,
      //   so:  this.trendOptions.so,
      //   file_list: this.resBase64,
      //   title: this.formMail.title,
      //   recv: this.formMail.addressee,
      //   cc: this.formMail.CC_List,

      //   send: this.formMail.Sender,
      // };
      //  dispatchUploadCpuReport(store, upload_data)
    });
  }
  public configurationShow = false;
  public htmlCanvas1(item) {
    var getPixelRatio = (context) => {
      // 获取设备的PixelRatio
      var backingStore =
        context.backingStorePixelRatio ||
        context.webkitBackingStorePixelRatio ||
        context.mozBackingStorePixelRatio ||
        context.msBackingStorePixelRatio ||
        context.oBackingStorePixelRatio ||
        context.backingStorePixelRatio ||
        0.5;
      // this.b = (this as any).$message({
      //   //Message 消息提示
      //   message: "报告发送中...",
      //   showClose: true,
      //   duration: 0,
      // });
      return (window.devicePixelRatio || 0.5) / backingStore;
    };
    let shareContent: any = "";

    if (item === "func_trend") {
      shareContent = document.getElementById("func_trend");
    } else if (item == "tree") {
      shareContent = document.getElementById("func");
    } else if (item === "chart") {
      // let b = window.frames["bdIframe"];
      // shareContent = b.document.getElementById("chart");
      // let b = window.frames["bdIframe"];
      shareContent = document.getElementById("chart");
      shareContent.style.fontSize = "12px";

      shareContent.style.whiteSpace = "nowrap";
      shareContent.style.textOverflow = "ellipsis";
      shareContent.style.overflow = "hidden";
      shareContent.style.fontFamily = "Verdana";
      shareContent.style.marginLeft = "4px";
      shareContent.style.marginRight = "4px";
      shareContent.style.lineHeight = "1.5";
    }

    // console.log(shareContent)
    var width = shareContent.offsetWidth;
    var height = shareContent.offsetHeight;
    var canvas = document.createElement("canvas");
    var context = canvas.getContext("2d");
    var scale = getPixelRatio(context); // 将canvas的容器扩大PixelRatio倍，再将画布缩放，将图像放大PixelRatio倍。
    canvas.width = width * scale;
    canvas.height = height * scale;
    canvas.style.width = width + "px";
    canvas.style.height = height + "px";
    context.scale(scale, scale);

    var opts = {
      scale: 1,
      canvas: canvas,
      dpi: window.devicePixelRatio,
      // 获取元素宽高 让其以一个规律或者固定宽高伸展
      width: (shareContent as any) + 400,
      height: (shareContent as any) + 500,
      // 将截图部分 移入中心位置
      scrollX: 200,
      scrollY: 250,
    };
    // 解决图片超出显示区后底色变成黑色的问题
    context.fillStyle = "#fff";

    context.fillRect(0, 0, canvas.width, canvas.height);
    var dataUrl = html2canvas(shareContent, opts).then(function (canvas) {
      context.imageSmoothingEnabled = false;
      (context as any).webkitImageSmoothingEnabled = false;
      (context as any).msImageSmoothingEnabled = false;
      context.imageSmoothingEnabled = false;
      return canvas.toDataURL("image/png", 1.0);
    });

    dataUrl.then((result) => {
      let res: any = {};
      res.file_base64 = result;
      res.filename = item + ".png";
      res.chinese = "函数树状图";

      this.resBase64.push(res);

      this.htmlCanvas2("chart");
    });
  }
  public risk_type_new = [];
  public htmlCanvas2(item) {
    var getPixelRatio = (context) => {
      // 获取设备的PixelRatio
      var backingStore =
        context.backingStorePixelRatio ||
        context.webkitBackingStorePixelRatio ||
        context.mozBackingStorePixelRatio ||
        context.msBackingStorePixelRatio ||
        context.oBackingStorePixelRatio ||
        context.backingStorePixelRatio ||
        0.5;
      // this.b = (this as any).$message({
      //   //Message 消息提示
      //   message: "报告发送中...",
      //   showClose: true,
      //   duration: 0,
      // });
      return (window.devicePixelRatio || 0.5) / backingStore;
    };
    let shareContent: any = "";

    if (item === "func_trend") {
      shareContent = document.getElementById("func_trend");
    } else if (item == "tree") {
      shareContent = document.getElementById("func");
    } else if (item === "chart") {
      // let b = window.frames["bdIframe"];
      // shareContent = b.document.getElementById("chart");
      // let b = window.frames["bdIframe"];

      shareContent = document.getElementById("chart");
      shareContent.style.fontSize = "12px";
      // shareContent.style.height = "100%";

      shareContent.style.whiteSpace = "nowrap";
      shareContent.style.textOverflow = "ellipsis";
      shareContent.style.overflow = "hidden";
      shareContent.style.fontFamily = "Verdana";
      shareContent.style.marginLeft = "4px";
      shareContent.style.marginRight = "4px";
      shareContent.style.lineHeight = "1.5";
    }

    // console.log(shareContent)
    var width = shareContent.offsetWidth;
    var height = shareContent.offsetHeight;
    var canvas = document.createElement("canvas");
    var context = canvas.getContext("2d");
    var scale = getPixelRatio(context); // 将canvas的容器扩大PixelRatio倍，再将画布缩放，将图像放大PixelRatio倍。
    canvas.width = width * scale;
    canvas.height = height * scale;
    canvas.style.width = width + "px";
    canvas.style.height = height + "px";
    context.scale(scale, scale);

    var opts = {
      scale: 1,
      canvas: canvas,
      dpi: window.devicePixelRatio,
      // 获取元素宽高 让其以一个规律或者固定宽高伸展
      width: (shareContent as any) + 400,
      height: (shareContent as any) + 500,
      // 将截图部分 移入中心位置
      scrollX: 200,
      scrollY: 250,
    };
    // 解决图片超出显示区后底色变成黑色的问题
    context.fillStyle = "#fff";

    context.fillRect(0, 0, canvas.width, canvas.height);
    var dataUrl = html2canvas(shareContent, opts).then(function (canvas) {
      context.imageSmoothingEnabled = false;
      (context as any).webkitImageSmoothingEnabled = false;
      (context as any).msImageSmoothingEnabled = false;
      context.imageSmoothingEnabled = false;
      return canvas.toDataURL("image/png", 1.0);
    });

    dataUrl.then((result) => {
      let res: any = {};
      res.file_base64 = result;
      res.filename = item + ".png";
      res.chinese = "函数堆栈火焰图";

      this.resBase64.push(res);

      let upload_data: any;
      let old_test = this.versionsOldOptions.filter(
        (v) => v.chinese === this.dataConsumeOptions.old_verson
      )[0].id_test;
      upload_data = {
        // project: Number(this.$route.query.project),
        project: this.localProject,
        id_test: Number(this.id_test),
        old_test: old_test,
        thread: this.trendOptions.thread,
        so: this.trendOptions.so,
        file_list: this.resBase64,
        title: this.formMail.title,
        recv: this.formMail.addressee,
        cc: this.formMail.CC_List,
        cpu: this.cpu_thread == "" ? 0 : this.cpu_thread,
        send: this.formMail.Sender,
        url: window.location.href,
      };
      dispatchUploadCpuReportNew(store, upload_data)
        .then((res) => {
          if (res) {
            this.b.close();
            // let flame = document.getElementById("chart");
            //  flame.style.height = "600px";
            this.btnFalse = true;
            this.edit_show_text = true;
          }
        })
        .finally(() => {
          this.flameShow = true;
          this.flame_thread.forEach((v) => {
            let obj = (this.stackData_obj as any).children.filter(
              (child) => child.name === v
            );
            console.log(obj);
            this.$nextTick(() => {
              let newObj = {
                ...this.stackData_obj,
                children: obj,
              };
              this.renderFlame("#" + this.replaceSpacesWithHyphens(v), newObj);
            });
          });
        });
    });
  }
  //   父类型数据
  public splitArrayByName(list, searchString) {
    let index = list.findIndex((item) => item.name === searchString);

    if (index !== -1) {
      let firstArray = list.slice(0, index);
      let secondArray = list.slice(index + 1);

      return [firstArray, secondArray];
    } else {
      console.log("Name not found in the array.");
      return [list, []];
    }
  }
  public flameShow = true;
  public type_query: any = "";
  public getChinese(i) {
    if (i === "single_frame_time") {
      return "单帧平均耗时(ms)";
    } else {
      return i;
    }
  }
  public trendOptions = {
    thread: "",
    so: "",
  };
  public get allColorList() {
    let list = [];
    for (let i = 0; i < 3; i++) {
      this.colList.forEach((v) => {
        list.push(v);
      });
    }
    return list;
  }
  public colList = [
    "rgba(237, 86, 100)",
    "rgba(145, 124, 190)",
    "rgba(94, 190, 181)",
    "rgba(237, 131, 92)",
    "rgba(102, 132, 213)",
    "rgba(250, 203, 97)",
    "rgba(59, 162, 114)",
    "rgba(102, 132, 213)",
    "rgba(53, 166, 159)",
    "rgba(250, 203, 97)",
    "rgba(237, 86, 100)",
    "rgba(145, 124, 190)",
    "rgba(94, 190, 181)",
    "rgba(237, 131, 92)",
    "rgba(102, 132, 213)",
    "rgba(250, 203, 97)",
    "rgba(59, 162, 114)",
    "rgba(102, 132, 213)",
    "rgba(53, 166, 159)",
    "rgba(250, 203, 97)",
  ];
  public list = [];
  public get labels() {
    this.list = [];
    let num = 0;
    this.cpu_by_frame?.labels?.forEach((v) => {
      num += v.length;
    });
    this.cpu_by_frame?.labels?.forEach((v, index) => {
      this.list.push({
        label: v[0] + "-" + index,
        width: (v.length / num) * 100 + "%",
        color: this.allColorList[index],
      });
    });

    return this.list;
  }
  public fps_list = [];
  public get fps_labels() {
    this.fps_list = [];
    let num = 0;
    this.fps_inside_creat_data?.labels?.forEach((v) => {
      num += v.length;
    });
    this.fps_inside_creat_data?.labels?.forEach((v, index) => {
      this.fps_list.push({
        label: v[0] + "-" + index,
        width: (v.length / num) * 100 + "%",
        color: this.allColorList[index],
      });
    });

    return this.fps_list;
  }
  public get function_label_list() {
    return readGetdeepCpuFunction(store).label_list;
  }
  public getModuleTrend(moduleList) {
    let res = { label_list: [], params: [], series: [] };

    res.label_list = moduleList.label_list;
    res.params = moduleList.data?.map((item) => item.name);

    for (
      let labelIndex = 0;
      labelIndex < res.label_list?.length;
      labelIndex++
    ) {
      let series = [];
      for (let paramIndex = 0; paramIndex < res.params?.length; paramIndex++) {
        series.push(
          this.formatNumber(
            moduleList.data[paramIndex].list[labelIndex].event_count
          )
        );
      }
      res.series.push(series);
    }
    return res;
  }
  public num = -1;
  public async submit() {
    // (this.$refs.table as any).toggleRowExpansion(this.stackData[0], true);
    this.num += 1;
    if (this.inputValue) {
      let result = [];
      this.stackData_all.forEach((item) => {
        this.searchByName(item, this.inputValue, result);
      });
      this.close1(this.stackData_all, false);

      await result.forEach((v) => {
        (this.$refs.table as any).toggleRowExpansion(v, true);
      });
      let c = result.filter((v) => v.name.includes(this.inputValue));
      c.forEach((v, index) => {
        if (document.getElementById(v.id) != null) {
          document.getElementById(v.id).style.color = "orange";
          if (index == 0) {
            //                    const parentEl = document.getElementById(v.id).parentElement;
            // parentEl.style.overflow = 'visible'
            document.getElementById(v.id).scrollIntoView();
          }
        }
      });
    } else {
      this.close1(this.stackData_all, false);
    }
  }
  public addColspan(list) {
    for (let i = 0; i < list.length; i++) {
      let currentItem = list[i];

      let isEqualName = currentItem.index_name === currentItem.index_detail;
      let isEqualDetail =
        currentItem.index_detail === currentItem.index_detail_name;
      let isEqualDetailName =
        currentItem.index_name === currentItem.index_detail_name;

      if (isEqualName && isEqualDetail && isEqualDetailName) {
        currentItem.colspan = 3;
      } else if (isEqualName || isEqualDetail || isEqualDetailName) {
        currentItem.colspan = 2;
      } else {
        currentItem.colspan = 1;
      }
    }
  }
  public mergeRows(list) {
    let indexNameCount = 1;
    let indexDetailCount = 1;
    let indexNameStart = 0;
    let indexDetailStart = 0;

    for (let i = 0; i < list.length; i++) {
      let currentItem = list[i];
      let nextItem = list[i + 1];

      if (
        nextItem &&
        currentItem.index_name === nextItem.index_name &&
        currentItem.index_name !== ""
      ) {
        indexNameCount++;

        if (
          currentItem.index_detail === nextItem.index_detail &&
          currentItem.index_detail !== ""
        ) {
          indexDetailCount++;
        } else {
          list[indexDetailStart].index_detail_rowspan = indexDetailCount;
          indexDetailCount = 1;
          indexDetailStart = i + 1;
        }
      } else {
        list[indexNameStart].index_name_rowspan = indexNameCount;
        indexNameCount = 1;
        indexNameStart = i + 1;

        // 当 index_name 不同时，重置 index_detail_rowspan
        list[indexDetailStart].index_detail_rowspan = indexDetailCount;
        indexDetailCount = 1;
        indexDetailStart = i + 1;
      }
    }
  }
  public custom_text = [
    "SetPassCall",

    "MaxSetPassCall",

    "DrawCall",

    "MaxDrawCall",

    "Batches",

    "MaxBatches",

    "Triangles",

    "MaxTriangles",

    "DynamicBatchedCalls",

    "MaxDynamicBatchedCalls",

    "StaticBatchedCalls",

    "MaxStaticBatchedCalls",
  ];
  public submit_cancellation() {
    dispatchDeepPerformanceCpuCpuConfig(store, {
      project: this.localProject,
    });

    ElMessage.success({
      message: "数据已还原",
      showClose: true,
      type: "success",
    });
    this.addShow = false;

    this.tableAddShow = false;
  }
  public get moudule_list() {
    return readGetdeepCpuFunction(store);
  }
  public mergeCells1({ row, column, rowIndex, columnIndex }) {
    if (columnIndex === 0) {
      const rowCount = this.table_test_overview.filter(
        (item) => item.model === row.model
      ).length;
      if (rowCount > 1) {
        const isFirstRow =
          this.table_test_overview.findIndex(
            (item) => item.model === row.model
          ) === rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
    if (columnIndex === 1) {
      const rowCount = this.table_test_overview.filter(
        (item) => item.scene === row.scene
      ).length;
      if (rowCount > 1) {
        const isFirstRow =
          this.table_test_overview.findIndex(
            (item) => item.scene === row.scene
          ) === rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
    if (columnIndex === 2) {
      const rowCount = this.table_test_overview.filter(
        (item) => item.risk === row.risk
      ).length;
      if (rowCount > 1) {
        const isFirstRow =
          this.table_test_overview.findIndex(
            (item) => item.risk === row.risk
          ) === rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
    if (columnIndex === 3) {
      const rowCount = this.table_test_overview.filter(
        (item) => item.index_name === row.index_name
      ).length;
      const isFirstRow =
        this.table_test_overview.findIndex(
          (item) => item.index_name === row.index_name
        ) === rowIndex;
      const isSameValue =
        row.index_name === row.index_detail &&
        row.index_name === row.index_detail_name;
      return isFirstRow
        ? { rowspan: rowCount > 1 ? rowCount : 1, colspan: isSameValue ? 3 : 1 }
        : { rowspan: 0, colspan: 0 };
    }
    if (columnIndex === 4) {
      const rowCount = this.table_test_overview.filter(
        (item) => item.index_detail === row.index_detail
      ).length;
      const isFirstRow =
        this.table_test_overview.findIndex(
          (item) => item.index_detail === row.index_detail
        ) === rowIndex;
      const isSameValue =
        row.index_name === row.index_detail &&
        row.index_name === row.index_detail_name;
      return isFirstRow
        ? { rowspan: rowCount > 1 ? rowCount : 1, colspan: isSameValue ? 0 : 1 }
        : { rowspan: 0, colspan: 0 };
    }
    if (columnIndex === 5) {
      const rowCount = this.table_test_overview.filter(
        (item) => item.index_detail_name === row.index_detail_name
      ).length;
      const isFirstRow =
        this.table_test_overview.findIndex(
          (item) => item.index_detail_name === row.index_detail_name
        ) === rowIndex;
      const isSameValue =
        row.index_name === row.index_detail &&
        row.index_name === row.index_detail_name;
      return isFirstRow
        ? { rowspan: rowCount > 1 ? rowCount : 1, colspan: isSameValue ? 0 : 1 }
        : { rowspan: 0, colspan: 0 };
    }
  }
  public getMaxLabelHeight(labels) {
    let maxLabelHeight = 0;

    const tempDiv = document.createElement("div");
    tempDiv.style.position = "absolute";
    tempDiv.style.visibility = "hidden";
    tempDiv.style.whiteSpace = "pre"; // 保留换行符
    document.body.appendChild(tempDiv);

    labels.forEach((label) => {
      const formattedLabel = label?.split("").join("\n");
      tempDiv.textContent = formattedLabel;
      maxLabelHeight = Math.max(maxLabelHeight, tempDiv.offsetHeight);
    });

    document.body.removeChild(tempDiv);

    return maxLabelHeight;
  }

  public get report_data() {
    let list = [];
    let falseArray: any = [36, 34, 40, 47, 12, 32, 4];
    if (
      this.localProject === 34 ||
      this.localProject === 40 ||
      this.localProject === 47
    ) {
      list = [
        { name: "Default", value: 0 },
        { name: "局内皮肤测试  ", value: 4 },
        { name: "局外皮肤测试", value: 3 },
        { name: "5V5真人测试", value: 9 },
        { name: "极限测试", value: 8 },
        { name: "皮肤异常测试", value: 13 },
      ];
    }
    if (this.localProject === 32) {
      list = [
        { name: "Default", value: 0 },
        { name: "皮肤异常测试", value: 13 },
      ];
    }
    if (this.localProject === 36) {
      list = [
        { name: "Default", value: 0 },
        { name: "皮肤测试报告", value: 5 },
        { name: "UI性能测试报告", value: 25 },
      ];
    }
    if (this.localProject === 4) {
      list = [
        { name: "Default", value: 0 },
        { name: "分支性能", value: 21 },
        { name: "主干性能", value: 22 },
        { name: "分支dev", value: 23 },
        { name: "主干dev", value: 24 },
        { name: "登录测试", value: 30 },
        { name: "iOS登录", value: 41 },
      ];
    }
    if (this.localProject === 12) {
      list = [{ name: "Default", value: 0 }];
    } else if (falseArray.every((v) => v != this.localProject)) {
      list = [{ name: "Default", value: 0 }];
    }

    return list;
  }
  public hexToRgb(hex) {
    var rgb = [];
    for (var i = 1; i < 7; i += 2) {
      rgb.push(parseInt("0x" + hex.slice(i, i + 2)));
    }
    return rgb;
  }
  public rgbToHex(r: any, g: any, b: any) {
    var hex = ((r << 16) | (g << 8) | b).toString(16);
    return "#" + new Array(Math.abs(hex.length - 7)).join("0") + hex;
  }
  public gradient(startColor, endColor, step) {
    // 将 hex 转换为rgb
    var sColor = this.hexToRgb(startColor),
      eColor = this.hexToRgb(endColor);

    // 计算R\G\B每一步的差值
    var rStep = (eColor[0] - sColor[0]) / step;
    var gStep = (eColor[1] - sColor[1]) / step;
    var bStep = (eColor[2] - sColor[2]) / step;

    var gradientColorArr = [];
    for (var i = 0; i < step; i++) {
      // 计算每一步的hex值
      gradientColorArr.push(
        this.rgbToHex(
          parseInt(rStep * i + sColor[0]),
          parseInt(gStep * i + sColor[1]),
          parseInt(bStep * i + sColor[2])
        )
      );
    }
    return gradientColorArr;
  }
  public returnBtn() {
    return;
  }
  public edit_show = false;
  public risk_model = "";
  public text_quillEditor = "";
  public risk_list_edit = ["高风险", "低风险"];
  public async edit_text() {
    this.edit_show = !this.edit_show;

    if (!this.edit_show) {
      let text = {
        core: {},
        important: {},
        options: {},
        options_list_name: [],
      };
      text.core = this.table_test_overview;
      text.important = this.table_test_overview_important;
      text.options = this.options_list;
      text.options_list_name = this.options_list_name;
      let old_test = this.versionsOldOptions.filter(
        (v) => v.chinese == this.dataConsumeOptions.old_verson
      )[0].id_test;
      await dispatchDeepPerformanceCpuReportText(store, {
        project: this.localProject,
        id_test: this.id_test,
        old_test: old_test,
        risk: this.risk,
        text: JSON.stringify(text),
      });
    }
  }
  public getTableColor(item) {
    let startColor = "#62CDFF";
    let endColor = "#E9F8F9";

    var colorArr = this.gradient(startColor, endColor, 6);
    colorArr = ["	#00BFFF", "#62CDFF", "#97DEFF", "#C9EEFF", "#E9F8F9"];

    return colorArr[item];
  }
  public edit1(row) {
    row.edit = !row.edit;

    if (row.edit == false) {
      row.func = row.func_check ? 1 : 0;
      row.show = row.show_check ? 1 : 0;
      row.show_trend = row.trend_check ? 1 : 0;
      row.functions = row.functions_string.split("\n");

      this.conFig.is_show_function = this.conFig.is_show_function_check ? 0 : 1;
    }
  }
  public async handleBlur(data) {
    data.edit_vale = false;
    //  let text={data:{}}
    //    text.data=this.table_test_overview
    //     let old_test = this.versionsOldOptions.filter(
    //       (v) => v.chinese == this.dataConsumeOptions.old_verson
    //     )[0].id_test;

    //     await dispatchDeepPerformanceCpuReportText(store, {
    //       project: this.localProject,
    //       id_test: this.id_test,
    //       old_test: old_test,
    //       risk: this.risk,
    //       text:  JSON.stringify(text),
    //     });
    // data.newText=this.text_quillEditor
    //    console.log(this.text_quillEditor)
    //    console.log(this.table_test_overview)
  }
  public edit_table(data, index) {
    this.find_options_name = data.index_name;
    data.edit = true;
  }
  public edit_show_text = true;
  public edit_table_detail(data, index) {
    data.edit_detail = true;
  }
  public edit_table_name(data, index) {
    data.edit_name = true;
  }
  public edit_table_value(data, i) {
    // this.table_test_overview.forEach((v, index) =>{
    //   if(index!=i){
    //     v.edit_vale=false
    //   }
    // })
    data.edit_vale = true;

    data.text_quillEditor = `<p><span style="color:${data.color}">${data.value}</span><span style="color:${data.color_new}">${data.text}</span></p>`;
  }
  public operate_text(item) {
    let lastIndex = this.findLastIndexOfStringInIndexName(
      this.table_test_overview,
      "index_name",
      "重点卡顿问题"
    );
    if (item.value == "对比上版本") {
      return "添加";
    } else if (item.value == "对比整局平均") {
      return "添加";
    } else if (item.value !== "对比上版本" || item.value !== "对比整局平均") {
      return "删除";
    }
  }
  public edit_table_value_html(data) {
    data.edit_vale = true;
  }
  public async problemChange(data, i) {
    this.table_test_overview_important.forEach((v, index) => {
      if (index > i && index <= i + data.index_name_rowspan - 1) {
        v.index_name = data.index_name;
      }
    });
    // this.important_flag=false

    // this.importanta_data(this.find_options_name,data.index_name)
    const keys = Object.keys(this.options_list);
    const index = keys.indexOf(this.find_options_name);

    if (index !== -1) {
      keys[index] = data.index_name;
      const newObj = {};
      keys.forEach((key, i) => {
        if (key === data.index_name) {
          newObj[key] = this.options_list[this.find_options_name];
        } else {
          newObj[key] = this.options_list[key];
        }
      });

      Object.assign(this.options_list, newObj);
    }

    this.options_list_name[
      this.options_list_name.indexOf(this.find_options_name)
    ] = data.index_name;
    // let options={}
    //  this.options_list_name.forEach(v=>{
    //  options[v]=this.options_list[v]
    //  })
    //  console.log(options)
    //   const sortedEntries = Object.entries(this.options_list).sort(([key1], [key2]) =>
    //   this.options_list_name.indexOf(key1) > this.options_list_name.indexOf(key2) ? 1 : -1
    // );

    // sortedEntries.forEach(([key, value]) => {
    //   delete this.options_list[key];
    //   this.options_list[key] = value;
    // });
    // console.log( this.options_list)
    // console.log( this.options_list_name)

    //  this.importanta_data()

    //    uniqueIndexNames.forEach(key => {
    //   sortedObj[key] = this.important_options[key];
    // });
    // console.log(sortedObj )
    this.clearRowspan(this.table_test_overview_important);
    // this.table_test_overview.forEach((v, index) => {
    //   if (index == 0) {
    //     v.rowspan = this.table_test_overview.length;
    //   }
    // });
    this.mergeRows(this.table_test_overview_important);

    data.edit = false;
  }
  public important_flag = true;
  public name_list = [];
  public async problemDetailChange(data, i) {
    this.table_test_overview_important.forEach((v, index) => {
      if (index > i && index <= i + data.index_detail_rowspan - 1) {
        v.index_detail = data.index_detail;
      }
    });

    this.clearRowspan(this.table_test_overview_important);
    // this.table_test_overview.forEach((v, index) => {
    //   if (index == 0) {
    //     v.rowspan = this.table_test_overview.length;
    //   }
    // });
    this.mergeRows(this.table_test_overview_important);

    data.edit = false;
  }
  public async problemNameChange(data, i) {
    // this.clearRowspan(this.table_test_overview);
    // this.table_test_overview.forEach((v, index) => {
    //   if (index == 0) {
    //     v.rowspan = this.table_test_overview.length;
    //   }
    // });
    // this.mergeRows(this.table_test_overview);

    // this.addColspan(this.table_test_overview);
    data.edit_name = false;
    //  let text={data:{}}
    //  text.data=this.table_test_overview
    //   let old_test = this.versionsOldOptions.filter(
    //     (v) => v.chinese == this.dataConsumeOptions.old_verson
    //   )[0].id_test;

    //   await dispatchDeepPerformanceCpuReportText(store, {
    //     project: this.localProject,
    //     id_test: this.id_test,
    //     old_test: old_test,
    //     risk: this.risk,
    //     text:  JSON.stringify(text),
    //   });
  }
  public expand = true;
  public async submit_edit() {
    this.tableAddShow = false;

    this.conFig.is_show_function = this.conFig.is_show_function_check ? 0 : 1;
    this.conFig.module_list.forEach((v) => {
      v.edit = false;
      v.func = v.func_check ? 1 : 0;
      v.show = v.show_check ? 1 : 0;
      v.show_trend = v.trend_check ? 1 : 0;
      v.functions = v.functions_string.split("\n");
    });
    let b = (this as any).$message({
      //Message 消息提示
      message: "正在更新模块,请稍等",
      showClose: true,
      duration: 0,
    });

    await dispatcDeepPerformanceCpuPutConfig(store, {
      project: this.localProject,
      id_test: this.id_test,
      module_config: this.conFig,
    });
    b.close();
    ElMessage.success({
      message: "保存成功",
      showClose: true,
      type: "success",
    });
    await dispatchDeepPerformanceCpuDetail(store, {
      project: this.localProject,
      id_test: this.id_test,
    });

    this.cpu_module_creat();
    // await dispatchDeepPerformanceCpuFunctionModuleTrend(store, {
    //   project: this.localProject,
    //   start: startTimeAll,
    //   end: endTimeAll,
    //   device_id: Number(this.dataOptions.device),
    //   scene_id: Number(this.dataOptions.scene),
    //   thread: this.trendOptions.thread,
    //   label: this.dataOptions.subScene,
    //   so: this.trendOptions.so,
    //   id_test: this.id_test,
    //   is_auto: this.auto_query,
    //   type: this.type_query,
    //   subtype: this.subtype_query,
    // });
    // this.drawMoTrend();
    if (
      this.localProject == 7 ||
      this.localProject == 4 ||
      this.localProject == 48
    ) {
      await dispatchDeepPerformanceCpuUsageListModuleQQ(store, {
        project: this.localProject,
        id_test: this.id_test,
      });
      this.moudle_model = this.moudleList;
      this.moudle_inside_data = this.moudle_mounted_qf().filter((item) =>
        this.moudle_model.includes(item.name)
      );
      this.drawModuleInsideTrendQF();
    } else {
      await this.moudel_detail_creat();
      this.moudle_inside_data = this.moudle_mounted().filter((item) =>
        this.moudle_model.includes(item.name)
      );
      this.drawModuleInsideTrend();
    }
  }
  public cellStyle({ row, column, rowIndex, columnIndex }) {
    //指定坐标rowIndex ：行，columnIndex ：列
    // this.getTableColor(row.depth)
    return "background:" + this.getTableColor(row.depth); //rgb(105,0,7)
  }
  cellStyle2({ row, column, rowIndex, columnIndex }) {
    let columnList = this.generateArray(
      this.configuration_table_baseline.length
    );
    let columnList1 = this.generateArray1(
      columnList.length,
      this.configuration_table_threshold.length
    );
    if (columnList.includes(columnIndex) && !this.baseline_check) {
      return { backgroundColor: "#e0e0e0" };
    }
    if (columnList1.includes(columnIndex) && !this.threshold_check) {
      return { backgroundColor: "#e0e0e0" };
    }

    //  if (columnIndex === 2) {
    //     return { backgroundColor: '#e0e0e0' };
    //   }
    // if (columnIndex === 1) {
    //   return { backgroundColor: '#f0f0f0' };
    // } else if (columnIndex === 2) {
    //   return { backgroundColor: '#e0e0e0' };
    // }
  }
  public generateArray(num) {
    const result = [];
    for (let i = 1; i <= num; i++) {
      result.push(i);
    }
    return result;
  }
  public generateArray1(n, num) {
    const result = [];
    for (let i = 1; i <= num; i++) {
      result.push(n + i);
    }
    return result;
  }
  //   子类型数据
  public subtype_query: any = "";
  public clear(row, i) {
    if (row.edit == true) {
      row.edit = false;
    } else {
      this.conFig.module_list.splice(i, 1);
      this.conFig.is_show_function = this.conFig.is_show_function_check ? 0 : 1;
    }
  }
  public add_row_data = {
    thread: "",
    so: "",
    moudel: "",
    parent: "",
    func_check: false,
    functions_string: "",
    show_check: false,
    trend_check: false,
  };
  delConfig(config) {
    /*
  配置会有这种空配置情况，需要剔除：
      82676: {"All": {}, "Android": {}, "iOS": {}}
  */
    const nullList = [];

    for (const scene in config) {
      let isNull = true;

      for (const platform in config[scene]) {
        if (Object.keys(config[scene][platform]).length > 0) {
          isNull = false;
        }
      }

      if (isNull) {
        nullList.push(scene);
      }
    }

    for (const i of nullList) {
      delete config[i];
    }
  }
  public cpu_thread = "";

  public removeEmptyObjects(obj?) {
    return Object.fromEntries(
      Object.entries(obj)
        .map(([k, v]) => [
          k,
          v && typeof v === "object" ? this.removeEmptyObjects(v) : v,
        ])
        .filter(
          ([k, v]) =>
            v !== undefined &&
            v !== null &&
            !(typeof v === "object" && Object.keys(v).length === 0)
        )
    );
  }

  public removeEmptyParentObjects(obj?) {
    return Object.fromEntries(
      Object.entries(this.removeEmptyObjects(obj)).filter(
        ([k, v]) => !(typeof v === "object" && Object.keys(v).length === 0)
      )
    );
  }
  config = {
    "78509": {
      All: {},
      Android: {},
      iOS: { name: 2 },
    },
    "78503": {
      All: { name: 4 },
      Android: {},
      iOS: { name: 2 },
    },
    "78504": {
      All: {},
      Android: {},
      iOS: {},
    },
  };
  public get cpu_set_up() {
    let obj = JSON.parse(readGetdeepCpuDetail(store)?.settings);

    return obj;
  }
  public is_bad_risk = false;
  public get parentList() {
    let report_settings = this.cpu_set_up;

    let list = [];
    if (this.localProject !== 7) {
      for (let i in report_settings.module) {
        if (i !== "is_show_all" && i !== "is_show_function") {
          for (let n in report_settings.module[i]) {
            for (let m in report_settings.module[i][n]) {
              list.push(m);
            }
          }
        }
      }
    } else {
      for (let i in report_settings.module) {
        if (i !== "is_show_all" && i !== "is_show_function") {
          for (let n in report_settings.module[i]) {
            list.push(n);
          }
        }
      }
    }

    return list;
  }
  public async addList() {
    if (this.localProject != 7) {
      this.conFig.module_list.push({
        thread: this.add_row_data.thread,
        so: this.add_row_data.so,
        module: this.add_row_data.moudel,
        parent: this.add_row_data.parent,
        functions: this.add_row_data.functions_string.split("\n"),
        func: this.add_row_data.func_check ? 1 : 0,
        show: this.add_row_data.show_check ? 1 : 0,
        show_trend: this.add_row_data.trend_check ? 1 : 0,
      });
    } else {
      this.conFig.module_list.push({
        thread: this.add_row_data.thread,

        module: this.add_row_data.moudel,
        parent: this.add_row_data.parent,
        functions: this.add_row_data.functions_string.split("\n"),
        func: this.add_row_data.func_check ? 1 : 0,
        show: this.add_row_data.show_check ? 1 : 0,
        show_trend: this.add_row_data.trend_check ? 1 : 0,
      });
    }

    this.addShow = false;
  }
  public addShow = false;
  public async addRow() {
    this.addShow = true;
    // let report_settings = JSON.parse(readGetdeepCpuDetail(store).settings);

    await dispatchDeepPerformanceCpuCpuConfigSoList(store, {
      project: this.localProject,
      id_test: this.id_test,
    });
  }
  public get sub_data() {
    let list = [];
    if (this.type_query == 13) {
      list = [
        { name: "局内", value: "0" },
        { name: "局外", value: "1" },
      ];
    } else if (this.type_query == 9) {
      list = [
        { name: "Default", value: "0" },
        { name: "开profile", value: "1" },
        { name: "关profile", value: "2" },
      ];
    } else {
      list = [{ name: "Default", value: "0" }];
    }
    return list;
  }
  //   当前版本数据
  public dataConsumeOptions = {
    version: "",
    device: "",
    scene: "",
    old_verson: "",
  };
  public get versionsOptions() {
    return readGetdeepCpuVersions(store).data;
  }
  // 测试机型
  public get performace_select_options_old() {
    const options = readDeepPerformanceSelectOptionsOld(store);

    return options;
  }
  public configuration_table_baseline = [];
  public configuration_table_threshold = [];
  public configuration_table_data = [];
  public get device_options_old() {
    const devices = this.performace_select_options_old.device_list;

    return devices;
  }
  //   测试场景
  public get scene_options_old() {
    const scene_list: any[] = this.performace_select_options_old.scene_list;

    return scene_list;
  }
  public get scene_options_old_table() {
    const scene_list: any[] = JSON.parse(JSON.stringify(this.scene_options));

    scene_list.push({ scene__chinese: "All", scene_id: "All" });

    return scene_list;
  }
  //   对比版本
  public get versionsOldOptions() {
    return readGetdeepCpuVersionsOld(store).data;
  }
  //   对比版本切换
  public async versionChange(type, name) {
    if (!type) {
      if (name.includes("type")) {
        await dispatchCpuFuncScenesOptions(store, {
          project: this.localProject,
          device_id: "",
          scene_id: "",
          is_auto: this.auto_query.length == 0 ? "" : this.auto_query,
          type: this.type_query,
          subtype: this.subtype_query,
        });
        this.dataConsumeOptions.scene = this.scene_options[0].scene_id;
      }
      if (name.includes("scene")) {
        await dispatchCpuFuncDeivceOptions(store, {
          project: this.localProject,
          device_id: "",
          scene_id: this.dataConsumeOptions.scene,
          is_auto: this.auto_query.length == 0 ? "" : this.auto_query,
          type: this.type_query,
          subtype: this.subtype_query,
        });
        this.dataConsumeOptions.device = this.device_options[0].device_id;
      }
      if (name.includes("device")) {
        await dispatchDeepPerformanceCpuCpuVersions(store, {
          project: this.localProject,
          is_auto: this.auto_query.length == 0 ? "" : this.auto_query,
          type: this.type_query,
          subtype: this.subtype_query,
          device_id: this.dataConsumeOptions.device,
          scene_id: this.dataConsumeOptions.scene,
        });
        this.dataConsumeOptions.version = this.versionsOptions[0].chinese;
        this.id_test = this.versionsOptions[0].id_test;
      }
    }
    //  await dispatchDeepPerformanceCputhreadByFrame(store, {
    //   project: this.localProject,
    //   id_test: this.id_test,
    // });
    //     this.cpu_thread=this.cpu_thead_options[0]
    //  this.drawCpuThreadByFrame()
    await dispatchDeepPerformanceCpuCpuVersionsOld(store, {
      project: this.localProject,
      device_id: Number(this.dataConsumeOptions.device),
      scene_id: Number(this.dataConsumeOptions.scene),
      is_auto: this.auto_query,
      type: this.type_query,
      subtype: this.subtype_query,
    });
    if (this.versionsOldOptions.length == 1) {
      this.dataConsumeOptions.old_verson = this.versionsOldOptions[0].chinese;
    }
    if (this.versionsOldOptions.length > 1) {
      let index_num = 0;
      let index = this.versionsOldOptions.findIndex(
        (v) => v.chinese == this.dataConsumeOptions.version
      );
      if (index == this.versionsOldOptions.length - 1) {
        index_num = index - 1;
      } else {
        index_num = index + 1;
      }

      this.dataConsumeOptions.old_verson = this.versionsOldOptions[
        index_num
      ].chinese;
    }

    // let date = this.versionsOptions.filter(
    //   (v) => v.chinese == this.dataConsumeOptions.version
    // )[0].date;
    // let version = this.versionsOptions.filter(
    //   (v) => v.chinese == this.dataConsumeOptions.version
    // )[0].game_version;
    // await dispatchGetDeepPerformanceSelectOptionsOld(store, {
    //   project: this.localProject,
    //   date: date,
    //   game_version: version,
    // });
    // this.dataConsumeOptions.device = this.device_options_old[0].device_id;

    // this.dataConsumeOptions.scene = this.scene_options_old[0].scene_id;
  }

  // 控制发送邮件开关
  public edit = false;
  public sendOut() {
    this.edit = !this.edit;
  }
  //   邮件数据
  public formMail = {
    title: "", //标题
    Sender: "gamerobot@tencent.com", //发件人
    addressee: "", //收件人
    CC_List: "", //抄送人
  };
  public get fps_inside_creat_data() {
    return readGetdeepFpsInsideTrend(store);
  }
  // FPS局内趋势图
  public async fps_inside_creat() {
    await dispatchDeepPerformanceFpsInsideTrend(store, {
      project: this.localProject,
      id_test: this.id_test,
    });

    await this.drawFpsInside();
    this.fps_labels;
  }
  public drawFpsInside() {
    let data = [];
    this.fps_inside_creat_data.columns
      ?.filter((v) => v !== "timeline")
      .forEach((v, index) => {
        data.push({
          name: v,
          type: "line",
          symbol: "circle", //拐点设置为实心
          data: this.fps_inside_creat_data.rows[v],
          yAxisIndex: v === "fps" ? 0 : 1,
        });
      });
    let yaxis = [
      {
        name: "ms",
        type: "value",
      },
      {
        type: "value",
        splitLine: {
          show: false,
        },
      },
    ];
    let performance_line: any = document.getElementById("fps_inside");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.on("datazoom", (params: any) => {
      let xAxis = (contrastChart as any).getModel().option; // 获取x轴数据 我这个是时间
      let series = (contrastChart as any).getModel().option.series[0]; // 获取数据
      let start_rate = params.start;
      let end_rate = params.end;

      // console.log(series); // 这个是获取的数据
      //           console.log(series.data);
      //            console.log(xAxis.rangeStart);//滑动条左端对应在xAxis.data的索引
      //           console.log(xAxis.rangeEnd);//滑动条右端对应在xAxis.data的索引
      // let timeIndexStart =
      //   this.cpu_by_frame.frame_index.length * (params.start / 100);
      // let timeIndexEnd =
      //   this.cpu_by_frame.frame_index.length * (params.end / 100);
      let start = (contrastChart as any).getModel().option.dataZoom[0]
        .startValue;
      let end = (contrastChart as any).getModel().option.dataZoom[0].endValue;
      let arr = this.fps_inside_creat_data.rows.timeline.filter((v, i) => {
        if (start === this.fps_inside_creat_data.rows.timeline.length) {
          return i >= start - 1 && i < end;
        } else {
          return i >= start && i <= end;
        }
      });
      let newLabelName = this.fps_by_frame_list.flat().filter((v, i) => {
        if (start === this.fps_inside_creat_data.rows.timeline.length) {
          return i >= start - 1 && i < end;
        } else {
          return i >= start && i <= end;
        }
      });
      var newArr = [],
        tempArr = [];

      for (var i = 0, j = newLabelName.length; i < j; i++) {
        if (newLabelName[i] == newLabelName[i + 1]) {
          tempArr.push(newLabelName[i]);
        } else {
          tempArr.push(newLabelName[i]);
          newArr.push(tempArr.slice(0));
          tempArr.length = 0;
        }
      }

      let c = newArr.flat();
      let n = Array.from(new Set(c));
      let nameArr = [];
      let name1Arr = [];

      this.fps_labels.forEach((v) => {
        n.forEach((j) => {
          if (v.label === j) {
            nameArr.push(v);
          }
        });
      });

      newArr.forEach((v) => {
        name1Arr.push({
          label: v[0],
          width: (v.length / arr.length) * 100 + "%",
        });
      });

      nameArr.forEach((v) => {
        name1Arr.forEach((j) => {
          if (v.label == j.label) {
            v.width = j.width;
          }
        });
      });
      this.fps_list = nameArr;
    });
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
        confine: true,
      },
      grid: {
        left: "4%",
        right: "4%",
        bottom: "25%",
        top: "20%",
        // containLabel: true,
      },
      // title: {
      //   left: "center",

      //   text: "日稳定包函数耗时趋势图(百分比)",
      // },
      dataZoom: [
        //给x轴设置滚动条
        {
          // end: 100 - 1500 / 31, //默认为100
          type: "slider",
          show: true,
          xAxisIndex: [0],
          // handleSize: 0, //滑动条的 左右2个滑动条的大小
          height: 14, //组件高度
          left: 30, //左边的距离
          right: 40, //右边的距离
          bottom: 40, //右边的距离
          handleColor: "#ddd", //h滑动图标的颜色
          handleStyle: {
            borderColor: "#cacaca",
            borderWidth: "1",
            shadowBlur: 2,
            background: "#ddd",
            shadowColor: "#ddd",
          },
          fillerColor: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
            {
              //给颜色设置渐变色 前面4个参数，给第一个设置1，第四个设置0 ，就是水平渐变
              //给第一个设置0，第四个设置1，就是垂直渐变
              offset: 0,
              color: "#1eb5e5",
            },
            {
              offset: 1,
              color: "#5ccbb1",
            },
          ]),
          backgroundColor: "#ddd", //两边未选中的滑动条区域的颜色
          showDataShadow: false, //是否显示数���阴影 默认auto
          showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
          handleIcon:
            "M-292,322.2c-3.2,0-6.4-0.6-9.3-1.9c-2.9-1.2-5.4-2.9-7.6-5.1s-3.9-4.8-5.1-7.6c-1.3-3-1.9-6.1-1.9-9.3c0-3.2,0.6-6.4,1.9-9.3c1.2-2.9,2.9-5.4,5.1-7.6s4.8-3.9,7.6-5.1c3-1.3,6.1-1.9,9.3-1.9c3.2,0,6.4,0.6,9.3,1.9c2.9,1.2,5.4,2.9,7.6,5.1s3.9,4.8,5.1,7.6c1.3,3,1.9,6.1,1.9,9.3c0,3.2-0.6,6.4-1.9,9.3c-1.2,2.9-2.9,5.4-5.1,7.6s-4.8,3.9-7.6,5.1C-285.6,321.5-288.8,322.2-292,322.2z",
          filterMode: "filter",
        },
        //下面这个属性是里面拖到
        {
          type: "inside",
          show: true,
          xAxisIndex: [0],
          disabled: true, // 禁用鼠标滚动缩放
          //  start: 0,//默认为1
          //  end: 100-1500/31,//默认为100
        },
      ],
      legend: {
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: yaxis,

      animation: false,
      xAxis: {
        type: "category",
        data: this.fps_inside_creat_data.rows?.timeline,
      },

      series: data,
    });
    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    });
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = "fps_inside" + "-" + ".png";
    res.chinese = "FPS局内趋势图";
    this.resBase64.push(res);
  }
  public get conFig() {
    let list = readGetdeepCpuConfig(store);

    list.is_show_function_check = list.is_show_function == 1 ? false : true;
    list.module_list.forEach((v) => {
      if (v.func == 1) {
        v.func_check = true;
      } else {
        v.func_check = false;
      }
      if (v.show_trend == 1) {
        v.trend_check = true;
      } else {
        v.trend_check = false;
      }
      if (v.show) {
        v.show_check = true;
      } else {
        v.show_check = false;
      }
      v.edit = false;
      v.functions_string = v.functions.join("\n");
    });
    return list;
  }
  public tableAddShow = false;
  // CPU性能迭代趋势图数据
  public get cpuDataTrend() {
    return readGetdeepCpuUsageTrend(store).data;
  }
  // CPU局内趋势图
  public drawCpuInsideTrend() {
    let data = [];
    this.cpu_inside_data.chinese.forEach((v, index) => {
      data.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心，
        smooth: true, // 平滑曲线
        data: [],
        itemStyle: {
          normal: {
            label: {
              // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
              show: true,
            },
          },
        },
        yAxisIndex: v === "Freq MHz" ? 1 : 0,
      });
    });
    data.forEach((v, index) => {
      this.cpu_inside_data.series.forEach((i) => {
        v.data.push(i[index]);
      });
    });
    let yaxis = [
      {
        name: "",
        type: "value",
      },
      {
        type: "value",
        splitLine: {
          show: false,
        },
      },
    ];
    let performance_line: any = document.getElementById("cpu_inside");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      color: [
        "#5470c6",
        "#91cc75",
        "#fac858",
        "#ee6666",
        "#73c0de",
        "#3ba272",
        "#fc8452",
        "#935bab",
        "#d872bc",
        "black", // 新颜色1，橙色
        "pink",
      ],
      tooltip: {
        trigger: "axis",
        confine: true,
      },
      // grid: {
      //   left: "4%",
      //   right: "4%",
      //   bottom:
      //   // this.getMaxLabelHeight(this.cpu_inside_data.label_list) - 150,
      //     this.getMaxLabelHeight(this.cpu_inside_data.label_list),

      //   top: "10%",
      //   // containLabel: true,
      // },
      grid: {
        left: "4%",
        right: "4%",
        top: "10%",
        bottom: "15%",
        containLabel: true,
      },
      // title: {
      //   left: "center",

      //   text: "日稳定包函数耗时趋势图(百分比)",
      // },

      legend: {
        bottom: 0,
        left: "center",
        orient: "horizontal",
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: yaxis,

      animation: false,
      xAxis: {
        type: "category",
        data: this.cpu_inside_data.label_list,
        axisLabel: {
          formatter: function (value) {
            return value?.split("").join("\n");
          },
        },
      },

      series: data,
    });
    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    });
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = "cpu_inside" + "-" + ".png";
    res.chinese = "CPU局内趋势图";
    this.resBase64.push(res);
  }
  public return_tootip(name, value) {
    if (name === "VerticesShaded[K]") {
      return value + "(M)";
    } else if (name === "FragmentsShaded[K]") {
      return (value / 10).toFixed(2) + "(10MB)";
    } else if (name === "ReadTotal[MB]") {
      return (value / 10).toFixed(2) + "(10MB)";
    } else if (name === "WriteTotal[MB]") {
      return (value / 10).toFixed(2) + "(10MB)";
    } else {
      return value;
    }
  }
  public return_convert(name, item) {
    let list = [];
    if (name === "VerticesShaded[K]") {
      list = item.map((number) => (number / 1024).toFixed(2));
      // return (value / 1024).toFixed(2) + "(M)";
    } else if (name === "FragmentsShaded[K]") {
      list = item.map((number) => (number / 1024).toFixed(2));
      // return (value / 1024 / 10).toFixed(2) + "(10MB)";
    }
    //   else if (name === "ReadTotal[MB]") {
    //      list=item.map((number) => (number / 10).toFixed(2))
    //     // return (value / 10).toFixed(2) + "(10MB)";
    //   } else if (name === "WriteTotal[MB]") {
    //  list=item.map((number) => (number / 10).toFixed(2))
    //   }
    else {
      list = item;
    }
    return list;
  }

  // public remoteMethod = (query: string) => {
  //   if (query !== '') {
  //     loading.value = true
  //     setTimeout(() => {
  //       loading.value = false
  //       options.value = list.filter((item) => {
  //         return item.label.toLowerCase().includes(query.toLowerCase())
  //       })
  //     }, 200)
  //   } else {
  //     options.value = []
  //   }
  // }
  public value = [];
  public options = [
    { value: 0, label: "Option 0" },
    { value: 1, label: "Option 1" },
    { value: 2, label: "Option 2" },
    { value: 3, label: "Option 3" },
    { value: 4, label: "Option 4" },
    { value: 5, label: "Option 5" },
    { value: 6, label: "Option 6" },
    { value: 7, label: "Option 7" },
    { value: 8, label: "Option 8" },
    { value: 9, label: "Option 9" },
    { value: 10, label: "Option 10" },
    { value: 11, label: "Option 11" },
    { value: 12, label: "Option 12" },
    { value: 13, label: "Option 13" },
    { value: 14, label: "Option 14" },
    { value: 15, label: "Option 15" },
    { value: 16, label: "Option 16" },
    { value: 17, label: "Option 17" },
    { value: 18, label: "Option 18" },
    { value: 19, label: "Option 19" },
  ];
  public loading = false;
  public currentPage2 = 1;
  public pageSize = 20;
  public hasMore = true;
  public drawGpuInsideTrend() {
    let data = [];
    let check = [
      "VerticesShaded[K]",
      "FragmentsShaded[K]",
      "ReadTotal[MB]",
      "WriteTotal[MB]",
    ];

    this.gpu_inside_data.chinese.forEach((v, index) => {
      data.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: [],
        data1: [],
        smooth: true, // 平滑曲线
        itemStyle: {
          normal: {
            label: {
              // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
              show: true,
            },
          },
        },
        yAxisIndex: check.includes(v) ? 1 : 0,
      });
    });

    data.forEach((v, index) => {
      this.gpu_inside_data.series.forEach((i) => {
        v.data1.push(i[index]);
        // this.return_convert(v.name,v.data.push(i[index]));
      });
    });
    data.forEach((v, index) => {
      v.data = this.return_convert(v.name, v.data1);
    });

    let yaxis = [
      {
        name: "ms",
        type: "value",
      },
      {
        type: "value",

        splitLine: {
          show: false,
        },
      },
    ];
    let performance_line: any = document.getElementById("gpu_inside");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
        confine: true,
        formatter: (params: any) => {
          {
            //  只粘贴formatter了

            let relVal = params[0].axisValueLabel;
            for (let i = 0; i < params.length; i++) {
              relVal +=
                "<div  style='display:flex;align-items:center;width:350px;justify-content: space-between;' ><div style='width:120px'>" +
                params[i].marker +
                params[i].seriesName +
                '</div><div style="font-weight:bold">' +
                (params[i].value == undefined
                  ? "-"
                  : this.return_tootip(params[i].seriesName, params[i].value)) + //   不同点
                "</div></div>";
            }

            return relVal;
          }
        },
      },
      grid: {
        left: "4%",
        right: "4%",
        top: "10%",
        bottom: "15%",
        containLabel: true,
      },
      // title: {
      //   left: "center",

      //   text: "日稳定包函数耗时趋势图(百分比)",
      // },

      legend: {
        bottom: 0,
        left: "center",
        orient: "horizontal",
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: yaxis,

      animation: false,
      xAxis: {
        type: "category",
        data: this.gpu_inside_data.label_list,
        axisLabel: {
          formatter: function (value) {
            return value?.split("").join("\n");
          },
        },
      },

      series: data,
    });
    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    });
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = "gpu_inside" + "-" + ".png";
    res.chinese = "GPU局内趋势图";
    this.resBase64.push(res);
  }
  public drawGpuInsideTrendQF() {
    let data = [];
    let check = [
      "VerticesShaded[K]",
      "FragmentsShaded[K]",
      "ReadTotal[MB]",
      "WriteTotal[MB]",
    ];

    this.qf_inside.gpu.columns
      .filter((v) => v != "timeline")
      .forEach((v, index) => {
        data.push({
          name: v,
          type: "line",
          symbol: "circle", //拐点设置为实心，
          // smooth: true, // 平滑曲线
          data: this.return_convert(v, this.qf_inside.gpu.rows[v]),
          // itemStyle: {
          //   normal: {
          //     label: {
          //       // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
          //       show: true,
          //     },
          //   },
          // },
          yAxisIndex: check.includes(v) ? 1 : 0,
        });
      });

    let yaxis = [
      {
        name: "ms",
        type: "value",
      },
      {
        type: "value",

        splitLine: {
          show: false,
        },
      },
    ];
    let performance_line: any = document.getElementById("gpu_inside");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.on("datazoom", (params: any) => {
      let xAxis = (contrastChart as any).getModel().option; // 获取x轴数据 我这个是时间
      let series = (contrastChart as any).getModel().option.series[0]; // 获取数据
      let start_rate = params.start;
      let end_rate = params.end;

      // console.log(series); // 这个是获取的数据
      //           console.log(series.data);
      //            console.log(xAxis.rangeStart);//滑动条左端对应在xAxis.data的索引
      //           console.log(xAxis.rangeEnd);//滑动条右端对应在xAxis.data的索引
      // let timeIndexStart =
      //   this.cpu_by_frame.frame_index.length * (params.start / 100);
      // let timeIndexEnd =
      //   this.cpu_by_frame.frame_index.length * (params.end / 100);
      let start = (contrastChart as any).getModel().option.dataZoom[0]
        .startValue;
      let end = (contrastChart as any).getModel().option.dataZoom[0].endValue;
      let arr = this.qf_inside.gpu.rows.timeline.filter((v, i) => {
        if (start === this.qf_inside.gpu.rows.timeline.length) {
          return i >= start - 1 && i < end;
        } else {
          return i >= start && i <= end;
        }
      });
      let newLabelName = this.gpu_by_frame_list.flat().filter((v, i) => {
        if (start === this.qf_inside.gpu.rows.timeline.length) {
          return i >= start - 1 && i < end;
        } else {
          return i >= start && i <= end;
        }
      });
      var newArr = [],
        tempArr = [];

      for (var i = 0, j = newLabelName.length; i < j; i++) {
        if (newLabelName[i] == newLabelName[i + 1]) {
          tempArr.push(newLabelName[i]);
        } else {
          tempArr.push(newLabelName[i]);
          newArr.push(tempArr.slice(0));
          tempArr.length = 0;
        }
      }

      let c = newArr.flat();
      let n = Array.from(new Set(c));
      let nameArr = [];
      let name1Arr = [];

      this.gpu_labels.forEach((v) => {
        n.forEach((j) => {
          if (v.label === j) {
            nameArr.push(v);
          }
        });
      });

      newArr.forEach((v) => {
        name1Arr.push({
          label: v[0],
          width: (v.length / arr.length) * 100 + "%",
        });
      });

      nameArr.forEach((v) => {
        name1Arr.forEach((j) => {
          if (v.label == j.label) {
            v.width = j.width;
          }
        });
      });
      this.gpu_list = nameArr;
    });
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
        confine: true,
        formatter: (params: any) => {
          {
            //  只粘贴formatter了

            let relVal = params[0].axisValueLabel;
            for (let i = 0; i < params.length; i++) {
              relVal +=
                "<div  style='display:flex;align-items:center;width:350px;justify-content: space-between;' ><div style='width:120px'>" +
                params[i].marker +
                params[i].seriesName +
                '</div><div style="font-weight:bold">' +
                (params[i].value == undefined
                  ? "-"
                  : this.return_tootip(params[i].seriesName, params[i].value)) + //   不同点
                "</div></div>";
            }

            return relVal;
          }
        },
      },
      grid: {
        left: "4%",
        right: "4%",
        bottom:
          this.localProject == 34
            ? this.getMaxLabelHeight(this.qf_inside.gpu.rows.timeline) - 150
            : "25%",
        top: "10%",
        // containLabel: true,
      },
      // title: {
      //   left: "center",

      //   text: "日稳定包函数耗时趋势图(百分比)",
      // },
      dataZoom: [
        //给x轴设置滚动条
        {
          // end: 100 - 1500 / 31, //默认为100
          type: "slider",
          show: true,
          xAxisIndex: [0],
          // handleSize: 0, //滑动条的 左右2个滑动条的大小
          height: 14, //组件高度
          left: 30, //左边的距离
          right: 40, //右边的距离
          bottom: 40, //右边的距离
          handleColor: "#ddd", //h滑动图标的颜色
          handleStyle: {
            borderColor: "#cacaca",
            borderWidth: "1",
            shadowBlur: 2,
            background: "#ddd",
            shadowColor: "#ddd",
          },
          fillerColor: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
            {
              //给颜色设置渐变色 前面4个参数，给第一个设置1，第四个设置0 ，就是水平渐变
              //给第一个设置0，第四个设置1，就是垂直渐变
              offset: 0,
              color: "#1eb5e5",
            },
            {
              offset: 1,
              color: "#5ccbb1",
            },
          ]),
          backgroundColor: "#ddd", //两边未选中的滑动条区域的颜色
          showDataShadow: false, //是否显示数据阴影 默认auto
          showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
          handleIcon:
            "M-292,322.2c-3.2,0-6.4-0.6-9.3-1.9c-2.9-1.2-5.4-2.9-7.6-5.1s-3.9-4.8-5.1-7.6c-1.3-3-1.9-6.1-1.9-9.3c0-3.2,0.6-6.4,1.9-9.3c1.2-2.9,2.9-5.4,5.1-7.6s4.8-3.9,7.6-5.1c3-1.3,6.1-1.9,9.3-1.9c3.2,0,6.4,0.6,9.3,1.9c2.9,1.2,5.4,2.9,7.6,5.1s3.9,4.8,5.1,7.6c1.3,3,1.9,6.1,1.9,9.3c0,3.2-0.6,6.4-1.9,9.3c-1.2,2.9-2.9,5.4-5.1,7.6s-4.8,3.9-7.6,5.1C-285.6,321.5-288.8,322.2-292,322.2z",
          filterMode: "filter",
        },
        //下面这个属性是里面拖到
        {
          type: "inside",
          show: true,
          xAxisIndex: [0],
          disabled: true, // 禁用鼠标滚动缩放
          //  start: 0,//默认为1
          //  end: 100-1500/31,//默认为100
        },
      ],
      legend: {
        x: "center",
        y: "bottom",
        padding: [0, 0, 0, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: yaxis,

      animation: false,
      xAxis: {
        type: "category",
        data: this.qf_inside.gpu.rows.timeline,
      },

      series: data,
    });
    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    });
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = "gpu_inside" + "-" + ".png";
    res.chinese = "GPU局内趋势图";
    this.resBase64.push(res);
  }
  public get moudleList() {
    if (
      this.localProject !== 4 &&
      this.localProject !== 7 &&
      this.localProject !== 48
    ) {
      return this.getModuleTrend(this.moudule_list).params;
    } else {
      return this.qf_module.module?.columns;
    }
  }
  public get moudleIterationList() {
    return (this.moTreend_data as any)?.chinese;
  }
  public get stackData_obj() {
    let list = {};

    if (JSON.stringify(readGetdeepCpuStack(store)) != "{}") {
      list = readGetdeepCpuStack(store);

      // list.push({})
    }

    return list;
  }
  public get gpu_by_frame_list() {
    let list = this.qf_inside;
    let list1 = [];
    list.labels.forEach((v, index) => {
      list1.push(v.map((k) => k + "-" + index));
    });

    return list1;
  }
  public drawThreadInsideTrend() {
    let data = [];
    this.getOverviewTrend(this.overviewData).params.forEach((v, index) => {
      data.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: [],
        smooth: true, // 平滑曲线
        itemStyle: {
          normal: {
            label: {
              // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
              show: true,
            },
          },
        },
      });
    });
    data.forEach((v, index) => {
      this.getOverviewTrend(this.overviewData).series.forEach((i) => {
        v.data.push(i[index]);
      });
    });

    let performance_line: any = document.getElementById("thread_inside");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
        confine: true,
      },
      // grid: {
      //   left: "4%",
      //   right: "4%",
      //   bottom:
      //   this.getMaxLabelHeight(
      //           this.getOverviewTrend(this.overviewData).label_list
      //         ) ,

      //   top: "10%",
      //   // containLabel: true,
      // },
      grid: {
        left: "4%",
        right: "4%",
        top: "10%",
        bottom: "15%",
        containLabel: true,
      },
      // title: {
      //   left: "center",

      //   text: "日稳定包函数耗时趋势图(百分比)",
      // },

      legend: {
        bottom: 0,
        left: "center",
        orient: "horizontal",
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        name: "ms",
        //  nameLocation: "top",
        // 坐标轴名称与轴线之间的距离。
        // nameGap: 35,
        // nameRotate: 90,
        axisTick: false,
        //左侧线
        // axisLine: {
        //   show: true,
        // },
        //  splitLine: {
        //   show: true,
        // },
      },

      animation: false,
      xAxis: {
        type: "category",
        data: this.getOverviewTrend(this.overviewData).label_list,
        axisLabel: {
          formatter: function (value) {
            return value?.split("").join("\n");
          },
        },
      },

      series: data,
    });
    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    });
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = "thread_inside" + "-" + ".png";
    res.chinese = "线程局内趋势图";
    this.resBase64.push(res);
  }
  public drawThreadInsideTrendQF() {
    let data = [];
    this.qf_inside.thread.columns
      .filter((v) => v != "timeline")
      .forEach((v, index) => {
        data.push({
          name: v,
          type: "line",
          symbol: "circle", //拐点设置为实心，
          // smooth: true, // 平滑曲线
          data: this.qf_inside.thread.rows[v],
          // itemStyle: {
          //   normal: {
          //     label: {
          //       // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
          //       show: true,
          //     },
          //   },
          // },
        });
      });

    let performance_line: any = document.getElementById("thread_inside");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
        confine: true,
      },
      grid: {
        left: "4%",
        right: "4%",
        bottom:
          this.localProject == 34
            ? this.getMaxLabelHeight(this.qf_inside.thread.rows.timeline) - 100
            : "25%",
        top: "10%",
        // containLabel: true,
      },
      // title: {
      //   left: "center",

      //   text: "日稳定包函数耗时趋势图(百分比)",
      // },

      legend: {
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      dataZoom: [
        //给x轴设置滚动条
        {
          // end: 100 - 1500 / 31, //默认为100
          type: "slider",
          show: true,
          xAxisIndex: [0],
          // handleSize: 0, //滑动条的 左右2个滑动条的大小
          height: 14, //组件高度
          left: 30, //左边的距离
          right: 40, //右边的距离
          bottom: 40, //右边的距离
          handleColor: "#ddd", //h滑动图标的颜色
          handleStyle: {
            borderColor: "#cacaca",
            borderWidth: "1",
            shadowBlur: 2,
            background: "#ddd",
            shadowColor: "#ddd",
          },
          fillerColor: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
            {
              //给颜色设置渐变色 前面4个参数，给第一个设置1，第四个设置0 ，就是水平渐变
              //给第一个设置0，第四个设置1，就是垂直渐变
              offset: 0,
              color: "#1eb5e5",
            },
            {
              offset: 1,
              color: "#5ccbb1",
            },
          ]),
          backgroundColor: "#ddd", //两边未选中的滑动条区域的颜色
          showDataShadow: false, //是否显示数据阴影 默认auto
          showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
          handleIcon:
            "M-292,322.2c-3.2,0-6.4-0.6-9.3-1.9c-2.9-1.2-5.4-2.9-7.6-5.1s-3.9-4.8-5.1-7.6c-1.3-3-1.9-6.1-1.9-9.3c0-3.2,0.6-6.4,1.9-9.3c1.2-2.9,2.9-5.4,5.1-7.6s4.8-3.9,7.6-5.1c3-1.3,6.1-1.9,9.3-1.9c3.2,0,6.4,0.6,9.3,1.9c2.9,1.2,5.4,2.9,7.6,5.1s3.9,4.8,5.1,7.6c1.3,3,1.9,6.1,1.9,9.3c0,3.2-0.6,6.4-1.9,9.3c-1.2,2.9-2.9,5.4-5.1,7.6s-4.8,3.9-7.6,5.1C-285.6,321.5-288.8,322.2-292,322.2z",
          filterMode: "filter",
        },
        //下面这个属性是里面拖到
        {
          type: "inside",
          show: true,
          xAxisIndex: [0],
          disabled: true, // 禁用鼠标滚动缩放
          //  start: 0,//默认为1
          //  end: 100-1500/31,//默认为100
        },
      ],
      yAxis: {
        type: "value",
        name: "ms",
        //  nameLocation: "top",
        // 坐标轴名称与轴线之间的距离。
        // nameGap: 35,
        // nameRotate: 90,
        axisTick: false,
        //左侧线
        // axisLine: {
        //   show: true,
        // },
        //  splitLine: {
        //   show: true,
        // },
      },

      animation: false,
      xAxis: {
        type: "category",
        data: this.qf_inside.thread.rows.timeline,
      },

      series: data,
    });
    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    });
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = "thread_inside" + "-" + ".png";
    res.chinese = "线程局内趋势图";
    this.resBase64.push(res);
  }
  public name_token = ["pagezhang", "v_baofeiyan", "v_yihuideng"];
  public moudle_inside_data = [];
  public async drawModuleInsideTrend() {
    // let data = [];

    // this.getModuleTrend(this.moudule_list).params.forEach((v, index) => {
    //   data.push({
    //     name: v,
    //     type: "line",
    //     symbol: "circle", //拐点设置为实心
    //     data: [],
    //     smooth: true, // 平滑曲线
    //     itemStyle: {
    //       normal: {
    //         label: {
    //           // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
    //           show: true,
    //         },
    //       },
    //     },
    //   });
    // });

    // data.forEach((v, index) => {
    //   this.getModuleTrend(this.moudule_list).series.forEach((i) => {
    //     v.data.push(i[index]);
    //   });
    // });

    // data.forEach(v=>{
    //   v.data.forEach((m,index)=>{
    //     v.data[index] = this.formatNumber(m)

    //   })
    // })

    let performance_line: any = document.getElementById("moudle_inside");

    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
        confine: true,
      },
      // grid: {
      //   left: "4%",
      //   right: "4%",
      //   bottom:

      //      this.getMaxLabelHeight(
      //           this.getOverviewTrend(this.overviewData).label_list
      //         )
      //       ,
      //   top: "10%",
      //   // containLabel: true,
      // },
      grid: {
        left: "4%",
        right: "4%",
        top: "10%",
        bottom: "15%",
        containLabel: true,
      },
      // title: {
      //   left: "center",

      //   text: "日稳定包函数耗时趋势图(百分比)",
      // },

      legend: {
        bottom: 0,
        left: "center",
        orient: "horizontal",
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        name: "ms",
        //  nameLocation: "top",
        // 坐标轴名称与轴线之间的距离。
        // nameGap: 35,
        // nameRotate: 90,
        axisTick: false,
        //左侧线
        // axisLine: {
        //   show: true,
        // },
        //  splitLine: {
        //   show: true,
        // },
      },

      animation: false,
      xAxis: {
        type: "category",
        data: this.getOverviewTrend(this.overviewData).label_list,
        axisLabel: {
          formatter: function (value) {
            return value?.split("").join("\n");
          },
        },
      },

      series: this.moudle_inside_data,
    });
    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    });
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = "moudle_inside" + "-" + ".png";
    res.chinese = "模块局内趋势图";
    this.resBase64.push(res);
  }
  public drawModuleInsideTrendQF() {
    // let data = [];

    // this.qf_module.module?.columns
    //   .filter((v) => v != "timeline")
    //   .forEach((v, index) => {
    //     data.push({
    //       name: v,
    //       type: "line",
    //       symbol: "circle", //拐点设置为实心，
    //       // smooth: true, // 平滑曲线
    //       data: this.qf_module.module?.rows[v],
    //       // itemStyle: {
    //       //   normal: {
    //       //     label: {
    //       //       // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
    //       //       show: true,
    //       //     },
    //       //   },
    //       // },
    //     });
    //   });

    let performance_line: any = document.getElementById("moudle_inside");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
        confine: true,
      },
      grid: {
        left: "4%",
        right: "4%",
        bottom: "18%",
        top: "10%",
        // containLabel: true,
      },
      // title: {
      //   left: "center",

      //   text: "日稳定包函数耗时趋势图(百分比)",
      // },

      legend: {
        bottom: 0,
        left: "center",
        orient: "horizontal",
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      dataZoom: [
        //给x轴设置滚动条
        {
          // end: 100 - 1500 / 31, //默认为100
          type: "slider",
          show: true,
          xAxisIndex: [0],
          // handleSize: 0, //滑动条的 左右2个滑动条的大小
          height: 14, //组件高度
          left: 30, //左边的距离
          right: 40, //右边的距离
          bottom: 60, //右边的距离
          handleColor: "#ddd", //h滑动图标的颜色
          handleStyle: {
            borderColor: "#cacaca",
            borderWidth: "1",
            shadowBlur: 2,
            background: "#ddd",
            shadowColor: "#ddd",
          },
          fillerColor: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
            {
              //给颜色设置渐变色 前面4个参数，给第一个设置1，第四个设置0 ，就是水平渐变
              //给第一个设置0，第四个设置1，就是垂直渐变
              offset: 0,
              color: "#1eb5e5",
            },
            {
              offset: 1,
              color: "#5ccbb1",
            },
          ]),
          backgroundColor: "#ddd", //两边未选中的滑动条区域的颜色
          showDataShadow: false, //是否显示数据阴影 默认auto
          showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
          handleIcon:
            "M-292,322.2c-3.2,0-6.4-0.6-9.3-1.9c-2.9-1.2-5.4-2.9-7.6-5.1s-3.9-4.8-5.1-7.6c-1.3-3-1.9-6.1-1.9-9.3c0-3.2,0.6-6.4,1.9-9.3c1.2-2.9,2.9-5.4,5.1-7.6s4.8-3.9,7.6-5.1c3-1.3,6.1-1.9,9.3-1.9c3.2,0,6.4,0.6,9.3,1.9c2.9,1.2,5.4,2.9,7.6,5.1s3.9,4.8,5.1,7.6c1.3,3,1.9,6.1,1.9,9.3c0,3.2-0.6,6.4-1.9,9.3c-1.2,2.9-2.9,5.4-5.1,7.6s-4.8,3.9-7.6,5.1C-285.6,321.5-288.8,322.2-292,322.2z",
          filterMode: "filter",
        },
        //下面这个属性是里面拖到
        {
          type: "inside",
          show: true,
          xAxisIndex: [0],
          disabled: true, // 禁用鼠标滚动缩放
          //  start: 0,//默认为1
          //  end: 100-1500/31,//默认为100
        },
      ],
      yAxis: {
        type: "value",
        name: "ms",
        //  nameLocation: "top",
        // 坐标轴名称与轴线之间的距离。
        // nameGap: 35,
        // nameRotate: 90,
        axisTick: false,
        //左侧线
        // axisLine: {
        //   show: true,
        // },
        //  splitLine: {
        //   show: true,
        // },
      },

      animation: false,
      xAxis: {
        type: "category",
        data: this.qf_module.module?.rows.timeline,
      },

      series: this.moudle_inside_data,
    });
    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    });
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = "moudle_inside" + "-" + ".png";
    res.chinese = "模块局内趋势图";
    this.resBase64.push(res);
  }

  public get overList() {
    let list = [];
    if (readGetdeepCpuFunctionOverview(store).length != 0) {
      list = Object.keys(readGetdeepCpuFunctionOverview(store)[0]?.new);
    }

    return list;
  }
  public get overList_filter() {
    let obj = {};

    if (readGetdeepCpuFunctionOverview(store).length != 0) {
      obj = readGetdeepCpuFunctionOverview(store)[0]?.new;
    }
    const filteredObj: any = { ...obj };
    delete filteredObj.single_frame_time;

    const topThreeKeys = Object.entries(filteredObj)
      .sort((a: any, b: any) => b[1] - a[1])
      .slice(0, 3)
      .map((entry) => entry[0]);
    topThreeKeys.push("single_frame_time");
    return topThreeKeys; // 返回包含值最大的三个键的数组
  }
  public async cpu_trend_creat() {
    await dispatchDeepPerformanceCpuUsageTrend(store, {
      project: this.localProject,
      start: "",
      end: "",
      device_id: Number(this.dataConsumeOptions.device),
      scene_id: Number(this.dataConsumeOptions.scene),
      is_auto: this.auto_query,
      type: this.type_query,
      subtype: this.subtype_query,
    });
    this.drawCpuTrend();
  }

  public async cpu_thread_trend_creat() {
    await dispatchDeepPerformanceCpuThreadTrend(store, {
      project: this.localProject,
      start: "",
      end: "",
      device_id: Number(this.dataConsumeOptions.device),
      scene_id: Number(this.dataConsumeOptions.scene),
      id_test: this.id_test,
      is_auto: this.auto_query,
      type: this.type_query,
      subtype: this.subtype_query,
    });
    if (JSON.stringify(this.cpu_thread_trend !== "{}")) {
      if (this.cpu_thead_options?.length > 0) {
        this.cpu_thread = this.cpu_thead_options[0];

        this.drawCpu_cpu_thread_iteration();
      }

      //  await  this.cpu_thread_list()
    }

    // this.drawCpuTrend();
  }
  public drawCpuTrend_index() {
    let series = [];
    let xData = [];
    let yaxis: any = [] || {};
    this.get_cpu_trend(this.cpu_trend_data)[this.cpu_index]?.chinese.forEach(
      (v, index) => {
        series.push({
          name: v,
          type: "line",
          data: this.get_cpu_trend(this.cpu_trend_data)[this.cpu_index]?.series[
            index
          ],

          symbol: "circle", //拐点设置为实心,
          smooth: true, // 平滑曲线
          itemStyle: {
            normal: {
              label: {
                // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
                show: true,
              },
            },
          },

          // yAxisIndex: v === "avg_cpu_freq" ? 1 : 0,
        });

        xData = this.get_cpu_trend(this.cpu_trend_data)[this.cpu_index]
          ?.date_list;
        // yaxis = [
        //   {
        //     name: "",
        //     type: "value",
        //   },
        //   {
        //     type: "value",
        //     splitLine: {
        //       show: false,
        //     },
        //   },
        // ];
      }
    );
    let performance_line: any = document.getElementById("cpu");
    echarts.dispose(performance_line);
    let PerformanceLineChart = echarts.init(performance_line);
    let option;
    option = {
      color: [
        "#5470c6",
        "#91cc75",
        "#fac858",
        "#ee6666",
        "#73c0de",
        "#3ba272",
        "#fc8452",
        "#935bab",
        "#d872bc",
        "black", // 新颜色1，橙色
        "pink",
      ],
      title: {
        left: "center",
        textStyle: {
          fontSize: 16,
          fontWeight: "normal",
        },
      },
      tooltip: {
        trigger: "axis",
        confine: true,
      },
      legend: {
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "20%",
        right: "4%",
        containLabel: true,
      },

      animation: false,
      xAxis: {
        type: "category",
        data: xData,
      },
      yAxis: {
        type: "value",
      },
      series: series,
    };
    PerformanceLineChart.setOption(option);
    var res_base64 = PerformanceLineChart.getDataURL({
      excludeComponents: ["toolbox"],
    });
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = "cpu_iteration" + "-" + ".png";
    res.chinese = "CPU迭代趋势图";
    this.resBase64.push(res);
  }
  public cpu_thread_data_2_series = [];
  public cpu_thread_data_2_data = [];

  public async cpu_thread_creat() {
    await dispatchDeepPerformanceCpuCpuTrend(store, {
      project: this.localProject,
      start: "",
      end: "",
      device_id: Number(this.dataConsumeOptions.device),
      scene_id: Number(this.dataConsumeOptions.scene),
      threads: this.threadOptions,
      label: "All",
      id_test: this.id_test,
      is_auto: this.auto_query,
      type: this.type_query,
      subtype: this.subtype_query,
    });
    this.drawThreadTrend();
  }
  public get moTreend_data() {
    return readGetdeepCpuModuleTrend(store).data;
  }
  public findObjectByName(obj, targetName) {
    for (const key in obj) {
      if (obj[key].name === targetName) {
        return obj[key];
      }
    }
    return null;
  }
  public async cpu_module_creat() {
    await dispatchDeepPerformanceCpuFunctionModuleTrend(store, {
      project: this.localProject,
      start: "",
      end: "",
      device_id: Number(this.dataConsumeOptions.device),
      scene_id: Number(this.dataConsumeOptions.scene),

      label: "All",

      id_test: this.id_test,
      is_auto: this.auto_query,
      type: this.type_query,
      subtype: this.subtype_query,
    });
    this.moudle_iteration_model = this.moudleIterationList;

    this.moudle_loading = false;
  }
  public drawMoTrend() {
    let series = [];
    let indexArray = this.moudleIterationList.map((item) => {
      return this.moudle_iteration_model.indexOf(item);
    });
    indexArray.forEach((v, index) => {
      series.push({
        name: (this.moTreend_data as any).chinese[v],
        type: "line",
        symbol: "circle", //拐点设置为实心
        smooth: true, // 平滑曲线
        itemStyle: {
          normal: {
            label: {
              // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
              show: true,
            },
          },
        },
        data: (this.moTreend_data as any).series[v],
      });
    });
    let performance_line: any = document.getElementById("moudelTrand");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);

    // contrastChart.getZr().on("click", (params) =>  {
    //    var pointInPixel = [params.offsetX, params.offsetY];
    //   if (contrastChart.containPixel("grid", pointInPixel)) {
    //      var pointInGrid = contrastChart.convertFromPixel(
    //         { seriesIndex: 0 },
    //         pointInPixel
    //       );
    //       //X轴序号
    //       var xIndex = pointInGrid[0];

    //       //获取当前图表的option
    //       var op = contrastChart.getOption();
    //       console.log(op.series[0].name)
    //       //获得图表中我们想要的数据
    //       var month = op.xAxis[0].data[xIndex];
    //       var value = op.series[0].data[xIndex];
    //       console.log(month,value)
    //   }
    // })
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
        confine: true,
      },
      // title: {
      //   left: "center",

      //   text: "日稳定包函数耗时趋势图(百分比)",
      // },
      legend: {
        bottom: 0,
        left: "center",
        orient: "horizontal",
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        name: "ms",
        //  nameLocation: "top",
        // 坐标轴名称与轴线之间的距离。
        // nameGap: 35,
        // nameRotate: 90,
        axisTick: false,
        //左侧线
        // axisLine: {
        //   show: true,
        // },
        //  splitLine: {
        //   show: true,
        // },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "25%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: this.moTreend_data.date_list,
      },

      series: series,
    });
    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    });
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = "module_iteration" + "-" + ".png";
    res.chinese = "模块迭代趋势图";
    this.resBase64.push(res);
  }
  public drawCpuTrend() {
    let series = [];
    let xData = [];
    let yaxis: any = [] || {};
    this.cpuDataTrend.chinese.forEach((v, index) => {
      series.push({
        name: v,
        type: "line",
        data: this.cpuDataTrend.series[index],

        symbol: "circle", //拐点设置为实心,
        smooth: true, // 平滑曲线
        itemStyle: {
          normal: {
            label: {
              // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
              show: true,
            },
          },
        },

        yAxisIndex: v === "Freq MHz" ? 1 : 0,
        // yAxisIndex: v === "avg_cpu_freq" ? 1 : 0,
      });

      xData = this.cpuDataTrend.date_list;
      yaxis = [
        {
          name: "",
          type: "value",
        },
        {
          type: "value",
          splitLine: {
            show: false,
          },
        },
      ];
    });
    let performance_line: any = document.getElementById("cpu");
    echarts.dispose(performance_line);
    let PerformanceLineChart = echarts.init(performance_line);
    let option;
    option = {
      color: [
        "#5470c6",
        "#91cc75",
        "#fac858",
        "#ee6666",
        "#73c0de",
        "#3ba272",
        "#fc8452",
        "#935bab",
        "#d872bc",
        "black", // 新颜色1，橙色
        "pink",
      ],
      title: {
        left: "center",
        textStyle: {
          fontSize: 16,
          fontWeight: "normal",
        },
      },
      tooltip: {
        trigger: "axis",
        confine: true,
      },
      legend: {
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "20%",
        right: "4%",
        containLabel: true,
      },

      animation: false,
      xAxis: {
        type: "category",
        data: xData,
      },
      yAxis: yaxis,
      series: series,
    };
    PerformanceLineChart.setOption(option);
    var res_base64 = PerformanceLineChart.getDataURL({
      excludeComponents: ["toolbox"],
    });
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = "cpu_iteration" + "-" + ".png";
    res.chinese = "CPU迭代趋势图";
    this.resBase64.push(res);
  }
  // CPU性能局内数据
  public get cpu_inside_data() {
    let res = {
      label_list: [],
      params: [
        "avg_cpu_total",
        "avg_cpu",
        "cpu_usage_0",
        "cpu_usage_1",
        "cpu_usage_2",
        "cpu_usage_3",
        "cpu_usage_4",
        "cpu_usage_5",
        "cpu_usage_6",
        "cpu_usage_7",
        "avg_cpu_freq",
      ],
      chinese: [
        "TotalCPU[%]",
        "AppCPU[%]",
        "CPU0[%]",
        "CPU1[%]",
        "CPU2[%]",
        "CPU3[%]",
        "CPU4[%]",
        "CPU5[%]",
        "CPU6[%]",
        "CPU7[%]",
        "Freq MHz",
      ],
      series: [],
    };

    for (let cpu_usage of this.cpu_usage_data) {
      res.label_list.push(cpu_usage.label);
      let series = [];

      for (let param of res.params) {
        series.push(cpu_usage.new[param] || null);
      }
      res.series.push(series);
    }

    return res;
  }
  public b: any;
  public btnFalse = true;
  public async save_report() {
    this.btnFalse = false;
    this.edit_show_text = false;
    this.b = (this as any).$message({
      //Message 消息提示
      message: "报告发送中...",
      showClose: true,
      duration: 0,
    });
    this.edit = false;
    let upload_data: any;
    let old_test = this.versionsOldOptions.filter(
      (v) => v.chinese === this.dataConsumeOptions.old_verson
    )[0].id_test;
    this.resBase64 = [];
    this.activeName = "first";
    this.flameShow = false;
    this.flame_thread.forEach((v) => {
      let obj = (this.stackData_obj as any).children.filter(
        (child) => child.name === v
      );

      this.$nextTick(() => {
        let newObj = {
          ...this.stackData_obj,
          children: obj,
        };
        this.renderFlame("#" + this.replaceSpacesWithHyphens(v), newObj);
      });
    });
    this.cpu_activeName = "first_cpu";
    this.custom_activeName = "first_custom";
    this.thread_activeName = "first_thread";
    this.gpu_activeName = "first_gpu";
    this.activeName_moudle = "first_moudle";
    this.cpu_thread_activeName = "first_cpu_thread";
    if (this.activeName == "first") {
      await this.cpuPerfTrend_creat();
      await this.cpu_trend_creat();
      await this.cpu_thread_creat();
      await dispatchDeepPerformanceCpuThreadTrend(store, {
        project: this.localProject,
        start: "",
        end: "",
        device_id: Number(this.dataConsumeOptions.device),
        scene_id: Number(this.dataConsumeOptions.scene),
        id_test: this.id_test,
        is_auto: this.auto_query,
        type: this.type_query,
        subtype: this.subtype_query,
      });
      if (JSON.stringify(this.cpu_thread_trend !== "{}")) {
        if (this.cpu_thead_options?.length > 0) {
          this.drawCpu_cpu_thread_iteration();
        }

        //  await  this.cpu_thread_list()
      }
      // if (JSON.stringify(this.cpu_thread_by_frame) !== "{}") {
      //   this.drawCpuThreadByFrame();
      // }
      // this.moudle_iteration_model=this.moudleIterationList
      await this.cpu_module_creat();
      this.activeName = "second";
      this.cpu_activeName = "second_cpu";
      this.thread_activeName = "second_thread";
      this.gpu_activeName = "second_gpu";
      this.activeName_moudle = "second_moudle";
      this.cpu_thread_activeName = "second_cpu_thread";
    }

    this.fps_tabs_inside_show = true;
    this.fps_tabs_inside_show = true;
    this.cpu_tabs_detail_show = true;
    this.thread_tabs_detail_show = true;
    this.moudel_tabs_detail_show = true;
    if (this.activeName == "second") {
      if (this.fps_tabs_inside_show) {
        await this.fps_inside_creat();
        await this.fps_detail_creat();
        if (JSON.stringify(this.cpu_thread_trend !== "{}")) {
          if (this.cpu_thead_options?.length > 0) {
            await this.cpu_thread_list();
          }

          //  await  this.cpu_thread_list()
        }

        await this.thread_detail_creat();
        if (
          this.localProject !== 4 &&
          this.localProject !== 7 &&
          this.localProject !== 48
        ) {
          this.drawCpuInsideTrend();
          if (this.localProject != 34) {
            this.drawGpuInsideTrend();
          }

          this.drawThreadInsideTrend();
        } else {
          this.drawCpuInsideTrendQF();
          this.drawGpuInsideTrendQF();
          this.drawThreadInsideTrendQF();
        }
        // this.drawCpuInsideTrend();

        await this.moudel_detail_creat();
        if (
          this.localProject !== 4 &&
          this.localProject !== 7 &&
          this.localProject !== 48
        ) {
          this.moudle_inside_data = this.moudle_mounted().filter((item) =>
            this.moudle_model.includes(item.name)
          );
          await this.drawModuleInsideTrend();
        } else {
          this.moudle_inside_data = this.moudle_mounted_qf().filter((item) =>
            this.moudle_model.includes(item.name)
          );
          await this.drawModuleInsideTrendQF();
        }

        await this.htmlCanvas("func_trend");
        this.fps_tabs_inside_show = false;
        //             upload_data = {
        //   // project: Number(this.$route.query.project),
        //   project: this.localProject,
        //   id_test: Number(this.id_test),
        //   old_test: old_test,
        //   thread: this.trendOptions.thread,
        //   so:  this.trendOptions.so,
        //   file_list: this.resBase64,
        //   title: this.formMail.title,
        //   recv: this.formMail.addressee,
        //   cc: this.formMail.CC_List,

        //   send: this.formMail.Sender,
        // };

        // dispatchUploadCpuReport(store, upload_data)
      }
    }
    //          await   this.fps_inside_creat()
    //            await  this.fps_detail_creat()

    //         await this.thread_detail_creat()

    //          this.drawCpuInsideTrend()
    //          this.drawGpuInsideTrend()
    //            this.drawThreadInsideTrend()
    //                  await this.moudel_detail_creat()
    //          await  this.drawModuleInsideTrend()

    //             this.fps_tabs_inside_show=false

    //       this.edit = false;
    //       upload_data = {
    //         // project: Number(this.$route.query.project),
    //         project: this.localProject,
    //         id_test: Number(this.id_test),
    //         old_test: old_test,
    //         thread: this.trendOptions.thread,
    //         so:  this.trendOptions.so,
    //         file_list: this.resBase64,
    //         title: this.formMail.title,
    //         recv: this.formMail.addressee,
    //         cc: this.formMail.CC_List,

    //         send: this.formMail.Sender,
    //       };

    //       dispatchUploadCpuReport(store, upload_data)
    //          }

    //     }

    //   if(this.activeName!='first'){
    //     if(this.record.includes('second')){

    //       this.edit = false;
    //       upload_data = {
    //         // project: Number(this.$route.query.project),
    //         project: this.localProject,
    //         id_test: Number(this.id_test),
    //         old_test: old_test,
    //         thread: this.trendOptions.thread,
    //         so:  this.trendOptions.so,
    //         file_list: this.resBase64,
    //         title: this.formMail.title,
    //         recv: this.formMail.addressee,
    //         cc: this.formMail.CC_List,

    //         send: this.formMail.Sender,
    //       };

    //       dispatchUploadCpuReport(store, upload_data)
    //     }else{
    //       this.activeName='second'
    //        if(this.fps_tabs_inside_show){
    //          await   this.fps_inside_creat()
    //            await  this.fps_detail_creat()

    //         await this.thread_detail_creat()

    //          this.drawCpuInsideTrend()
    //          this.drawGpuInsideTrend()
    //            this.drawThreadInsideTrend()
    //                  await this.moudel_detail_creat()
    //          await  this.drawModuleInsideTrend()

    //             this.fps_tabs_inside_show=false

    //       this.edit = false;
    //       upload_data = {
    //         // project: Number(this.$route.query.project),
    //         project: this.localProject,
    //         id_test: Number(this.id_test),
    //         old_test: old_test,
    //         thread: this.trendOptions.thread,
    //         so:  this.trendOptions.so,
    //         file_list: this.resBase64,
    //         title: this.formMail.title,
    //         recv: this.formMail.addressee,
    //         cc: this.formMail.CC_List,

    //         send: this.formMail.Sender,
    //       };

    //       dispatchUploadCpuReport(store, upload_data)
    //          }

    //     }
    //   }else{
    //  if(this.record.includes('second')===false){
    //    this.activeName='second'
    //        if(this.fps_tabs_inside_show){
    //          await   this.fps_inside_creat()
    //            await  this.fps_detail_creat()

    //         await this.thread_detail_creat()

    //          this.drawCpuInsideTrend()
    //          this.drawGpuInsideTrend()
    //            this.drawThreadInsideTrend()
    //                  await this.moudel_detail_creat()
    //          await  this.drawModuleInsideTrend()

    //             this.fps_tabs_inside_show=false

    //       this.edit = false;
    //       upload_data = {
    //         // project: Number(this.$route.query.project),
    //         project: this.localProject,
    //         id_test: Number(this.id_test),
    //         old_test: old_test,
    //         thread: this.trendOptions.thread,
    //         so:  this.trendOptions.so,
    //         file_list: this.resBase64,
    //         title: this.formMail.title,
    //         recv: this.formMail.addressee,
    //         cc: this.formMail.CC_List,

    //         send: this.formMail.Sender,
    //       };

    //       dispatchUploadCpuReport(store, upload_data)
    //          }

    //  }
    //   }
  }
  public get gpu_inside_data() {
    let res = {
      label_list: [],
      params: this.params_gpu.map((v) => v.value),
      chinese: this.params_gpu.map((v) => v.name),
      series: [],
    };

    for (let cpu_usage of this.cpu_usage_data) {
      res.label_list.push(cpu_usage.label);
      let series = [];

      for (let param of res.params) {
        series.push(cpu_usage.new[param] || null);
      }
      res.series.push(series);
    }

    return res;
  }
  public get overviewData() {
    return readGetdeepCpuFunctionOverview(store);
  }
  // public com_color_risk_list(){
  //     let function_list_data = { new: [], old: [] };
  //   this.function_list_data.forEach((v) => {
  //     function_list_data.new.push({
  //       name: v.name,
  //       type: v.type,
  //       value: v.list[0].event_count,
  //     });
  //     function_list_data.old.push({
  //       name: v.name,
  //       type: v.type,
  //       value: v.list[0].old_event_count,
  //     });
  //   });
  //       let fpsData = this.cpu_usage_data[0];
  //   let threaData = this.overviewData[0];
  // }

  public chinese_name(data) {
    const allParams = this.params.concat(this.params_cpu, this.params_gpu);
    if (data === "single_frame_time") {
      return "单帧平均耗时(ms)";
    } else if (allParams.filter((v) => v.value == data).length > 0) {
      return allParams.filter((v) => v.value == data)[0].name;
    } else {
      return data;
    }
  }
  // 线程数据
  public getOverviewTrend(overview) {
    let res = {
      label_list: [],
      params: [],
      series: [],
    };
    for (let index = 0; index < overview.length; index++) {
      let item = overview[index];
      res.label_list.push(item.label_name);
      if (index === 0) {
        res.params = Object.keys(item.new);
      }
      let series = [];
      for (let param of res.params) {
        series.push(item.new[param] || null);
      }
      res.series.push(series);
    }

    return res;
  }
  public get customTreand() {
    return readGetdeepCpuCustomTrend(store).data;
  }
  // 迭代趋势图
  public async cpuPerfTrend_creat() {
    await dispatchDeepPerformanceCpuPerfTrend(store, {
      project: this.localProject,
      scene_id: Number(this.dataConsumeOptions.scene),
      device_id: Number(this.dataConsumeOptions.device),
    });
    // this.drawFps_fps_iteration();

    this.drawGpu_gpu_iteration();

    // if (this.localProject == 7) {
    //   await dispatchDeepPerformanceCpuCustomTrend(store, {
    //     project: this.localProject,
    //     scene_id: Number(this.dataConsumeOptions.scene),
    //     device_id: Number(this.dataConsumeOptions.device),
    //   });
    //   this.drawCustom();
    // }
  }
  public resBase64 = [];
  //
  public get cpuTrend_data() {
    return readGetdeepCpuPerfTrend(store).data;
  }
  public drawFps_fps_iteration() {
    let data = [];
    this.cpuTrend_data.fps_trend?.chinese.forEach((v, index) => {
      data.push({
        name: v,
        type: "line",
        smooth: true, // 平滑曲线
        itemStyle: {
          normal: {
            label: {
              // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
              show: true,
            },
          },
        },
        symbol: "circle", //拐点设置为实心
        data: this.cpuTrend_data.fps_trend.series[index],
        yAxisIndex: v === "FPS" ? 0 : 1,
      });
    });
    let yaxis = [
      {
        name: "",
        type: "value",
      },
      {
        type: "value",
        splitLine: {
          show: false,
        },
      },
    ];
    let performance_line: any = document.getElementById("fps_iteration");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
        confine: true,
      },
      grid: {
        left: "4%",
        right: "4%",
        bottom: "25%",
        top: "20%",
        // containLabel: true,
      },
      // title: {
      //   left: "center",

      //   text: "日稳定包函数耗时趋势图(百分比)",
      // },

      legend: {
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: yaxis,

      animation: false,
      xAxis: {
        type: "category",
        data: this.cpuTrend_data.fps_trend.date_list,
      },

      series: data,
    });
  }
  public drawCpu_cpu_thread_iteration() {
    let data = [];
    this.cpu_thread_trend[this.cpu_thread]?.params.forEach((v, index) => {
      data.push({
        name: v,
        type: "line",
        smooth: true, // 平滑曲线
        itemStyle: {
          normal: {
            label: {
              // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
              show: true,
            },
          },
        },
        symbol: "circle", //拐点设置为实心
        data: this.cpu_thread_trend[this.cpu_thread]?.series[index],
      });
    });

    let yaxis = [
      {
        name: "%",
        type: "value",
      },
    ];
    let performance_line: any = document.getElementById("cpu_thread_iteration");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
        confine: true,
      },
      grid: {
        left: "4%",
        right: "4%",
        bottom: "25%",
        top: "20%",
        // containLabel: true,
      },
      // title: {
      //   left: "center",

      //   text: "日稳定包函数耗时趋势图(百分比)",
      // },

      legend: {
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: yaxis,

      animation: false,
      xAxis: {
        type: "category",
        data: this.cpu_thread_trend[this.cpu_thread]?.date_list,
      },

      series: data,
    });
    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    });
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = "cpu_thread_iteration" + this.cpu_thread + ".png";
    res.chinese = "CPU线程占比迭代趋势";
    this.resBase64.push(res);
  }
  public drawCpu_cpu_thread_inside_2() {
    let data = this.cpu_thread_data_2_data;
    let yaxis = [
      {
        name: "%",
        type: "value",
      },
    ];
    let performance_line: any = document.getElementById("cpu_thread");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
        confine: true,
      },
      grid: {
        left: "4%",
        right: "4%",
        top: "10%",
        bottom: "15%",
        containLabel: true,
      },
      // title: {
      //   left: "center",

      //   text: "日稳定包函数耗时趋势图(百分比)",
      // },

      legend: {
        bottom: 0,
        left: "center",
        orient: "horizontal",
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: yaxis,

      animation: false,
      xAxis: {
        type: "category",
        data: this.cpu_thread_data_2_series,
        axisLabel: {
          formatter: function (value) {
            return value?.split("").join("\n");
          },
        },
      },

      series: data,
    });
    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    });
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = "cpu_thread_iteration_2" + this.cpu_thread + ".png";
    res.chinese = "CPU线程占比局内趋势";
    this.resBase64.push(res);
  }
  public drawCustom() {
    let data = [];
    this.customTreand?.chinese.forEach((v, index) => {
      data.push({
        name: v,
        type: "line",
        smooth: true, // 平滑曲线
        itemStyle: {
          normal: {
            label: {
              // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
              show: true,
            },
          },
        },
        symbol: "circle", //拐点设置为实心
        data: this.customTreand.series[index],
        yAxisIndex: v === "MaxTriangles" || v === "Triangles" ? 1 : 0,
      });
    });
    let yaxis = [
      {
        name: "",
        type: "value",
      },
      {
        type: "value",
        splitLine: {
          show: false,
        },
      },
    ];
    let performance_line: any = document.getElementById("custom");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
        confine: true,
        formatter: (params: any) => {
          {
            //  只粘贴formatter了

            let relVal = params[0].axisValueLabel;
            for (let i = 0; i < params.length; i++) {
              relVal +=
                "<div  style='display:flex;align-items:center;width:350px;justify-content: space-between;' ><div style='width:120px'>" +
                params[i].marker +
                params[i].seriesName +
                '</div><div style="font-weight:bold">' +
                (params[i].value == undefined
                  ? "-"
                  : params[i].value.toFixed(1)) + //   不同点
                "</div></div>";
            }

            return relVal;
          }
        },
      },
      grid: {
        left: "4%",
        right: "4%",
        bottom: "25%",
        top: "20%",
        // containLabel: true,
      },
      // title: {
      //   left: "center",

      //   text: "日稳定包函数耗时趋势图(百分比)",
      // },

      legend: {
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: yaxis,

      animation: false,
      xAxis: {
        type: "category",
        data: this.customTreand.date_list,
      },

      series: data,
    });
    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    });
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = "custom" + "-" + ".png";
    res.chinese = "自定义数据趋势图";
    this.resBase64.push(res);
  }
  public drawGpu_gpu_iteration() {
    let data = [];
    let check = [
      "VerticesShaded[K]",
      "FragmentsShaded[K]",
      "ReadTotal[MB]",
      "WriteTotal[MB]",
    ];
    this.cpuTrend_data.gpu_trend?.chinese.forEach((v, index) => {
      data.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: this.return_convert(
          v,
          this.cpuTrend_data.gpu_trend.series[index]
        ),
        smooth: true, // 平滑曲线
        itemStyle: {
          normal: {
            label: {
              // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
              show: true,
            },
          },
        },
        yAxisIndex: check.includes(v) ? 1 : 0,
      });
    });
    let yaxis = [
      {
        name: "ms",
        type: "value",
      },
      {
        type: "value",

        splitLine: {
          show: false,
        },
      },
    ];
    let performance_line: any = document.getElementById("gpu_iteration");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
        confine: true,
        formatter: (params: any) => {
          {
            //  只粘贴formatter了

            let relVal = params[0].axisValueLabel;
            for (let i = 0; i < params.length; i++) {
              relVal +=
                "<div  style='display:flex;align-items:center;width:350px;justify-content: space-between;' ><div style='width:120px'>" +
                params[i].marker +
                params[i].seriesName +
                '</div><div style="font-weight:bold">' +
                (params[i].value == undefined
                  ? "-"
                  : this.return_tootip(params[i].seriesName, params[i].value)) + //   不同点
                "</div></div>";
            }

            return relVal;
          }
        },
      },
      grid: {
        left: "4%",
        right: "4%",
        bottom: "25%",
        top: "20%",
        // containLabel: true,
      },
      // title: {
      //   left: "center",

      //   text: "日稳定包函数耗时趋势图(百分比)",
      // },

      legend: {
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: yaxis,

      animation: false,
      xAxis: {
        type: "category",
        data: this.cpuTrend_data.gpu_trend.date_list,
      },

      series: data,
    });
    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    });
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = "gpu_iteration" + "-" + ".png";
    res.chinese = "GPU迭代趋势图";
    this.resBase64.push(res);
  }
  // FPS_tabs切换
  public fps_tabs_inside_show = true;
  public cpu_tabs_detail_show = true;
  public thread_tabs_detail_show = true;
  public moudel_tabs_detail_show = true;
  public record = [];
  public async handleClick_fps(type) {
    this.record.push(this.activeName);
    if (type == "fps") {
      if (this.activeName == "second") {
        if (this.fps_tabs_inside_show) {
          await this.fps_inside_creat();

          // await this.fps_detail_creat();

          // await this.thread_detail_creat();

          // this.drawCpuInsideTrend();
          // this.drawGpuInsideTrend();
          // this.drawThreadInsideTrend();
          // await this.moudel_detail_creat();
          // this.drawModuleInsideTrend();
          this.fps_tabs_inside_show = false;
        }
      }
      // if (this.activeName == "third") {
      //   await this.fps_detail_creat();
      //   await this.thread_detail_creat();
      //   await this.moudel_detail_creat();
      //   this.cpu_tabs_detail_show = false;
      //   this.thread_tabs_detail_show = false;
      //   this.thread_tabs_detail_show = false;
      // }
    }
    if (type == "cpu") {
      if (this.cpu_activeName == "second_cpu") {
        this.cpu_loading = true;

        this.$nextTick(() => {
          if (
            this.localProject !== 4 &&
            this.localProject !== 7 &&
            this.localProject !== 48
          ) {
            this.drawCpuInsideTrend();
          } else {
            this.drawCpuInsideTrendQF();
          }
          this.cpu_loading = false;
        });
      }
    }
    if (type == "gpu") {
      if (this.gpu_activeName == "second_gpu") {
        this.gpu_loading = true;

        this.$nextTick(() => {
          if (
            this.localProject !== 4 &&
            this.localProject !== 7 &&
            this.localProject !== 48
          ) {
            this.drawGpuInsideTrend();
          } else {
            this.drawGpuInsideTrendQF();
          }
          this.gpu_loading = false;
        });
      }
    }
    if (type == "thread") {
      if (this.thread_activeName == "second_thread") {
        this.thread_loading = true;

        this.$nextTick(() => {
          if (
            this.localProject !== 4 &&
            this.localProject !== 7 &&
            this.localProject !== 48
          ) {
            this.drawThreadInsideTrend();
          } else {
            this.drawThreadInsideTrendQF();
          }

          this.thread_loading = false;
        });
      }
    }
    if (type == "moudle") {
      if (this.activeName_moudle == "second_moudle") {
        this.moudle_loading = true;

        this.$nextTick(() => {
          if (
            this.localProject !== 4 &&
            this.localProject !== 7 &&
            this.localProject !== 48
          ) {
            this.moudle_inside_data = this.moudle_mounted().filter((item) =>
              this.moudle_model.includes(item.name)
            );

            this.drawModuleInsideTrend();
          } else {
            this.moudle_inside_data = this.moudle_mounted_qf().filter((item) =>
              this.moudle_model.includes(item.name)
            );
            this.drawModuleInsideTrendQF();
          }
          this.moudle_loading = false;
        });
      }
    }
    if (type == "cpu_thread") {
      if (this.cpu_thread_activeName == "second_cpu_thread") {
        this.cpu_thread_list();
      }
      if (this.cpu_thread_activeName == "first_cpu_thread") {
        //  this.cpu_thead_options=Object.keys(this.cpu_thread_trend)

        this.$nextTick(() => {
          this.drawCpu_cpu_thread_iteration();
        });
      }
      if (this.cpu_thread_activeName == "third_cpu_thread") {
        this.cpu_thread_list();
      }
    }
  }
  public async cpu_thread_list() {
    let old_test = this.versionsOldOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.old_verson
    )[0].id_test;
    await dispatchDeepPerformanceCpuThreadList(store, {
      project: this.localProject,
      id_test: this.id_test,
      old_test: old_test,
    });
    this.cpu_thread_list_head();
    this.cpu_thread_list_data();

    if (this.thrad_list_data.map((v) => v.label_name).length <= 2) {
      await dispatchDeepPerformanceCputhreadByFrame(store, {
        project: this.localProject,
        id_test: this.id_test,
      });
      if (this.cpu_thread_activeName == "second_cpu_thread") {
        this.drawCpuThreadByFrame();
      }
    } else {
      this.cpu_thread_data_2_series = this.thrad_list_data.map(
        (v) => v.label_name
      );
      this.cpu_thread_data_2_data = [];
      this.thrad_list_head.forEach((v) => {
        this.cpu_thread_data_2_data.push({
          name: v,
          type: "line",
          smooth: true, // 平滑曲线
          itemStyle: {
            normal: {
              label: {
                // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
                show: true,
              },
            },
          },
          symbol: "circle", //拐点设置为实心
          data: this.thrad_list_data.map((x) => x.new[v]),
        });
      });
      this.drawCpu_cpu_thread_inside_2();
    }
  }
  public thrad_list_head = [];
  public thrad_list_data = [];
  public cpu_thread_list_head() {
    this.thrad_list_head = Object.keys(
      readGetdeepCpuThreadList(store)[this.cpu_thread][0].new
    );
  }
  public cpu_thread_list_data() {
    this.thrad_list_data = readGetdeepCpuThreadList(store)[this.cpu_thread];
  }
  // FPS详细测试数据
  public get cpu_usage_data() {
    // if(readGetdeepCpuUsageList(store).data){
    //    readGetdeepCpuUsageList(store).data[0].old.cpu_usage_0=42
    // }
    let list = [];
    list = readGetdeepCpuUsageList(store).data;
    const convertPropertiesToNumbers = (properties) => {
      return Object.fromEntries(
        Object.entries(properties).map(([key, value]) => [
          key,
          isNaN(Number(value)) ? value : Number(value),
        ])
      );
    };

    const convertedData = list?.map((item) => {
      const newProperties = convertPropertiesToNumbers(item.new);
      const oldProperties = convertPropertiesToNumbers(item.old);
      return { ...item, new: newProperties, old: oldProperties };
    });

    return convertedData;
  }
  public configuration_form = {
    scene_id: "",
    moudle: "",
  };
  public formatNumber(value) {
    // 判断值是否为空字符串
    if (value === "") {
      return value;
    }

    // 判断值是否可以转换为数字
    if (isNaN(value) || value === null) {
      return value;
    }

    const number = Number(value);

    // 判断数字是否为整数
    if (Number.isInteger(number)) {
      return number;
    }

    // 如果数字不是整数，则保留两位小数
    return number.toFixed(2);
  }

  public options_list = {};
  public options_list_name = [];
  public moudle_model = [];
  public moudle_iteration_model = [];
  public params = [
    { name: "FPS", value: "avg_fps" },
    { name: "帧率方差", value: "var_fps" },
    { name: "Jank", value: "jank" },
    { name: "BigJank", value: "big_jank" },
    { name: "Stutter%", value: "lag_pcnt" },
    { name: "低帧(<25)占比%", value: "低帧(<25)占比" },
  ];
  public com_color_risk() {
    let baseline: any = this.getThreshold(
      this.removeEmptyParentObjects(this.cpu_set_up.config),
      this.report_data_list,
      this.configuration_form.scene_id
    ).baseline;

    let threshold: any = this.getThreshold(
      this.removeEmptyParentObjects(this.cpu_set_up.config),
      this.report_data_list,
      this.configuration_form.scene_id
    ).threshold;

    let is_bad_risk = !this.getThreshold(
      this.removeEmptyParentObjects(this.cpu_set_up.config),
      this.report_data_list,
      this.configuration_form.scene_id
    ).is_bad_risk;

    let function_list_data = { new: [], old: [] };
    this.function_list_data.forEach((v) => {
      if (v.type === "module" || v.type == "function") {
        function_list_data.new.push({
          name: v.name,
          type: v.type,
          value: v.list[0].event_count,
        });
      }
    });
    this.function_list_data.forEach((v) => {
      if (v.type === "module" || v.type == "function") {
        function_list_data.old.push({
          name: v.name,
          type: v.type,
          value: v.list[0].old_event_count,
        });
      }
    });
    // 项目区分备用
    // const top5Modules =
    //   this.localProject !== 34
    //     ? JSON.parse(JSON.stringify(function_list_data.new))
    //         .sort((a, b) => b.value - a.value)
    //         .map((item) => item.name)
    //         .slice(0, 5)
    //     : function_list_data.new
    //         .filter((v) => v.type == "module")
    //         .map((v) => v.name);

    const top5Modules = JSON.parse(JSON.stringify(function_list_data.new))
      .sort((a, b) => b.value - a.value)
      .map((item) => item.name)
      .slice(0, 5);

    let list = ["FPS", "CPU", "GPU", "线程耗时(ms)", "模块函数(ms)"];
    let risk = [];

    let text = "";
    let color = "";
    list.forEach((v) => {
      risk.push({ name: v, data: [] });
    });
    // this.cpu_usage_data[0].old.fps_lt_25_pcnt = 70;
    // this.cpu_usage_data[0].old.avg_cpu_total = 70;
    let fpsData = this.cpu_usage_data[0];
    let threaData = this.overviewData[0];

    let fps_list = ["avg_fps", "jank", "var_fps"];
    let avg_list = ["avg_cpu_total", "avg_cpu"];
    let gpu_list = [
      "gpu_usage",
      "shaders_busy",
      "vertices_shaded",
      "fragments_shaded",
      "read_total",
      "write_total",
    ];

    let merge_list = [
      ...top5Modules,
      ...this.overList_filter,
      ...avg_list,
      ...gpu_list,
      ...fps_list,
    ];

    // 数据整合

    risk.forEach((item) => {
      if (item.name == "FPS") {
        let list = ["avg_fps"];
        this.params.forEach((v: any) => {
          if (list.includes(v.value)) {
            if (baseline[v.value]) {
              if (fpsData.new[v.value] < baseline[v.value]) {
                item.data.push({
                  name: v.value,
                  color: "red",
                  new: fpsData.new[v.value],
                  baseline: baseline[v.value],
                });
              } else {
                if (v.value == "avg_fps") {
                  item.data.push({
                    name: v.value,
                    color: "#00b050",
                    new: fpsData.new[v.value],
                    baseline: baseline[v.value],
                  });
                }
              }
            } else {
              if (v.value == "avg_fps") {
                item.data.push({
                  name: v.value,
                  color: "#303133",
                  new: fpsData.new[v.value],
                  baseline: baseline[v.value],
                });
              }
            }

            if (is_bad_risk) {
              if (threshold[v.value]) {
                if (v.value == "avg_fps") {
                  if (
                    Math.abs(fpsData.new[v.value] - fpsData.old[v.value]) /
                      fpsData.old[v.value] >
                    threshold[v.value]?.replace("%", "") / 100
                  ) {
                    text =
                      (fpsData.new[v.value] < fpsData.old[v.value]
                        ? "↓"
                        : "↑") +
                      Math.abs(
                        fpsData.old[v.value] - fpsData.new[v.value]
                      ).toFixed(2);
                    color =
                      fpsData.new[v.value] < fpsData.old[v.value]
                        ? "red"
                        : "#00b050";
                    item.data.push({
                      name: v.value,
                      color_new: color,
                      old: fpsData.old[v.value],
                      text:
                        fpsData.new[v.value] == fpsData.old[v.value]
                          ? "(--)"
                          : text
                          ? "(" + text + ")"
                          : "",
                    });
                  } else {
                    text =
                      (fpsData.new[v.value] < fpsData.old[v.value]
                        ? "↓"
                        : "↑") +
                      Math.abs(
                        fpsData.old[v.value] - fpsData.new[v.value]
                      ).toFixed(2);
                    color = "#303133";
                    item.data.push({
                      name: v.value,
                      color_new: color,
                      old: fpsData.old[v.value],
                      text:
                        fpsData.new[v.value] == fpsData.old[v.value]
                          ? "(--)"
                          : text
                          ? "(" + text + ")"
                          : "",
                    });
                  }
                } else {
                  if (
                    Math.abs(fpsData.new[v.value] - fpsData.old[v.value]) /
                      fpsData.old[v.value] >
                    threshold[v.value]?.replace("%", "") / 100
                  ) {
                    if (fpsData.new[v.value] < fpsData.old[v.value]) {
                      color = "red";
                      text =
                        "↓" +
                        (fpsData.old[v.value] - fpsData.new[v.value]).toFixed(
                          2
                        );
                      item.data.push({
                        name: v.value,
                        color_new: color,
                        old: fpsData.old[v.value],
                        text: "(" + text + ")",
                      });
                    }
                  }
                }
              } else {
                if (v.value == "avg_fps") {
                  text =
                    (fpsData.new[v.value] < fpsData.old[v.value] ? "↓" : "↑") +
                    Math.abs(
                      fpsData.old[v.value] - fpsData.new[v.value]
                    ).toFixed(2);
                  color = "#303133";
                  item.data.push({
                    name: v.value,
                    color_new: color,
                    old: fpsData.old[v.value],
                    text:
                      fpsData.new[v.value] == fpsData.old[v.value]
                        ? "(--)"
                        : text
                        ? "(" + text + ")"
                        : "",
                  });
                }
              }
            } else {
              if (v.value == "avg_fps") {
                text =
                  (fpsData.new[v.value] < fpsData.old[v.value] ? "↓" : "↑") +
                  Math.abs(fpsData.old[v.value] - fpsData.new[v.value]).toFixed(
                    2
                  );
                color = "#303133";
                item.data.push({
                  name: v.value,
                  color_new: color,
                  old: fpsData.old[v.value],
                  text:
                    fpsData.new[v.value] == fpsData.old[v.value]
                      ? "(--)"
                      : text
                      ? "(" + text + ")"
                      : "",
                });
              }
            }
          } else {
            if (v.value === "jank" || v.value === "var_fps") {
              if (baseline[v.value]) {
                if (fpsData.new[v.value] > baseline[v.value]) {
                  item.data.push({
                    name: v.value,
                    color: "red",
                    new: fpsData.new[v.value],
                    baseline: baseline[v.value],
                  });
                } else {
                  item.data.push({
                    name: v.value,
                    color: "#00b050",
                    new: fpsData.new[v.value],
                    baseline: baseline[v.value],
                  });
                }
              } else {
                item.data.push({
                  name: v.value,
                  color: "#303133",
                  new: fpsData.new[v.value],
                  baseline: baseline[v.value],
                });
              }
              if (is_bad_risk) {
                if (threshold[v.value]) {
                  if (
                    Math.abs(fpsData.new[v.value] - fpsData.old[v.value]) /
                      fpsData.old[v.value] >
                    threshold[v.value]?.replace("%", "") / 100
                  ) {
                    color =
                      fpsData.new[v.value] > fpsData.old[v.value]
                        ? "red"
                        : "#00b050";

                    text =
                      (fpsData.new[v.value] > fpsData.old[v.value]
                        ? "↑"
                        : "↓") +
                      Math.abs(
                        fpsData.new[v.value] - fpsData.old[v.value]
                      ).toFixed(2);

                    item.data.push({
                      name: v.value,
                      color_new: color,
                      old: fpsData.old[v.value],
                      text: "(" + text + ")",
                    });
                  } else {
                    color = "#303133";
                    text =
                      (fpsData.new[v.value] > fpsData.old[v.value]
                        ? "↑"
                        : "↓") +
                      Math.abs(
                        fpsData.new[v.value] - fpsData.old[v.value]
                      ).toFixed(2);
                    item.data.push({
                      name: v.value,
                      color_new: color,
                      old: fpsData.old[v.value],
                      text:
                        fpsData.new[v.value] === fpsData.old[v.value]
                          ? "(--)"
                          : text
                          ? "(" + text + ")"
                          : "",
                    });
                  }
                } else {
                  color = "#303133";
                  text =
                    (fpsData.new[v.value] > fpsData.old[v.value] ? "↑" : "↓") +
                    Math.abs(
                      fpsData.new[v.value] - fpsData.old[v.value]
                    ).toFixed(2);
                  item.data.push({
                    name: v.value,
                    color_new: color,
                    old: fpsData.old[v.value],
                    text:
                      fpsData.new[v.value] === fpsData.old[v.value]
                        ? "(--)"
                        : text
                        ? "(" + text + ")"
                        : "",
                  });
                }
              } else {
                color = "#303133";
                text =
                  (fpsData.new[v.value] > fpsData.old[v.value] ? "↑" : "↓") +
                  Math.abs(fpsData.new[v.value] - fpsData.old[v.value]).toFixed(
                    2
                  );
                item.data.push({
                  name: v.value,
                  color_new: color,
                  old: fpsData.old[v.value],
                  text:
                    fpsData.new[v.value] === fpsData.old[v.value]
                      ? "(--)"
                      : text
                      ? "(" + text + ")"
                      : "",
                });
              }
            } else {
              if (baseline[v.value]) {
                if (fpsData.new[v.value] > baseline[v.value]) {
                  item.data.push({
                    name: v.value,
                    color: "red",
                    new: fpsData.new[v.value],
                    baseline: baseline[v.value],
                  });
                } else {
                  item.data.push({
                    name: v.value,
                    color: "#00b050",
                    new: fpsData.new[v.value],
                    baseline: baseline[v.value],
                  });
                }
              } else {
                item.data.push({
                  name: v.value,
                  color: "#303133",
                  new: fpsData.new[v.value],
                  baseline: baseline[v.value],
                });
              }

              if (is_bad_risk) {
                if (threshold[v.value]) {
                  if (
                    Math.abs(fpsData.new[v.value] - fpsData.old[v.value]) /
                      fpsData.old[v.value] >
                    threshold[v.value]?.replace("%", "") / 100
                  ) {
                    color =
                      fpsData.new[v.value] > fpsData.old[v.value]
                        ? "red"
                        : "#00b050";
                    text =
                      (fpsData.new[v.value] > fpsData.old[v.value]
                        ? "↑"
                        : "↓") +
                      Math.abs(
                        fpsData.new[v.value] - fpsData.old[v.value]
                      ).toFixed(2);
                    item.data.push({
                      name: v.value,
                      color_new: color,
                      old: fpsData.old[v.value],
                      text: "(" + text + ")",
                    });
                  } else {
                    color = "#303133";
                    text =
                      (fpsData.new[v.value] > fpsData.old[v.value]
                        ? "↑"
                        : "↓") +
                      Math.abs(
                        fpsData.new[v.value] - fpsData.old[v.value]
                      ).toFixed(2);
                    item.data.push({
                      name: v.value,
                      color_new: color,
                      old: fpsData.old[v.value],
                      text:
                        fpsData.new[v.value] === fpsData.old[v.value]
                          ? "(--)"
                          : text
                          ? "(" + text + ")"
                          : "",
                    });
                  }
                } else {
                  color = "#303133";
                  text =
                    (fpsData.new[v.value] > fpsData.old[v.value] ? "↑" : "↓") +
                    Math.abs(
                      fpsData.new[v.value] - fpsData.old[v.value]
                    ).toFixed(2);
                  item.data.push({
                    name: v.value,
                    color_new: color,
                    old: fpsData.old[v.value],
                    text:
                      fpsData.new[v.value] === fpsData.old[v.value]
                        ? "(--)"
                        : text
                        ? "(" + text + ")"
                        : "",
                  });
                }
              }
            }
          }
        });
      }
      if (item.name == "CPU") {
        let list = ["avg_cpu_total", "avg_cpu"];

        this.params_cpu.forEach((v: any) => {
          if (list.includes(v.value)) {
            if (baseline[v.value]) {
              if (fpsData.new[v.value] > baseline[v.value]) {
                item.data.push({
                  name: v.value,
                  color:
                    fpsData.new[v.value] > baseline[v.value]
                      ? "red"
                      : "#303133",
                  new: fpsData.new[v.value],
                  baseline: baseline[v.value],
                });
              } else {
                item.data.push({
                  name: v.value,
                  color: "#00b050",
                  new: fpsData.new[v.value],
                  baseline: baseline[v.value],
                });
              }
            } else {
              item.data.push({
                name: v.value,
                color: "#303133",
                new: fpsData.new[v.value],
                baseline: baseline[v.value],
              });
            }
            if (is_bad_risk) {
              if (threshold[v.value]) {
                if (
                  Math.abs(fpsData.new[v.value] - fpsData.old[v.value]) /
                    fpsData.old[v.value] >
                  threshold[v.value]?.replace("%", "") / 100
                ) {
                  color =
                    fpsData.new[v.value] > fpsData.old[v.value]
                      ? "red"
                      : "#00b050";
                  text =
                    (fpsData.new[v.value] > fpsData.old[v.value] ? "↑" : "↓") +
                    Math.abs(
                      fpsData.new[v.value] - fpsData.old[v.value]
                    ).toFixed(2);
                  item.data.push({
                    name: v.value,
                    color_new: color,
                    old: fpsData.old[v.value],
                    text: "(" + text + ")",
                  });
                } else {
                  color = "#303133";
                  text =
                    (fpsData.new[v.value] > fpsData.old[v.value] ? "↑" : "↓") +
                    Math.abs(
                      fpsData.new[v.value] - fpsData.old[v.value]
                    ).toFixed(2);
                  item.data.push({
                    name: v.value,
                    color_new: color,
                    old: fpsData.old[v.value],
                    text:
                      fpsData.new[v.value] === fpsData.old[v.value]
                        ? "(--)"
                        : text
                        ? "(" + text + ")"
                        : "",
                  });
                }
              } else {
                color = "#303133";
                text =
                  (fpsData.new[v.value] > fpsData.old[v.value] ? "↑" : "↓") +
                  Math.abs(fpsData.new[v.value] - fpsData.old[v.value]).toFixed(
                    2
                  );
                item.data.push({
                  name: v.value,
                  color_new: color,
                  old: fpsData.old[v.value],
                  text:
                    fpsData.new[v.value] === fpsData.old[v.value]
                      ? "(--)"
                      : text
                      ? "(" + text + ")"
                      : "",
                });
              }
            } else {
              color = "#303133";
              text =
                (fpsData.new[v.value] > fpsData.old[v.value] ? "↑" : "↓") +
                Math.abs(fpsData.new[v.value] - fpsData.old[v.value]).toFixed(
                  2
                );
              item.data.push({
                name: v.value,
                color_new: color,
                old: fpsData.old[v.value],
                text:
                  fpsData.new[v.value] === fpsData.old[v.value]
                    ? "(--)"
                    : text
                    ? "(" + text + ")"
                    : "",
              });
            }
          } else {
            if (baseline[this.type_moudle(v.value)]) {
              if (fpsData.new[v.value] > baseline[this.type_moudle(v.value)]) {
                item.data.push({
                  name: v.value,
                  color: "red",
                  new: fpsData.new[v.value],
                  baseline: baseline[this.type_moudle(v.value)],
                });
              } else {
                item.data.push({
                  name: v.value,
                  color: "#00b050",
                  new: fpsData.new[v.value],
                  baseline: baseline[this.type_moudle(v.value)],
                });
              }
            } else {
              item.data.push({
                name: v.value,
                color: "#303133",
                new: fpsData.new[v.value],
                baseline: baseline[this.type_moudle(v.value)],
              });
            }
            if (is_bad_risk) {
              if (threshold[this.type_moudle(v.value)]) {
                if (
                  Math.abs(fpsData.new[v.value] - fpsData.old[v.value]) /
                    fpsData.old[v.value] >
                  threshold[this.type_moudle(v.value)]?.replace("%", "") / 100
                ) {
                  color =
                    fpsData.new[v.value] > fpsData.old[v.value]
                      ? "red"
                      : "#00b050";
                  text =
                    (fpsData.new[v.value] > fpsData.old[v.value] ? "↑" : "↓") +
                    Math.abs(
                      fpsData.new[v.value] - fpsData.old[v.value]
                    ).toFixed(2);
                  item.data.push({
                    name: v.value,
                    color_new: color,
                    old: fpsData.old[v.value],
                    text: "(" + text + ")",
                  });
                } else {
                  color = "#303133";
                  text =
                    (fpsData.new[v.value] > fpsData.old[v.value] ? "↑" : "↓") +
                    Math.abs(
                      fpsData.new[v.value] - fpsData.old[v.value]
                    ).toFixed(2);
                  item.data.push({
                    name: v.value,
                    color_new: color,
                    old: fpsData.old[v.value],
                    text:
                      fpsData.new[v.value] === fpsData.old[v.value]
                        ? "(--)"
                        : text
                        ? "(" + text + ")"
                        : "",
                  });
                }
              } else {
                color = "#303133";
                text =
                  (fpsData.new[v.value] > fpsData.old[v.value] ? "↑" : "↓") +
                  Math.abs(fpsData.new[v.value] - fpsData.old[v.value]).toFixed(
                    2
                  );
                item.data.push({
                  name: v.value,
                  color_new: color,
                  old: fpsData.old[v.value],
                  text:
                    fpsData.new[v.value] === fpsData.old[v.value]
                      ? "(--)"
                      : text
                      ? "(" + text + ")"
                      : "",
                });
              }
            }
          }
        });
      }
      if (item.name == "GPU") {
        let list = [
          "gpu_usage",
          "shaders_busy",
          "vertices_shaded",
          "fragments_shaded",
          "read_total",
          "write_total",
        ];
        this.params_gpu.forEach((v: any) => {
          if (list.includes(v.value)) {
            if (baseline[v.value]) {
              if (fpsData.new[v.value] > baseline[v.value]) {
                item.data.push({
                  name: v.value,
                  color:
                    fpsData.new[v.value] > baseline[v.value]
                      ? "red"
                      : "#303133",
                  new: fpsData.new[v.value],
                  baseline: baseline[v.value],
                });
              } else {
                item.data.push({
                  name: v.value,
                  color: "#00b050",
                  new: fpsData.new[v.value],
                  baseline: baseline[v.value],
                });
              }
            } else {
              item.data.push({
                name: v.value,
                color: "#303133",
                new: fpsData.new[v.value],
                baseline: baseline[v.value],
              });
            }
            if (is_bad_risk) {
              if (threshold[v.value]) {
                if (
                  Math.abs(fpsData.new[v.value] - fpsData.old[v.value]) /
                    fpsData.old[v.value] >
                  threshold[v.value]?.replace("%", "") / 100
                ) {
                  color =
                    fpsData.new[v.value] > fpsData.old[v.value]
                      ? "red"
                      : "#00b050";
                  text =
                    (fpsData.new[v.value] > fpsData.old[v.value] ? "↑" : "↓") +
                    Math.abs(
                      fpsData.new[v.value] - fpsData.old[v.value]
                    ).toFixed(2);
                  item.data.push({
                    name: v.value,
                    color_new: color,
                    old: fpsData.old[v.value],
                    text: "(" + text + ")",
                  });
                } else {
                  color = "#303133";
                  text =
                    (fpsData.new[v.value] > fpsData.old[v.value] ? "↑" : "↓") +
                    Math.abs(
                      fpsData.new[v.value] - fpsData.old[v.value]
                    ).toFixed(2);
                  item.data.push({
                    name: v.value,
                    color_new: color,
                    old: fpsData.old[v.value],
                    text:
                      fpsData.new[v.value] === fpsData.old[v.value]
                        ? "(--)"
                        : text
                        ? "(" + text + ")"
                        : "",
                  });
                }
              } else {
                color = "#303133";
                text =
                  (fpsData.new[v.value] > fpsData.old[v.value] ? "↑" : "↓") +
                  Math.abs(fpsData.new[v.value] - fpsData.old[v.value]).toFixed(
                    2
                  );
                item.data.push({
                  name: v.value,
                  color_new: color,
                  old: fpsData.old[v.value],
                  text:
                    fpsData.new[v.value] === fpsData.old[v.value]
                      ? "(--)"
                      : text
                      ? "(" + text + ")"
                      : "",
                });
              }
            } else {
              color = "#303133";
              text =
                (fpsData.new[v.value] > fpsData.old[v.value] ? "↑" : "↓") +
                Math.abs(fpsData.new[v.value] - fpsData.old[v.value]).toFixed(
                  2
                );
              item.data.push({
                name: v.value,
                color_new: color,
                old: fpsData.old[v.value],
                text:
                  fpsData.new[v.value] === fpsData.old[v.value]
                    ? "(--)"
                    : text
                    ? "(" + text + ")"
                    : "",
              });
            }
          } else {
            if (baseline[v.value]) {
              if (fpsData.new[v.value] > baseline[v.value]) {
                item.data.push({
                  name: v.value,
                  color: "red",
                  new: fpsData.new[v.value],
                  baseline: baseline[v.value],
                });
              } else {
                item.data.push({
                  name: v.value,
                  color: "#00b050",
                  new: fpsData.new[v.value],
                  baseline: baseline[v.value],
                });
              }
            } else {
              item.data.push({
                name: v.value,
                color: "#303133",
                new: fpsData.new[v.value],
                baseline: baseline[v.value],
              });
            }
            if (is_bad_risk) {
              if (threshold[v.value]) {
                if (
                  Math.abs(fpsData.new[v.value] - fpsData.old[v.value]) /
                    fpsData.old[v.value] >
                  threshold[v.value]?.replace("%", "") / 100
                ) {
                  color =
                    fpsData.new[v.value] > fpsData.old[v.value]
                      ? "red"
                      : "#00b050";
                  text =
                    (fpsData.new[v.value] > fpsData.old[v.value] ? "↑" : "↓") +
                    Math.abs(
                      fpsData.new[v.value] - fpsData.old[v.value]
                    ).toFixed(2);
                  item.data.push({
                    name: v.value,
                    color_new: color,
                    old: fpsData.old[v.value],
                    text: "(" + text + ")",
                  });
                } else {
                  color = "#303133";
                  text =
                    (fpsData.new[v.value] > fpsData.old[v.value] ? "↑" : "↓") +
                    Math.abs(
                      fpsData.new[v.value] - fpsData.old[v.value]
                    ).toFixed(2);
                  item.data.push({
                    name: v.value,
                    color_new: color,
                    old: fpsData.old[v.value],
                    text:
                      fpsData.new[v.value] === fpsData.old[v.value]
                        ? "(--)"
                        : text
                        ? "(" + text + ")"
                        : "",
                  });
                }
              } else {
                color = "#303133";
                text =
                  (fpsData.new[v.value] > fpsData.old[v.value] ? "↑" : "↓") +
                  Math.abs(fpsData.new[v.value] - fpsData.old[v.value]).toFixed(
                    2
                  );
                item.data.push({
                  name: v.value,
                  color_new: color,
                  old: fpsData.old[v.value],
                  text:
                    fpsData.new[v.value] === fpsData.old[v.value]
                      ? "(--)"
                      : text
                      ? "(" + text + ")"
                      : "",
                });
              }
            }
          }
        });
      }
      if (item.name == "线程耗时(ms)") {
        let list = ["single_frame_time"];

        this.overList.forEach((v: any) => {
          if (this.overList_filter.includes(v)) {
            if (baseline[this.type_moudle(v)]) {
              if (threaData.new[v] > baseline[this.type_moudle(v)]) {
                item.data.push({
                  name: v,
                  color:
                    threaData.new[v] > baseline[this.type_moudle(v)]
                      ? "red"
                      : "#303133",
                  new: threaData.new[v],
                  baseline: baseline[this.type_moudle(v)],
                });
              } else {
                item.data.push({
                  name: v,
                  color: "#00b050",
                  new: threaData.new[v],
                  baseline: baseline[this.type_moudle(v)],
                });
              }
            } else {
              item.data.push({
                name: v,
                color: "#303133",
                new: threaData.new[v],
                baseline: baseline[this.type_moudle(v)],
              });
            }
            if (is_bad_risk) {
              if (threshold[this.type_moudle(v)]) {
                if (
                  Math.abs(threaData.new[v] - threaData.old[v]) /
                    threaData.old[v] >
                  threshold[this.type_moudle(v)]?.replace("%", "") / 100
                ) {
                  color =
                    threaData.new[v] > threaData.old[v] ? "red" : "#00b050";
                  text =
                    (threaData.new[v] > threaData.old[v] ? "↑" : "↓") +
                    Math.abs(threaData.new[v] - threaData.old[v]).toFixed(2);
                  item.data.push({
                    name: v,
                    color_new: color,
                    old: threaData.old[v],
                    text: "(" + text + ")",
                  });
                } else {
                  color = "#303133";
                  text =
                    (threaData.new[v] > threaData.old[v] ? "↑" : "↓") +
                    Math.abs(threaData.new[v] - threaData.old[v]).toFixed(2);
                  item.data.push({
                    name: v,
                    color_new: color,
                    old: threaData.old[v],
                    text:
                      threaData.new[v] === threaData.old[v]
                        ? "(--)"
                        : text
                        ? "(" + text + ")"
                        : "",
                  });
                }
              } else {
                color = "#303133";
                text =
                  (threaData.new[v] > threaData.old[v] ? "↑" : "↓") +
                  Math.abs(threaData.new[v] - threaData.old[v]).toFixed(2);
                item.data.push({
                  name: v,
                  color_new: color,
                  old: threaData.old[v],
                  text:
                    threaData.new[v] === threaData.old[v]
                      ? "(--)"
                      : text
                      ? "(" + text + ")"
                      : "",
                });
              }
            } else {
              color = "#303133";
              text =
                (threaData.new[v] > threaData.old[v] ? "↑" : "↓") +
                Math.abs(threaData.new[v] - threaData.old[v]).toFixed(2);
              item.data.push({
                name: v,
                color_new: color,
                old: threaData.old[v],
                text:
                  threaData.new[v] === threaData.old[v]
                    ? "(--)"
                    : text
                    ? "(" + text + ")"
                    : "",
              });
            }
          } else {
            if (baseline[this.type_moudle(v)]) {
              if (threaData.new[v] > baseline[this.type_moudle(v)]) {
                item.data.push({
                  name: v,
                  color: "red",
                  new: threaData.new[v],
                  baseline: baseline[this.type_moudle(v)],
                });
              } else {
                item.data.push({
                  name: v,
                  color: "#00b050",
                  new: threaData.new[v],
                  baseline: baseline[this.type_moudle(v)],
                });
              }
            } else {
              item.data.push({
                name: v,
                color: "#303133",
                new: threaData.new[v],
                baseline: baseline[this.type_moudle(v)],
              });
            }
            if (is_bad_risk) {
              if (threshold[this.type_moudle(v)]) {
                if (
                  Math.abs(threaData.new[v] - threaData.old[v]) /
                    threaData.old[v] >
                  threshold[this.type_moudle(v)]?.replace("%", "") / 100
                ) {
                  color =
                    threaData.new[v] > threaData.old[v] ? "red" : "#00b050";
                  text =
                    (threaData.new[v] > threaData.old[v] ? "↑" : "↓") +
                    Math.abs(threaData.new[v] - threaData.old[v]).toFixed(2);
                  item.data.push({
                    name: v,
                    color_new: color,
                    old: threaData.old[v],
                    text: "(" + text + ")",
                  });
                } else {
                  color = "#303133";
                  text =
                    (threaData.new[v] > threaData.old[v] ? "↑" : "↓") +
                    Math.abs(threaData.new[v] - threaData.old[v]).toFixed(2);
                  item.data.push({
                    name: v,
                    color_new: color,
                    old: threaData.old[v],
                    text:
                      threaData.new[v] === threaData.old[v]
                        ? "(--)"
                        : text
                        ? "(" + text + ")"
                        : "",
                  });
                }
              } else {
                color = "#303133";
                text =
                  (threaData.new[v] > threaData.old[v] ? "↑" : "↓") +
                  Math.abs(threaData.new[v] - threaData.old[v]).toFixed(2);
                item.data.push({
                  name: v,
                  color_new: color,
                  old: threaData.old[v],
                  text:
                    threaData.new[v] === threaData.old[v]
                      ? "(--)"
                      : text
                      ? "(" + text + ")"
                      : "",
                });
              }
            }
          }
        });
      }
      if (item.name == "模块函数(ms)") {
        function_list_data.new.forEach((v, index) => {
          if (this.localProject) {
            if (top5Modules.includes(v.name)) {
              if (baseline[this.type_moudle(v.type)]) {
                if (v.value > baseline[this.type_moudle(v.type)]) {
                  item.data.push({
                    name: v.name,
                    color: "red",
                    new: String(v.value),
                    baseline: baseline[this.type_moudle(v.type)],
                  });
                } else {
                  item.data.push({
                    name: v.name,
                    color: "#00b050",
                    new: String(v.value),
                    baseline: baseline[this.type_moudle(v.type)],
                  });
                }
              } else {
                item.data.push({
                  name: v.name,
                  color: "#303133",
                  new: String(v.value),
                  baseline: baseline[this.type_moudle(v.type)],
                });
              }
              if (is_bad_risk) {
                if (threshold[this.type_moudle(v.type)]) {
                  if (
                    Math.abs(v.value - function_list_data.old[index].value) /
                      function_list_data.old[index].value >
                    threshold[this.type_moudle(v.type)]?.replace("%", "") / 100
                  ) {
                    color =
                      v.value > function_list_data.old[index].value
                        ? "red"
                        : "#00b050";
                    text =
                      (v.value > function_list_data.old[index].value
                        ? "↑"
                        : "↓") +
                      Math.abs(
                        v.value - function_list_data.old[index].value
                      ).toFixed(2);
                    item.data.push({
                      name: v.name,
                      color_new: color,
                      old: function_list_data.old[index].value,
                      text: "(" + text + ")",
                    });
                  } else {
                    color = "#303133";
                    text =
                      (v.value > function_list_data.old[index].value
                        ? "↑"
                        : "↓") +
                      Math.abs(
                        v.value - function_list_data.old[index].value
                      ).toFixed(2);
                    item.data.push({
                      name: v.name,
                      color_new: color,
                      old: function_list_data.old[index].value,
                      text:
                        v.value == function_list_data.old[index].value
                          ? "(--)"
                          : text
                          ? "(" + text + ")"
                          : "",
                    });
                  }
                } else {
                  color = "#303133";
                  text =
                    (v.value > function_list_data.old[index].value
                      ? "↑"
                      : "↓") +
                    Math.abs(
                      v.value - function_list_data.old[index].value
                    ).toFixed(2);
                  item.data.push({
                    name: v.name,
                    color_new: color,
                    old: function_list_data.old[index].value,
                    text:
                      v.value == function_list_data.old[index].value
                        ? "(--)"
                        : text
                        ? "(" + text + ")"
                        : "",
                  });
                }
              } else {
                color = "#303133";
                text =
                  (v.value > function_list_data.old[index].value ? "↑" : "↓") +
                  Math.abs(
                    v.value - function_list_data.old[index].value
                  ).toFixed(2);
                item.data.push({
                  name: v.name,
                  color_new: color,
                  old: function_list_data.old[index].value,
                  text:
                    v.value == function_list_data.old[index].value
                      ? "(--)"
                      : text
                      ? "(" + text + ")"
                      : "",
                });
              }
            } else {
              if (baseline[this.type_moudle(v.type)]) {
                if (this.type_moudle(v.type) == "module") {
                  if (v.value > baseline[this.type_moudle(v.type)]) {
                    item.data.push({
                      name: v.name,
                      color: "red",
                      new: String(v.value),
                      baseline: baseline[this.type_moudle(v.type)],
                    });
                  } else {
                    item.data.push({
                      name: v.name,
                      color: "#00b050",
                      new: String(v.value),
                      baseline: baseline[this.type_moudle(v.type)],
                    });
                  }
                }
              } else {
                if (this.type_moudle(v.type) == "module") {
                  item.data.push({
                    name: v.name,
                    color: "#303133",
                    new: String(v.value),
                    baseline: baseline[this.type_moudle(v.type)],
                  });
                }
              }
              if (is_bad_risk) {
                if (threshold[this.type_moudle(v.type)]) {
                  // console.log(threshold[v.value].split['%'])
                  if (this.type_moudle(v.type) == "module") {
                    if (
                      Math.abs(v.value - function_list_data.old[index].value) /
                        function_list_data.old[index].value >
                      threshold[this.type_moudle(v.type)]?.replace("%", "") /
                        100
                    ) {
                      color =
                        v.value > function_list_data.old[index].value
                          ? "red"
                          : "#00b050";
                      text =
                        (v.value > function_list_data.old[index].value
                          ? "↑"
                          : "↓") +
                        Math.abs(
                          v.value - function_list_data.old[index].value
                        ).toFixed(2);
                      // color = "red";
                      // text =
                      //   "↑" +
                      //   (v.value - function_list_data.old[index].value).toFixed(
                      //     2
                      //   );

                      item.data.push({
                        name: v.name,
                        color_new: color,
                        old: function_list_data.old[index].value,
                        text: "(" + text + ")",
                      });
                    } else {
                      color = "#303133";
                      text =
                        (v.value > function_list_data.old[index].value
                          ? "↑"
                          : "↓") +
                        Math.abs(
                          v.value - function_list_data.old[index].value
                        ).toFixed(2);
                      // color = "red";
                      // text =
                      //   "↑" +
                      //   (v.value - function_list_data.old[index].value).toFixed(
                      //     2
                      //   );

                      item.data.push({
                        name: v.name,
                        color_new: color,
                        old: function_list_data.old[index].value,
                        text:
                          v.value == function_list_data.old[index].value
                            ? "(--)"
                            : text
                            ? "(" + text + ")"
                            : "",
                      });
                    }
                  }
                } else {
                  if (this.type_moudle(v.type) == "module") {
                    color = "#303133";
                    text =
                      (v.value > function_list_data.old[index].value
                        ? "↑"
                        : "↓") +
                      Math.abs(
                        v.value - function_list_data.old[index].value
                      ).toFixed(2);
                    // color = "red";
                    // text =
                    //   "↑" +
                    //   (v.value - function_list_data.old[index].value).toFixed(
                    //     2
                    //   );

                    item.data.push({
                      name: v.name,
                      color_new: color,
                      old: function_list_data.old[index].value,
                      text:
                        v.value == function_list_data.old[index].value
                          ? "(--)"
                          : text
                          ? "(" + text + ")"
                          : "",
                    });
                  }
                }
              }
            }
          }
          // 项目区分备用
          // else {
          //   if (v.type == "module") {
          //     if (baseline[this.type_moudle(v.type)]) {
          //       if (v.value > baseline[this.type_moudle(v.type)]) {
          //         item.data.push({
          //           name: v.name,
          //           color: "red",
          //           new: String(v.value),
          //           baseline: baseline[this.type_moudle(v.type)],
          //         });
          //       } else {
          //         item.data.push({
          //           name: v.name,
          //           color: "#303133",
          //           new: String(v.value),
          //           baseline: baseline[this.type_moudle(v.type)],
          //         });
          //       }
          //     } else {
          //       item.data.push({
          //         name: v.name,
          //         color: "#303133",
          //         new: String(v.value),
          //         baseline: baseline[this.type_moudle(v.type)],
          //       });
          //     }
          //     if (is_bad_risk) {
          //       if (threshold[this.type_moudle(v.type)]) {
          //         if (
          //           Math.abs(v.value - function_list_data.old[index].value) /
          //             function_list_data.old[index].value >
          //           threshold[this.type_moudle(v.type)]?.replace("%", "") / 100
          //         ) {
          //           color =
          //             v.value > function_list_data.old[index].value
          //               ? "red"
          //               : "#00b050";
          //           text =
          //             (v.value > function_list_data.old[index].value
          //               ? "↑"
          //               : "↓") +
          //             Math.abs(
          //               v.value - function_list_data.old[index].value
          //             ).toFixed(2);
          //           item.data.push({
          //             name: v.name,
          //             color_new: color,
          //             old: function_list_data.old[index].value,
          //             text: "(" + text + ")",
          //           });
          //         } else {
          //           color = "#303133";
          //           text =
          //             (v.value > function_list_data.old[index].value
          //               ? "↑"
          //               : "↓") +
          //             Math.abs(
          //               v.value - function_list_data.old[index].value
          //             ).toFixed(2);
          //           item.data.push({
          //             name: v.name,
          //             color_new: color,
          //             old: function_list_data.old[index].value,
          //             text:
          //               v.value == function_list_data.old[index].value
          //                 ? "(--)"
          //                 : text
          //                 ? "(" + text + ")"
          //                 : "",
          //           });
          //         }
          //       } else {
          //         color = "#303133";
          //         text =
          //           (v.value > function_list_data.old[index].value
          //             ? "↑"
          //             : "↓") +
          //           Math.abs(
          //             v.value - function_list_data.old[index].value
          //           ).toFixed(2);
          //         item.data.push({
          //           name: v.name,
          //           color_new: color,
          //           old: function_list_data.old[index].value,
          //           text:
          //             v.value == function_list_data.old[index].value
          //               ? "(--)"
          //               : text
          //               ? "(" + text + ")"
          //               : "",
          //         });
          //       }
          //     } else {
          //       color = "#303133";
          //       text =
          //         (v.value > function_list_data.old[index].value ? "↑" : "↓") +
          //         Math.abs(
          //           v.value - function_list_data.old[index].value
          //         ).toFixed(2);
          //       item.data.push({
          //         name: v.name,
          //         color_new: color,
          //         old: function_list_data.old[index].value,
          //         text:
          //           v.value == function_list_data.old[index].value
          //             ? "(--)"
          //             : text
          //             ? "(" + text + ")"
          //             : "",
          //       });
          //     }
          //   }
          // }
        });
      }
    });

    // 合并
    risk.forEach((item) => {
      const mergedData = {};
      item.data.forEach((dataItem) => {
        if (!mergedData[dataItem.name]) {
          mergedData[dataItem.name] = dataItem;
        } else {
          mergedData[dataItem.name] = {
            ...mergedData[dataItem.name],
            ...dataItem,
          };
        }
      });
      item.data = Object.values(mergedData);
    });
    // console.log(risk);
    let hasHighRisk = risk.some((item) =>
      item.data.some(
        (dataItem) => dataItem.color === "red" || dataItem.color_new == "red"
      )
    );

    this.risk = hasHighRisk ? "高风险" : "低风险";
    // console.log(this.risk_list)

    for (let i = 0; i < risk.length; i++) {
      let data = risk[i].data;
      for (let j = 0; j < data.length; j++) {
        let item = data[j];

        if (!merge_list.includes(item.name)) {
          data.splice(j, 1);
          j--;
        }
      }
    }

    risk.forEach((v) => {
      v.data.forEach((m) => {
        m.new = this.formatNumber(m.new);
        m.text = "(" + this.formatNumber(m.text.match(/\(([^)]*)\)/)[1]) + ")";
      });
    });
    this.risk_list = risk;
    if (this.add_problem) {
      this.table_test_overview = [];
      // this.table_test_overview.push(
      //   {
      //     model:
      //       this.report_data_list?.device_level +
      //       "-" +
      //       this.report_data_list?.device_name,
      //     scene: this.report_data_list?.scene,
      //     risk: this.risk,
      //     index_name: "",
      //     index_detail: "",
      //     index_detail_name: "",
      //     value: "对比上版本",
      //   },
      //   {
      //     model:
      //       this.report_data_list?.device_level +
      //       "-" +
      //       this.report_data_list?.device_name,
      //     scene: this.report_data_list?.scene,
      //     risk: this.risk,
      //     index_name: "核心指标",
      //     index_detail: "核心指标",
      //     index_detail_name: "AvgFps",
      //     value: this.risk_list[0].data[0].new,
      //     color: this.risk_list[0].data[0].color,
      //     color_new: this.risk_list[0].data[0].color_new,
      //     text: this.risk_list[0].data[0].text,
      //     edit: false,
      //     edit_vale: false,
      //   }
      // );
      this.risk_list.forEach((v) => {
        v.data.forEach((k) => {
          this.table_test_overview.push({
            model:
              this.report_data_list?.device_level +
              "-" +
              this.report_data_list?.device_name,
            scene: this.report_data_list?.scene,
            risk: this.risk,
            index_name: "异常细分指标",
            index_detail: v.name,
            index_detail_name: this.chinese_name(k.name),
            value: k.new,
            color: k.color,

            color_new: k.color_new,
            text: k.text,
            edit: false,

            edit_vale: false,
          });
        });
      });
      // this.table_test_overview.push({
      //   model:
      //     this.report_data_list?.device_level +
      //     "-" +
      //     this.report_data_list?.device_name,
      //   scene: this.report_data_list?.scene,
      //   risk: this.risk,
      //   index_name: "",
      //   index_detail: "",
      //   index_detail_name: "",
      //   value: "对比整局平均",
      // });
    } else {
      console.log(2);
      //       for (let i = 0; i < this.table_test_overview.length; i++) {
      //   if (this.table_test_overview[i].index_name === '重点卡顿问题') {
      //    this.table_test_overview.splice(i, 1);
      //     i--; // 回退一步，因为数组长度已减少
      //   }
      //   if(this.table_test_overview[this.table_test_overview.length-1].value!=='对比整局平均'){
      //         this.table_test_overview.push({
      //       model:
      //         this.report_data_list?.device_level +
      //         "-" +
      //         this.report_data_list?.device_name,
      //       scene: this.report_data_list?.scene,
      //       risk: this.risk,
      //       index_name: "",
      //       index_detail: "",
      //       index_detail_name: "",
      //       value: "对比整局平均",
      //     });
      //      }

      // }
    }
    // this.table_test_overview = [];
    // this.table_test_overview.push(
    //   {
    //     model:
    //       this.report_data_list?.device_level +
    //       "-" +
    //       this.report_data_list?.device_name,
    //     scene: this.report_data_list?.scene,
    //     risk: this.risk,
    //     index_name: "",
    //     index_detail: "",
    //     index_detail_name: "",
    //     value: "对比上版本",
    //   },
    //   {
    //     model:
    //       this.report_data_list?.device_level +
    //       "-" +
    //       this.report_data_list?.device_name,
    //     scene: this.report_data_list?.scene,
    //     risk: this.risk,
    //     index_name: "核心指标",
    //     index_detail: "核心指标",
    //     index_detail_name: "AvgFps",
    //     value: this.risk_list[0].data[0].new,
    //     color: this.risk_list[0].data[0].color,
    //     color_new: this.risk_list[0].data[0].color_new,
    //     text: this.risk_list[0].data[0].text,
    //     edit: false,
    //     edit_vale: false,
    //   }
    // );
    // this.risk_list.forEach((v) => {
    //   v.data.forEach((k) => {
    //     this.table_test_overview.push({
    //       model:
    //         this.report_data_list?.device_level +
    //         "-" +
    //         this.report_data_list?.device_name,
    //       scene: this.report_data_list?.scene,
    //       risk: this.risk,
    //       index_name: "异常细分指标",
    //       index_detail: v.name,
    //       index_detail_name: k.name,
    //       value: k.new,
    //       color: k.color,

    //       color_new: k.color_new,
    //       text: k.text,
    //       edit: false,

    //       edit_vale: false,
    //     });
    //   });
    // });
    // this.table_test_overview.push({
    //   model:
    //     this.report_data_list?.device_level +
    //     "-" +
    //     this.report_data_list?.device_name,
    //   scene: this.report_data_list?.scene,
    //   risk: this.risk,
    //   index_name: "",
    //   index_detail: "",
    //   index_detail_name: "",
    //   value: "对比整局平均",
    // });
    // let fps_problem = [];
    // this.fps_top.forEach((v) =>

    //  { v.index_name="FPS";
    //     v.top
    //     .filter((m) => m.color == "red" || m.color_new == "red")
    //     .forEach((k) => {
    //       k.timeline = v.time;
    //      k.index_name=v.index_name
    //       fps_problem.push(k);
    //     })
    //  }
    // );

    // let cpu_problem = [];
    // //  this.top_cpu.filter(
    // //   (v) => v.color == "red" || v.color_new == "red"
    // // );
    // this.top_cpu.forEach((v) =>
    //  {
    //       v.index_name = "CPU";
    //     v.top
    //     .filter((m) => m.color == "red" || m.color_new == "red")
    //     .forEach((k) => {
    //       k.timeline = v.time;
    //    k.index_name=v.index_name
    //       cpu_problem.push(k);
    //     })
    //  }
    // );
    // let gpu_problem = [];
    // this.top_gpu.forEach((v) =>{
    //       v.index_name = "GPU";
    //     v.top
    //     .filter((m) => m.color == "red" || m.color_new == "red")
    //     .forEach((k) => {
    //       k.timeline = v.time;
    //       k.index_name=v.index_name
    //       gpu_problem.push(k);
    //     })
    // }

    // );
    // let thread_problem = [];
    // //    this.top_thread_3.filter(
    // //   (v) => v.color == "red" || v.color_new == "red"
    // // );
    // this.top_thread_3.forEach((v) =>{
    //     v.index_name = "线程耗时(ms)";
    //    v.top
    //     .filter((m) => m.color == "red" || m.color_new == "red")
    //     .forEach((k) => {
    //       k.timeline = v.time;
    //      k.index_name=v.index_name
    //       thread_problem.push(k);
    //     })
    // }

    // );
    // let module_problem = [];
    // //  this.top_moudle_5.filter(
    // //   (v) => v.color == "red" || v.color_new == "red"
    // // );
    // this.top_moudle_5.forEach((v) =>
    // {
    //     v.index_name = "模块函数(ms)";
    //     v.top
    //     .filter((m) => m.color == "red" || m.color_new == "red")
    //     .forEach((k) => {
    //       k.timeline = v.time;
    //      k.index_name=v.index_name
    //       module_problem.push(k);
    //     })
    // }
    // );

    // for(let i in this.frameProblem){
    //   this.options_list[i]={}
    //   list.forEach(v=>{
    //     if(v==='FPS'){
    //       this.options_list[i][v]=this.fps_top.filter(n=>i==n.time)[0].top
    //     }
    //     if(v==='CPU'){
    //       this.options_list[i][v]=this.top_cpu.filter(n=>i==n.time)[0].top
    //     }
    //     if(v==='GPU'){
    //       this.options_list[i][v]=this.top_gpu.filter(n=>i==n.time)[0].top
    //     }
    //     if(v==='线程耗时(ms)'){
    //       this.options_list[i][v]=this.top_thread_3.filter(n=>i==n.time)[0].top
    //     }
    //     if(v==='模块函数(ms)'){
    //       console.log(33333)
    //       this.options_list[i][v]=this.top_moudle_5.filter(n=>i==n.time)[0].top
    //     }

    //   })
    // }
    // this.important_options={...this.options_list}
    // for(let i in this.options_list){
    //   for(let n in this.options_list[i]){
    //     this.options_list[i][n].filter((m) => m.color == "red" || m.color_new == "red").forEach(x=>{
    //       this.table_test_overview_important.push({
    //     model:
    //       this.report_data_list?.device_level +
    //       "-" +
    //       this.report_data_list?.device_name,
    //     scene: this.report_data_list?.scene,
    //     risk: this.risk,
    //     index_name:i,
    //     index_detail: x.index_name,
    //     index_detail_name: this.chinese_name(x.name),
    //     value: x.value,
    //     color: x.color,

    //     color_new: x.color_new,
    //     text: x.text,
    //     edit:false,
    //     edit_name: false,
    //     edit_vale: false,
    //     edit_detail: false,
    //   })
    //     })
    //   }
    // }

    // let merge_problem = [
    //   ...fps_problem,
    //   ...cpu_problem,
    //   ...gpu_problem,
    //   ...thread_problem,
    //   ...module_problem,
    // ];

    // merge_problem.sort((a, b) => {
    //   if (a.timeline < b.timeline) {
    //     return -1;
    //   }
    //   if (a.timeline > b.timeline) {
    //     return 1;
    //   }
    //   return 0;
    // });
    // this.table_test_overview_important = [];
    // console.log(merge_problem)
    // merge_problem.forEach((v) => {
    //   this.table_test_overview_important.push({
    //     model:
    //       this.report_data_list?.device_level +
    //       "-" +
    //       this.report_data_list?.device_name,
    //     scene: this.report_data_list?.scene,
    //     risk: this.risk,
    //     index_name: v.timeline,
    //     index_detail: v.index_name,
    //     index_detail_name: this.chinese_name(v.name),
    //     value: v.value,
    //     color: v.color,

    //     color_new: v.color_new,
    //     text: v.text,
    //     edit: v.edit,
    //     edit_name: false,
    //     edit_vale: false,
    //     edit_detail: false,
    //   });
    // });

    // cpu_problem.forEach((v) => {
    //   this.table_test_overview.push({
    //     model:
    //       this.report_data_list?.device_level +
    //       "-" +
    //       this.report_data_list?.device_name,
    //     scene: this.report_data_list?.scene,
    //     risk: this.risk,
    //     index_name: "重点卡顿问题",
    //     index_detail: v.timeline,
    //     index_detail_name: v.name,
    //     value: v.value + v.text,
    //   });
    // });
    // gpu_problem.forEach((v) => {
    //   this.table_test_overview.push({
    //     model:
    //       this.report_data_list?.device_level +
    //       "-" +
    //       this.report_data_list?.device_name,
    //     scene: this.report_data_list?.scene,
    //     risk: this.risk,
    //     index_name: "重点卡顿问题",
    //     index_detail: v.timeline,
    //     index_detail_name: v.name,
    //     value: v.value + v.text,
    //   });
    // });
    //    thread_problem.forEach((v) => {
    //   this.table_test_overview.push({
    //     model:
    //       this.report_data_list?.device_level +
    //       "-" +
    //       this.report_data_list?.device_name,
    //     scene: this.report_data_list?.scene,
    //     risk: this.risk,
    //     index_name: "重点卡顿问题",
    //     index_detail: v.timeline,
    //     index_detail_name: v.name,
    //     value: v.value + v.text,
    //   });
    // });
    // module_problem.forEach((v) => {
    //   this.table_test_overview.push({
    //     model:
    //       this.report_data_list?.device_level +
    //       "-" +
    //       this.report_data_list?.device_name,
    //     scene: this.report_data_list?.scene,
    //     risk: this.risk,
    //     index_name: "重点卡顿问题",
    //     index_detail: v.timeline,
    //     index_detail_name: v.name,
    //     value: v.value + v.text,
    //   });
    // });

    // if (merge_problem.length == 0) {
    //   if (
    //     this.table_test_overview.filter((v) => v.value == "对比整局平均")
    //       .length > 0
    //   ) {
    //     this.table_test_overview.pop();
    //   }
    // }
    this.clearRowspan(this.table_test_overview);
    this.clearRowspan(this.table_test_overview_important);
    this.table_test_overview.forEach((v, index) => {
      if (index == 0) {
        v.rowspan = this.table_test_overview.length;
      }
    });

    let list1 = [
      { index_name: 2, index_detail: 4, index_detail_name: 7 },
      { index_name: 2, index_detail: 4, index_detail_name: 7 },
      { index_name: 2, index_detail: 4, index_detail_name: 7 },
      { index_name: 2, index_detail: 5, index_detail_name: 7 },
      { index_name: 2, index_detail: 5, index_detail_name: 7 },
      { index_name: 2, index_detail: 5, index_detail_name: 7 },
      { index_name: 2, index_detail: 5, index_detail_name: 7 },
      { index_name: 2, index_detail: 5, index_detail_name: 7 },
      { index_name: 4, index_detail: 12, index_detail_name: 7 },
      { index_name: 4, index_detail: 13, index_detail_name: 7 },
    ];
    this.mergeRows(this.table_test_overview);
    this.mergeRows(this.table_test_overview_important);
    // this.addColspan(this.table_test_overview);
    // this.addColspan(this.table_test_overview_important);
  }
  public table_test_overview = [];
  public table_test_overview_important = [];
  public get details_list() {
    let list: any = [];
    list = [
      { label: "func_name", prop: "name" },
      { label: "Time(ms)", prop: "value" },
      { label: "Time(%)", prop: "rate" },
    ];
    return list;
  }

  public get stackData() {
    let list = [];
    let list1 = [];

    if (JSON.stringify(readGetdeepCpuStack(store)) != "{}") {
      list.push({});
      list[0] = JSON.parse(JSON.stringify(readGetdeepCpuStack(store)));

      list.forEach((v) => {
        if (v.children.length > 0) {
          v.is_expand = true;
        } else {
          v.is_expand = false;
        }
      });
      list.map((e) => {
        delete e.children;
      });
      // list[0].is_expand=true
      list1.push(readGetdeepCpuStack(store));
      // list.push({})
    }

    return list;
  }
  public stack_data(data) {
    let list = [];
    list.push({});
    list[0] = JSON.parse(JSON.stringify(data));
    list.forEach((item) => {
      this.addCheckProperty(item);
    });

    return list;
  }
  public addCheckProperty(obj) {
    if (obj.id) {
      obj.check = false;
    }

    if (Array.isArray(obj.children)) {
      obj.children.forEach((child) => {
        this.addCheckProperty(child);
      });
    }
  }
  public updateCheckProperty(obj, idArray) {
    if (obj.id) {
      obj.check = idArray.some((item) => item.name === obj.name);
    }

    if (Array.isArray(obj.children)) {
      obj.children.forEach((child) => {
        this.updateCheckProperty(child, idArray);
      });
    }
  }
  public tree_func() {
    this.stackData_all = this.stack_data(this.stackData_obj);

    this.stackData_all.forEach((v) => {
      this.updateCheckProperty(v, this.series_list);
    });
  }
  public operateShow = false;
  public operateModule = 1;
  public num_table = 0;
  public overviewShow = false;
  public operate(item, i) {
    if (item.index_name == "异常细分指标") {
      this.table_test_overview.splice(i, 1);
      //  if(this.table_test_overview[this.table_test_overview.length-1].value=='对比整局平均'){
      //    this.table_test_overview.pop()
      //  }
      //   this.clearRowspan(this.table_test_overview);
      //   this.table_test_overview.forEach((v, index) => {
      //     if (index == 0) {
      //       v.rowspan = this.table_test_overview.length;
      //     }
      //   });
      this.mergeRows(this.table_test_overview);

      // this.addColspan(this.table_test_overview);
    } else if (item == "重点问题卡顿") {
      this.table_test_overview_important.splice(i, 1);
      //  if(this.table_test_overview[this.table_test_overview.length-1].value=='对比整局平均'){
      //    this.table_test_overview.pop()
      //  }
      //   this.clearRowspan(this.table_test_overview);
      //   this.table_test_overview.forEach((v, index) => {
      //     if (index == 0) {
      //       v.rowspan = this.table_test_overview.length;
      //     }
      //   });
      this.mergeRows(this.table_test_overview_important);

      // this.addColspan(this.table_test_overview);
    } else if (item == "add") {
      this.overviewShow = true;
      this.risk_type_new = Object.keys(this.options_list);
      this.overview.risk = "";
      this.overview.type = "";
      this.overview.term = "";
      this.operateShow = true;
    } else {
      this.overview.risk = "";
      this.overview.type = "";
      this.overview.term = "";
      this.operateShow = true;

      this.overviewShow = false;
    }
  }
  public overview = {
    risk: "",
    type: "",
    term: "",
  };
  public get risk_type() {
    return this.options_list_name;
  }
  public get indicator_type() {
    let list = [];

    if (this.overviewShow) {
      if (this.overview.risk) {
        list = Object.keys(this.options_list[this.overview.risk]);
      } else {
        list = [];
      }
    } else {
      list = ["FPS", "CPU", "GPU", "线程耗时(ms)", "模块函数(ms)"];
    }
    return list;
  }
  // 查找索引
  public findLastIndexOfStringInIndexName(list, findString, searchString) {
    let lastIndex = -1;

    for (let i = 0; i < list.length; i++) {
      let currentItem = list[i];

      if (currentItem[findString].toString() === searchString) {
        lastIndex = i;
      }
    }

    return lastIndex;
  }
  public findFirstIndexOfStringInIndexName(list, findString, searchString) {
    for (let i = 0; i < list.length; i++) {
      let currentItem = list[i];

      if (currentItem[findString].toString() === searchString) {
        return i;
      }
    }

    return -1;
  }
  public moudle_text(newValue, oldValue) {
    let color = "";
    let color_new = "";
    let baseline: any = this.getThreshold(
      this.removeEmptyParentObjects(this.cpu_set_up.config),
      this.report_data_list,
      this.configuration_form.scene_id
    ).baseline;
    let is_bad_risk = !this.getThreshold(
      this.removeEmptyParentObjects(this.cpu_set_up.config),
      this.report_data_list,
      this.configuration_form.scene_id
    ).is_bad_risk;
    let threshold: any = this.getThreshold(
      this.removeEmptyParentObjects(this.cpu_set_up.config),
      this.report_data_list,
      this.configuration_form.scene_id
    ).threshold;

    let text =
      (newValue > oldValue ? "↑" : "↓") +
      Math.abs(newValue - oldValue).toFixed(2);
    let textAll = "(" + text + ")";
    if (baseline.module) {
      if (newValue > baseline.module) {
        color = "red";
      } else {
        color = "#303133";
      }
    } else {
      color = "#303133";
    }
    if (is_bad_risk) {
      if (threshold.module) {
        if (
          Math.abs(newValue - oldValue) / oldValue >
          threshold.module?.replace("%", "") / 100
        ) {
          color_new = newValue > oldValue ? "red" : "#00b050";
        } else {
          color_new = "#303133";
        }
      } else {
        color_new = "#303133";
      }
    } else {
      color_new = "#303133";
    }
    return [textAll, color, color_new];
  }
  public submitAddForm() {
    // if (this.overview.risk == "核心指标") {
    //   let lastIndex = this.findLastIndexOfStringInIndexName(
    //     this.table_test_overview,
    //     "index_name",
    //     this.overview.risk
    //   );

    //   let newValue = this.risk_list
    //     .filter((v) => v.name == this.overview.type)[0]
    //     .data.filter((v) => v.name == this.overview.term)[0].new;
    //   let oldValue = this.risk_list
    //     .filter((v) => v.name == this.overview.type)[0]
    //     .data.filter((v) => v.name == this.overview.term)[0].text;
    //   let color = this.risk_list
    //     .filter((v) => v.name == this.overview.type)[0]
    //     .data.filter((v) => v.name == this.overview.term)[0].color;
    //   let color_new = this.risk_list
    //     .filter((v) => v.name == this.overview.type)[0]
    //     .data.filter((v) => v.name == this.overview.term)[0].color_new;
    //   let newData = {
    //     model:
    //       this.report_data_list?.device_level +
    //       "-" +
    //       this.report_data_list?.device_name,
    //     scene: this.report_data_list?.scene,
    //     risk: this.risk,
    //     index_name: "核心指标",
    //     index_detail: "核心指标",
    //     index_detail_name: this.chinese_name(this.overview.term),
    //     value: newValue,
    //     text: oldValue,
    //     color: color,
    //     color_new: color_new,
    //   };

    //   if (lastIndex != -1) {
    //     this.table_test_overview.splice(lastIndex + 1, 0, newData);
    //   } else {
    //     this.table_test_overview.splice(1, 0, newData);
    //   }
    // }
    if (!this.overviewShow) {
      let lastIndex = this.findLastIndexOfStringInIndexName(
        this.table_test_overview,
        "index_detail",
        this.overview.type
      );

      let newData = {};
      if (this.overview.type != "模块函数(ms)") {
        let newValue = this.risk_list
          .filter((v) => v.name == this.overview.type)[0]
          .data.filter((v) => v.name == this.overview.term)[0].new;
        let oldValue = this.risk_list
          .filter((v) => v.name == this.overview.type)[0]
          .data.filter((v) => v.name == this.overview.term)[0].text;
        let color = this.risk_list
          .filter((v) => v.name == this.overview.type)[0]
          .data.filter((v) => v.name == this.overview.term)[0].color;
        let color_new = this.risk_list
          .filter((v) => v.name == this.overview.type)[0]
          .data.filter((v) => v.name == this.overview.term)[0].color_new;

        newData = {
          model:
            this.report_data_list?.device_level +
            "-" +
            this.report_data_list?.device_name,
          scene: this.report_data_list?.scene,
          risk: this.risk,
          index_name: "异常细分指标",
          index_detail: this.overview.type,
          index_detail_name: this.chinese_name(this.overview.term),
          value: newValue,
          text: oldValue,
          color: color,
          color_new: color_new,
        };
      } else {
        let data = this.findObjectByName(this.func_list, this.overview.term);
        newData = {
          model:
            this.report_data_list?.device_level +
            "-" +
            this.report_data_list?.device_name,
          scene: this.report_data_list?.scene,
          risk: this.risk,
          index_name: "异常细分指标",
          index_detail: this.overview.type,
          index_detail_name: this.chinese_name(this.overview.term),
          value: data.value.toFixed(2),
          text: this.moudle_text(data.value, data.old_value)[0],
          color: this.moudle_text(data.value, data.old_value)[1],
          color_new: this.moudle_text(data.value, data.old_value)[2],
        };
      }

      if (lastIndex != -1) {
        this.table_test_overview.splice(lastIndex + 1, 0, newData);
      } else {
        let list = [];
        list = this.indicator_type;
        let allIndex = [];
        let i = 0;

        list.forEach((v) => {
          allIndex.push({
            name: v,
            index: this.findFirstIndexOfStringInIndexName(
              this.table_test_overview,
              "index_detail",
              v
            ),
          });
        });
        let [firstArray, secondArray] = this.splitArrayByName(
          allIndex,
          this.overview.type
        );
        // 数据切分 目的为了找节点关系

        let filrstArray_filter = firstArray.filter((v) => v.index != -1);
        let secondArray_filter = secondArray.filter((v) => v.index != -1);
        filrstArray_filter.forEach((v) => {
          v.index = this.findLastIndexOfStringInIndexName(
            this.table_test_overview,
            "index_detail",
            v.name
          );
        });

        if (filrstArray_filter.length > 0 || secondArray_filter.length > 0) {
          i =
            filrstArray_filter[filrstArray_filter.length - 1]?.index + 1 ||
            secondArray_filter[0]?.index;
          this.table_test_overview.splice(i, 0, newData);
        } else {
          let lastIndex = this.findLastIndexOfStringInIndexName(
            this.table_test_overview,
            "index_name",
            "核心指标"
          );
          if (lastIndex != -1) {
            this.table_test_overview.splice(lastIndex + 1, 0, newData);
          } else {
            this.table_test_overview.splice(1, 0, newData);
          }
        }
      }
    } else {
      let newValue = this.options_list[this.overview.risk][
        this.overview.type
      ].filter((v) => v.name == this.overview.term)[0].value;
      let oldValue = this.options_list[this.overview.risk][
        this.overview.type
      ].filter((v) => v.name == this.overview.term)[0].text;
      let color = this.options_list[this.overview.risk][
        this.overview.type
      ].filter((v) => v.name == this.overview.term)[0].color;
      let color_new = this.options_list[this.overview.risk][
        this.overview.type
      ].filter((v) => v.name == this.overview.term)[0].color_new;
      let newData = {
        model:
          this.report_data_list?.device_level +
          "-" +
          this.report_data_list?.device_name,
        scene: this.report_data_list?.scene,
        risk: this.risk,
        index_name: this.overview.risk,
        index_detail: this.overview.type,
        index_detail_name: this.chinese_name(this.overview.term),
        value: newValue,
        text: oldValue,
        color: color,
        color_new: color_new,
      };
      let lastIndex = this.table_test_overview_important.reduce(
        (lastFoundIndex, currentItem, currentIndex) => {
          if (
            currentItem.index_name === this.overview.risk &&
            currentItem.index_detail === this.overview.type
          ) {
            return currentIndex;
          }
          return lastFoundIndex;
        },
        -1
      );

      if (lastIndex != -1) {
        this.table_test_overview_important.splice(lastIndex + 1, 0, newData);
      } else {
        let list = [];
        let i = 0;
        list = this.indicator_type;
        let allIndex = [];
        list.forEach((v) => {
          allIndex.push({
            index_name: this.overview.risk,
            name: v,
            index: this.table_test_overview_important.reduce(
              (lastFoundIndex, currentItem, currentIndex) => {
                if (
                  currentItem.index_name === this.overview.risk &&
                  currentItem.index_detail === v
                ) {
                  return currentIndex;
                }
                return lastFoundIndex;
              },
              -1
            ),
          });
        });

        let [firstArray, secondArray] = this.splitArrayByName(
          allIndex,
          this.overview.type
        );

        let filrstArray_filter = firstArray.filter((v) => v.index != -1);
        let secondArray_filter = secondArray.filter((v) => v.index != -1);
        if (filrstArray_filter.length > 0 || secondArray_filter.length > 0) {
          i =
            filrstArray_filter[filrstArray_filter.length - 1]?.index + 1 ||
            secondArray_filter[0]?.index;
          this.table_test_overview_important.splice(i, 0, newData);
        } else {
          this.table_test_overview_important.push(newData);
        }
      }
    }

    // if (this.overview.risk == "重点卡顿问题") {
    //   let lastIndex = this.findLastIndexOfStringInIndexName(
    //     this.table_test_overview,
    //     "index_name",
    //     this.overview.risk
    //   );
    //   let list = [];
    //   if (this.overview.type == "FPS") {
    //     list = this.fps_top;
    //   }
    //   if (this.overview.type == "CPU") {
    //     list = this.top_cpu;
    //   }
    //   if (this.overview.type == "GPU") {
    //     list = this.top_gpu;
    //   }
    //   if (this.overview.type == "线程耗时(ms)") {
    //     list = this.top_thread_3;
    //   }
    //   if (this.overview.type == "模块函数(ms)") {
    //     list = this.top_moudle_5;
    //   }

    //   // console.log(lastIndex);
    //   let newValue = list.filter((v) => v.name == this.overview.term)[0].value;
    //   let oldValue = list.filter((v) => v.name == this.overview.term)[0].text;
    //   let newData = {
    //     model:
    //       this.report_data_list?.device_level +
    //       "-" +
    //       this.report_data_list?.device_name,
    //     scene: this.report_data_list?.scene,
    //     risk: this.risk,
    //     index_name: this.overview.risk,
    //     index_detail: "",
    //     index_detail_name: this.overview.term,
    //     value: newValue + oldValue,
    //   };
    //   if (lastIndex != -1) {
    //     this.table_test_overview.splice(lastIndex + 1, 0, newData);
    //   } else {
    //     let lastIndex_old = this.findLastIndexOfStringInIndexName(
    //       this.table_test_overview,
    //       "value",
    //       "对比整局平均"
    //     );
    //     this.table_test_overview.splice(lastIndex_old + 1, 0, newData);
    //   }

    // }
    this.clearRowspan(this.table_test_overview);
    this.clearRowspan(this.table_test_overview_important);
    this.table_test_overview.forEach((v, index) => {
      if (index == 0) {
        v.rowspan = this.table_test_overview.length;
      }
    });
    this.mergeRows(this.table_test_overview);
    this.mergeRows(this.table_test_overview_important);

    this.addColspan(this.table_test_overview);
  }
  public clearRowspan(list) {
    for (let i = 0; i < list.length; i++) {
      delete list[i].index_name_rowspan;
      delete list[i].index_detail_rowspan;
      delete list[i].rowspan;
      delete list[i].rowspan;
      delete list[i].colspan;
    }
  }
  public get indicator_term() {
    let list = [];
    this.overview.term = "";
    if (this.overviewShow) {
      if (this.overview.risk && this.overview.type) {
        list = this.options_list[this.overview.risk][this.overview.type].map(
          (v) => v.name
        );
      }
    } else {
      if (this.overview.type == "FPS") {
        list = ["avg_fps", "jank", "var_fps"];
      } else if (this.overview.type == "CPU") {
        list = ["avg_cpu_total", "avg_cpu"];
      } else if (this.overview.type == "GPU") {
        list = [
          "gpu_usage",
          "shaders_busy",
          "vertices_shaded",
          "fragments_shaded",
          "read_total",
          "write_total",
        ];
      } else if (this.overview.type == "线程耗时(ms)") {
        list =
          this.operateModule == 1
            ? this.overList_filter
            : this.top_thread_3.map((v) => v.name);
      } else if (this.overview.type == "模块函数(ms)") {
        // let function_list_data = { new: [], old: [] };
        // this.function_list_data.forEach((v) => {
        //   if (v.type === "module" || v.type == "function") {
        //     function_list_data.new.push({
        //       name: v.name,
        //       type: v.type,
        //       value: v.list[0].event_count,
        //     });
        //   }
        // });
        // this.function_list_data.forEach((v) => {
        //   if (v.type === "module" || v.type == "function") {
        //     function_list_data.old.push({
        //       name: v.name,
        //       type: v.type,
        //       value: v.list[0].old_event_count,
        //     });
        //   }
        // });
        // // 项目区分备用
        // // const top5Modules =
        // //   this.localProject !== 34
        // //     ? JSON.parse(JSON.stringify(function_list_data.new))
        // //         .sort((a, b) => b.value - a.value)
        // //         .map((item) => item.name)
        // //         .slice(0, 5)
        // //     : function_list_data.new
        // //         .filter((v) => v.type == "module")
        // //         .map((v) => v.name);

        // let top5Modules = [];
        // if (this.operateModule == 1) {
        //   top5Modules = JSON.parse(JSON.stringify(function_list_data.new))
        //     .sort((a, b) => b.value - a.value)
        //     .map((item) => item.name)
        //     .slice(0, 5);
        // } else {
        //   top5Modules = this.top_moudle_5.map((v) => v.name);
        // }
        list = [];
        for (let i in this.func_list) {
          list.push(this.func_list[i].name);
        }
      }
    }

    return list;
  }

  public stackData_all = [];
  public tableRowClassName(row: any) {
    let num = Math.round(row.row.value);
    var startColor = "#3E3E3E";
    var endColor = "#6E2F2F";
    var colorArr = this.gradient(
      startColor,
      endColor,
      Math.round(this.stackData[0].value)
    );
    if (num == Math.round(this.stackData[0].value)) {
      num = Math.round(this.stackData[0].value) - 1;
    }

    // console.log(colorArr[num])
    return {
      background: colorArr[num],
      borderBottom: "0",
      color: "#fff",
      height: "2px",
    };
  }
  public type_moudle(type) {
    let list = [
      "cpu_usage_0",
      "cpu_usage_1",
      "cpu_usage_2",
      "cpu_usage_3",
      "cpu_usage_4",
      "cpu_usage_5",
      "cpu_usage_6",
      "cpu_usage_7",
    ];
    let list_thread = this.overList;
    if (type == "FrameTime" || type == "single_frame_time") {
      return "frame_time";
    } else if (list.includes(type)) {
      return "core_cpu";
    } else if (list_thread.includes(type)) {
      return "thread";
    } else if (type == "FPS") {
      return "avg_fps";
    } else if (type == "function") {
      return "module";
    } else {
      return type;
    }
  }
  public risk_list = [];
  public moudle = ["All", "Android", "iOS"];
  public params_cpu = [
    { name: "FPS", value: "avg_fps" },
    { name: "Total%", value: "avg_cpu_total" },
    { name: "App%", value: "avg_cpu" },
    { name: "CPU0%", value: "cpu_usage_0" },
    { name: "CPU1%", value: "cpu_usage_1" },
    { name: "CPU2%", value: "cpu_usage_2" },
    { name: "CPU3%", value: "cpu_usage_3" },
    { name: "CPU4%", value: "cpu_usage_4" },
    { name: "CPU5%", value: "cpu_usage_5" },
    { name: "CPU6%", value: "cpu_usage_6" },
    { name: "CPU7%", value: "cpu_usage_7" },
    { name: "Freq MHz", value: "avg_cpu_freq" },
  ];
  public params_gpu = [
    { name: "FPS", value: "avg_fps" },
    { name: "GUsage%", value: "gpu_usage" },
    { name: "GpuBusBusy%", value: "gpu_bus_busy" },
    { name: "ShadersBusy%", value: "shaders_busy" },
    { name: "VerticesShaded[K]", value: "vertices_shaded" },
    { name: "FragmentsShaded[K]", value: "fragments_shaded" },
    { name: "ReadTotal[MB]", value: "read_total" },
    { name: "WriteTotal[MB]", value: "write_total" },
    { name: "GClock[MHz]", value: "GClock" },
  ];
  public getDataChinese(name) {
    if (this.fps_lt_list.filter((v) => v.value == name).length > 0) {
      return this.fps_lt_list.filter((v) => v.value == name)[0].name;
    } else {
      return this.configuration_name[name];
    }
  }

  public fps_lt_list = [
    { value: "fps_lt_10_pcnt", name: "低帧(<10)占比%" },
    { value: "fps_lt_18_pcnt", name: "低帧(>18)占比%" },
    { value: "fps_lt_25_pcnt", name: "低帧(>25)占比%" },
    { value: "fps_lt_40_pcnt", name: "低帧(>40)占比%" },
  ];
  public test_loading = false;
  public fps_loading = false;
  public cpu_loading = false;
  public gpu_loading = false;
  public thread_loading = false;
  public moudle_loading = false;
  public configuration_name = {
    avg_fps: "平均FPS",
    var_fps: "帧率方差",
    jank: "jank",
    big_jank: "big_jank",
    lag_pcnt: "Stutter%",
    "低帧(<25)占比": "低帧(<25)占比",
    avg_cpu: "AppCPU",
    avg_cpu_total: "TotalCPU",
    core_cpu: "各核心CPU",
    avg_cpu_freq: "平均频率",
    frame_time: "帧耗时",
    thread: "线程耗时",
    module: "模块函数耗时",
    gpu_usage: "GUsage%",
    gpu_bus_busy: "GpuBusBusy%",
    shaders_busy: "ShadersBusy%",
    vertices_shaded: "VerticesShaded[K]",
    fragments_shaded: "FragmentsShaded[K]",
    read_total: "ReadTotal[MB]",
    write_total: "WriteTotal[MB]",
    GClock: "GClock[MHz]",
    删除: "删除",
  };
  public indicator_default = {
    avg_fps: { baseline: 25, threshold: "10%" },
    var_fps: { baseline: 25, threshold: "10%" },
    jank: { baseline: "", threshold: "10%" },
    big_jank: { baseline: "", threshold: "10%" },
    lag_pcnt: { baseline: "", threshold: "10%" },
    fps_lt_25_pcnt: { baseline: "", threshold: "10%" },
    avg_cpu: { baseline: 80, threshold: "10%" },
    avg_cpu_total: { baseline: 90, threshold: "10%" },
    core_cpu: { baseline: 90, threshold: "10%" },
    avg_cpu_freq: { baseline: "", threshold: "10%" },
    frame_time: { baseline: 40, threshold: "10%" },
    thread: { baseline: "", threshold: "10%" },
    module: { baseline: "", threshold: "10%" },
    gpu_usage: { baseline: 90, threshold: "10%" },
    gpu_bus_busy: { baseline: "", threshold: "10%" },
    shaders_busy: { baseline: "", threshold: "10%" },
    vertices_shaded: { baseline: "", threshold: "10%" },
    fragments_shaded: { baseline: "", threshold: "10%" },
    read_total: { baseline: "", threshold: "10%" },
    write_total: { baseline: "", threshold: "10%" },
    GClock: { baseline: "", threshold: "10%" },
  };
  // public indicator_default = {
  //   avg_fps: { baseline: 25, threshold: "10%" },
  //   var_fps: { baseline: 25, threshold: "10%" },
  //   jank: { baseline: "", threshold: "10%" },
  //   big_jank: { baseline: "", threshold: "10%" },
  //   lag_pcnt: { baseline: "", threshold: "10%" },
  //   fps_lt_25_pcnt: { baseline: "", threshold: "10%" },
  //   avg_cpu: { baseline: 80, threshold: "10%" },
  //   avg_cpu_total: { baseline: 90, threshold: "10%" },
  //   core_cpu: { baseline: 90, threshold: "10%" },
  //   avg_cpu_freq: { baseline: "", threshold: "10%" },
  //   frame_time: { baseline: 40, threshold: "10%" },
  //   thread: { baseline: "", threshold: "10%" },
  //   module: { baseline: "", threshold: "10%" },
  //   gpu_usage: { baseline: 90, threshold: "10%" },
  //   gpu_bus_busy: { baseline: "", threshold: "10%" },
  //   shaders_busy: { baseline: "", threshold: "10%" },
  //   vertices_shaded: { baseline: "", threshold: "10%" },
  //   fragments_shaded: { baseline: "", threshold: "10%" },
  //   read_total: { baseline: "", threshold: "10%" },
  //   write_total: { baseline: "", threshold: "10%" },
  //   GClock: { baseline: "", threshold: "10%" },
  // };
  public com_color(name, value, old) {
    let baseline: any = this.getThreshold(
      this.removeEmptyParentObjects(this.cpu_set_up.config),
      this.report_data_list,
      this.configuration_form.scene_id
    ).baseline;
    let threshold: any = this.getThreshold(
      this.removeEmptyParentObjects(this.cpu_set_up.config),
      this.report_data_list,
      this.configuration_form.scene_id
    ).threshold;
    let is_bad_risk = !this.getThreshold(
      this.removeEmptyParentObjects(this.cpu_set_up.config),
      this.report_data_list,
      this.configuration_form.scene_id
    ).is_bad_risk;
    let color = "";
    let contrast_color = "";
    let name_new = this.type_moudle(name);
    if (name_new == "avg_fps") {
      if (baseline[name_new]) {
        if (value < baseline[name_new]) {
          color = "red";
        } else {
          color = "#00b050";
        }
        if (
          Math.abs(value - old) / old >
          threshold[name_new]?.replace("%", "") / 100
        ) {
          if (value > old) {
            contrast_color = "#00b050";
          } else {
            contrast_color = "red";
          }
        }
      }
    } else {
      if (baseline[name_new]) {
        if (value > baseline[name_new]) {
          color = "red";
        } else {
          color = "#00b050";
        }
      }
      if (threshold[name_new]) {
        if (
          name_new == "big_jank" ||
          name_new == "var_fps" ||
          name_new == "jank" ||
          name_new == "core_cpu" ||
          name_new == "avg_cpu" ||
          name_new == "avg_cpu_total" ||
          name_new == "gpu_bus_busy" ||
          name_new == "shaders_busy" ||
          name_new == "gpu_usage"
        ) {
          if (
            Math.abs(value - old) / old >
            threshold[name_new]?.replace("%", "") / 100
          ) {
            if (value > old) {
              contrast_color = "red";
            } else {
              contrast_color = "#00b050";
            }
          }
        } else {
          if (
            Math.abs(value - old) / old >
            threshold[name_new]?.replace("%", "") / 100
          ) {
            if (value > old) {
              contrast_color = "red";
            } else {
              contrast_color = "#00b050";
            }
          }
        }
      }
    }
    return [color, contrast_color];
  }
  public addRow_baseline() {
    let list = [];
    this.configuration_table_baseline.forEach((v) => {
      list.push(v.value);
    });
    if (list.flat().length == this.gear_position.length) {
      ElMessage.error({
        message: "挡位已选满,不可以继续添加列",
        showClose: true,
        type: "error",
      });
      return;
    } else {
      this.gear_position_all.push(
        JSON.parse(JSON.stringify(this.gear_position))
      );
      this.configuration_table_baseline.push({ name: "", value: [] });
      this.configuration_table_data.forEach((v) => {
        if (v.name == "") {
          v.baseline.push("删除");
        } else {
          v.baseline.push(this.indicator_default[v.name].baseline);
        }
      });
    }
  }
  public addRow_threshold() {
    let list = [];
    this.configuration_table_threshold.forEach((v) => {
      list.push(v.value);
    });
    if (list.flat().length == this.gear_position.length) {
      ElMessage.error({
        message: "挡位已选满,不可以继续添加列",
        showClose: true,
        type: "error",
      });
      return;
    } else {
      this.gear_position_all_threshold.push(
        JSON.parse(JSON.stringify(this.gear_position))
      );
      this.configuration_table_threshold.push({ name: "", value: [] });
      this.configuration_table_data.forEach((v) => {
        if (v.name == "") {
          v.threshold.push("删除");
        } else {
          v.threshold.push(this.indicator_default[v.name].threshold);
        }
      });
    }
  }
  public delete_baseline(num) {
    if (this.configuration_table_baseline.length > 1) {
      this.configuration_table_baseline.splice(num, 1);
      this.gear_position_all.splice(num, 1);
    } else {
      ElMessage.error({
        message: "只剩一列时不可删除",
        showClose: true,
        type: "error",
      });
    }
    this.configuration_table_data.forEach((v) => {
      if (v.baseline.length > 1) {
        v.baseline.splice(num, 1);
      }
    });
  }
  public delete_threshold(num) {
    if (this.configuration_table_threshold.length > 1) {
      this.configuration_table_threshold.splice(num, 1);
      this.gear_position_all_threshold.splice(num, 1);
    } else {
      ElMessage.error({
        message: "只剩一列时不可删除",
        showClose: true,
        type: "error",
      });
    }
    this.configuration_table_data.forEach((v) => {
      if (v.threshold.length > 1) {
        v.threshold.splice(num, 1);
      }
    });
  }
  public getNum(item1, item2, type?) {
    if (item1 === "" || item2 === null || item2 == "--") {
      return "--";
    }

    if (item1 > item2) {
      return Math.abs(item1 - item2).toFixed(2) + "↑";
    } else if (item1 < item2) {
      return Math.abs(item2 - item1).toFixed(2) + "↓";
    }
    if (item1 === item2) {
      return "--";
    }
  }
  public async fps_detail_creat() {
    let old_test = this.versionsOldOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.old_verson
    )[0].id_test;
    await dispatchDeepPerformanceCpuUsageList(store, {
      project: this.localProject,

      id_test: this.id_test,
      old_test: old_test,
      fps_rate: encodeURIComponent(this.fps_rate),
    });
    //   if (
    //     this.localProject == 7 ||
    //     this.localProject == 4 ||
    //     this.localProject == 48
    //   ) {
    // dispatchDeepPerformanceCpuUsageListQQ(store, {
    //   project: this.localProject,
    //   id_test: this.id_test,
    //   thread: this.trendOptions.thread,
    //   so: this.trendOptions.so,
    // });
    //     await dispatchDeepPerformanceCpuUsageListModuleQQ(store, {
    //       project: this.localProject,
    //       id_test: this.id_test,
    //       thread: this.trendOptions.thread,
    //       so: this.trendOptions.so,
    //     });
    //     this.moudle_model = this.moudleList;
    //      this.moudle_inside_data = this.moudle_mounted_qf().filter((item) =>
    //     this.moudle_model.includes(item.name)
    //   );
    //      this.drawModuleInsideTrendQF();
    //   }
  }
  public times = [];
  public add_problem = true;
  // public async brushEnd() {
  //   this.test_loading = true;
  //   this.add_problem = false;
  //   dispatchDeepPerformanceFrameProblem(store, {
  //     project: this.localProject,

  //     id_test: this.id_test,
  //     thread: this.trendOptions.thread,
  //     timelines: this.times,

  //     frame_time: this.times.length > 1 ? "" : this.frame_num,
  //   }).then((res) => {
  //     this.add_important_data();
  //     if (this.message_error.some((v) => v.length > 0)) {
  //       ElMessage.error({
  //         message: "已添加到重点卡顿问题中",
  //         showClose: true,
  //         type: "error",
  //       });
  //     } else {
  //       ElMessage.success({
  //         message: "没有指标超标无需添加",
  //         showClose: true,
  //         type: "success",
  //       });
  //     }
  //     //     let list_add=[]
  //     //     Object.keys(this.frameProblem).forEach(v=>{
  //     //        this.options_list_name.push(v)
  //     //        list_add.push(v)
  //     //     })
  //     //       let fps_problem = [];
  //     //   let list = ["FPS", "CPU", "GPU", "线程耗时(ms)", "模块函数(ms)"];
  //     //   console.log(this.fps_top)
  //     //   this.fps_top.forEach((v) =>

  //     //    { v.index_name="FPS";
  //     //       v.top
  //     //       .filter((m) => m.color == "red" || m.color_new == "red")
  //     //       .forEach((k) => {
  //     //         k.timeline = v.time;
  //     //        k.index_name=v.index_name
  //     //         fps_problem.push(k);
  //     //       })
  //     //    }
  //     //   );
  //     //  console.log(this.fps_top)
  //     //   let cpu_problem = [];
  //     //   //  this.top_cpu.filter(
  //     //   //   (v) => v.color == "red" || v.color_new == "red"
  //     //   // );
  //     //   this.top_cpu.forEach((v) =>
  //     //    {
  //     //         v.index_name = "CPU";
  //     //       v.top
  //     //       .filter((m) => m.color == "red" || m.color_new == "red")
  //     //       .forEach((k) => {
  //     //         k.timeline = v.time;
  //     //      k.index_name=v.index_name
  //     //         cpu_problem.push(k);
  //     //       })
  //     //    }
  //     //   );
  //     //   let gpu_problem = [];
  //     //   this.top_gpu.forEach((v) =>{
  //     //         v.index_name = "GPU";
  //     //       v.top
  //     //       .filter((m) => m.color == "red" || m.color_new == "red")
  //     //       .forEach((k) => {
  //     //         k.timeline = v.time;
  //     //         k.index_name=v.index_name
  //     //         gpu_problem.push(k);
  //     //       })
  //     //   }

  //     //   );
  //     //   let thread_problem = [];
  //     //   //    this.top_thread_3.filter(
  //     //   //   (v) => v.color == "red" || v.color_new == "red"
  //     //   // );
  //     //   this.top_thread_3.forEach((v) =>{
  //     //       v.index_name = "线程耗时(ms)";
  //     //      v.top
  //     //       .filter((m) => m.color == "red" || m.color_new == "red")
  //     //       .forEach((k) => {
  //     //         k.timeline = v.time;
  //     //        k.index_name=v.index_name
  //     //         thread_problem.push(k);
  //     //       })
  //     //   }

  //     //   );
  //     //   let module_problem = [];
  //     //   //  this.top_moudle_5.filter(
  //     //   //   (v) => v.color == "red" || v.color_new == "red"
  //     //   // );
  //     //   this.top_moudle_5.forEach((v) =>
  //     //   {
  //     //       v.index_name = "模块函数(ms)";
  //     //       v.top
  //     //       .filter((m) => m.color == "red" || m.color_new == "red")
  //     //       .forEach((k) => {
  //     //         k.timeline = v.time;
  //     //        k.index_name=v.index_name
  //     //         module_problem.push(k);
  //     //       })
  //     //   }
  //     //   );
  //     //     // this.importanta_data()
  //     //      list_add.forEach(i=>{
  //     //         if(!this.options_list[i]){
  //     //        this.options_list[i]={}
  //     //     }
  //     //     list.forEach(v=>{
  //     //       if(v==='FPS'){
  //     //         console.log(this.fps_top.filter(n=>i==n.time))
  //     //         if(this.fps_top.filter(n=>i==n.time).length>0){
  //     //           this.options_list[i][v]=this.fps_top.filter(n=>i==n.time)[0].top
  //     //         }

  //     //       }
  //     //       if(v==='CPU'){
  //     //           if(this.top_cpu.filter(n=>i==n.time).length>0){
  //     //           this.options_list[i][v]=this.top_cpu.filter(n=>i==n.time)[0].top
  //     //         }
  //     //         // this.options_list[i][v]=this.top_cpu.filter(n=>i==n.time)[0].top
  //     //       }
  //     //       if(v==='GPU'){
  //     //            if(this.top_gpu.filter(n=>i==n.time).length>0){
  //     //           this.options_list[i][v]=this.top_gpu.filter(n=>i==n.time)[0].top
  //     //         }
  //     //         // this.options_list[i][v]=this.top_gpu.filter(n=>i==n.time)[0].top
  //     //       }
  //     //       if(v==='线程耗时(ms)'){
  //     //             if(this.top_thread_3.filter(n=>i==n.time).length>0){
  //     //           this.options_list[i][v]=this.top_thread_3.filter(n=>i==n.time)[0].top
  //     //         }
  //     //         // this.options_list[i][v]=this.top_thread_3.filter(n=>i==n.time)[0].top
  //     //       }
  //     //       if(v==='模块函数(ms)'){
  //     //            if(this.top_moudle_5.filter(n=>i==n.time).length>0){
  //     //           this.options_list[i][v]=this.top_moudle_5.filter(n=>i==n.time)[0].top
  //     //         }
  //     //         // this.options_list[i][v]=this.top_moudle_5.filter(n=>i==n.time)[0].top
  //     //       }
  //     //       console.log(this.options_list[i][v])
  //     //         this.options_list[i][v].filter((m) => m.color == "red" || m.color_new == "red").forEach(x=>{
  //     //         this.table_test_overview_important.push({
  //     //       model:
  //     //         this.report_data_list?.device_level +
  //     //         "-" +
  //     //         this.report_data_list?.device_name,
  //     //       scene: this.report_data_list?.scene,
  //     //       risk: this.risk,
  //     //       index_name:i,
  //     //       index_detail: x.index_name,
  //     //       index_detail_name: this.chinese_name(x.name),
  //     //       value: x.value,
  //     //       color: x.color,

  //     //       color_new: x.color_new,
  //     //       text: x.text,
  //     //       edit:false,
  //     //       edit_name: false,
  //     //       edit_vale: false,
  //     //       edit_detail: false,
  //     //     })
  //     //       })

  //     //     })
  //     //     })
  //     //      this.mergeRows(this.table_test_overview_important);
  //     this.add_problem = true;
  //     this.test_loading = false;
  //   });
  // }
  public find_options_name = "";
  public focusInput(name) {
    this.find_options_name = name;
  }
  public async thread_detail_creat() {
    if (this.thread_tabs_detail_show) {
      let old_test = this.versionsOldOptions.filter(
        (v) => v.chinese == this.dataConsumeOptions.old_verson
      )[0].id_test;
      await dispatchDeepPerformanceCpuCpuFunctionOverviewNew(store, {
        project: this.localProject,

        id_test: this.id_test,
        old_test: old_test,
      });
      // this.getOverviewTrend(this.overviewData)
      this.thread_tabs_detail_show = false;
    }
    //   if(this.activeName=='second'&&this.fps_tabs_inside_show){
    //   this.drawCpuInsideTrend()
    // }
  }
  public async moudel_detail_creat() {
    if (this.moudel_tabs_detail_show) {
      let date = this.versionsOptions.filter(
        (v) => v.chinese == this.dataConsumeOptions.version
      )[0].date;
      let version = this.versionsOptions.filter(
        (v) => v.chinese == this.dataConsumeOptions.version
      )[0].game_version;
      let old_date = this.versionsOldOptions.filter(
        (v) => v.chinese == this.dataConsumeOptions.old_verson
      )[0].date;
      let old_version = this.versionsOldOptions.filter(
        (v) => v.chinese == this.dataConsumeOptions.old_verson
      )[0].game_version;
      let old_test = this.versionsOldOptions.filter(
        (v) => v.chinese == this.dataConsumeOptions.old_verson
      )[0].id_test;
      await dispatchDeepPerformanceCpuCpuFunction(store, {
        project: this.localProject,
        date: date,
        old_date: old_date,
        device_id: Number(this.dataConsumeOptions.device),
        scene_id: Number(this.dataConsumeOptions.scene),
        version: version,
        old_version: old_version,
        id_test: this.id_test,
        thread: this.trendOptions.thread,
        label: "All",
        old_test: old_test,
      });

      this.moudle_model = this.moudleList;

      // if (this.localProject !== 7 && this.localProject !== 4) {
      //   this.drawModuleInsideTrend();
      // }
      if (
        this.localProject !== 4 &&
        this.localProject !== 7 &&
        this.localProject !== 48
      ) {
        this.moudle_inside_data = this.moudle_mounted().filter((item) =>
          this.moudle_model.includes(item.name)
        );
        this.drawModuleInsideTrend();
      }
      this.moudel_tabs_detail_show = false;
    }
  }
  public get so_list() {
    return readGetdeepCpuConfigSoList(store);
  }
  public get thread_add() {
    return Object.keys(this.so_list);
  }
  public id_test: any = "";
  public moudle_mounted() {
    let data = [];
    this.getModuleTrend(this.moudule_list).params.forEach((v, index) => {
      data.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: [],
        smooth: true, // 平滑曲线
        itemStyle: {
          normal: {
            label: {
              // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
              show: true,
            },
          },
        },
      });
    });

    data.forEach((v, index) => {
      this.getModuleTrend(this.moudule_list).series.forEach((i) => {
        v.data.push(i[index]);
      });
    });
    return data;
  }
  public moudle_mounted_qf() {
    let data = [];

    this.qf_module.module?.columns
      .filter((v) => v != "timeline")
      .forEach((v, index) => {
        data.push({
          name: v,
          type: "line",
          symbol: "circle", //拐点设置为实心，
          // smooth: true, // 平滑曲线
          data: this.qf_module.module?.rows[v],
          // itemStyle: {
          //   normal: {
          //     label: {
          //       // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
          //       show: true,
          //     },
          //   },
          // },
        });
      });
    return data;
  }

  //   tabs-fps
  public activeName = "";
  public cpu_activeName = "";
  public thread_activeName = "";
  public gpu_activeName = "";
  public cpu_thread_activeName = "";
  public activeName_moudle = "";
  public custom_activeName = "";
  // 线程列表
  public get threadOptions() {
    return readGetdeepCpuThreads(store).data;
  }
  public get thrend_data() {
    return readGetdeepCpuTrend(store).data;
  }
  public async drawThreadTrend() {
    let data = [];
    this.thrend_data.chinese.forEach((v, index) => {
      data.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        smooth: true, // 平滑曲线
        itemStyle: {
          normal: {
            label: {
              // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
              show: true,
            },
          },
        },
        data: this.thrend_data.series[index],
      });
    });

    let performance_line: any = document.getElementById("threadTrand");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);

    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
        confine: true,
      },
      // title: {
      //   left: "center",

      //   text: "日稳定包函数耗时趋势图(百分比)",
      // },
      legend: {
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        name: "ms",
        //  nameLocation: "top",
        // 坐标轴名称与轴线之间的距离。
        // nameGap: 35,
        // nameRotate: 90,
        axisTick: false,
        //左侧线
        // axisLine: {
        //   show: true,
        // },
        //  splitLine: {
        //   show: true,
        // },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "15%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: this.thrend_data.date_list,
      },

      series: data,
    });
    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    });
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = "thread_iteration" + "-" + ".png";
    res.chinese = "线程耗时迭代趋势图";
    this.resBase64.push(res);
  }
  public frame_merge_size = 10;
  public async func_time() {
    let date = this.versionsOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.version
    )[0].date;
    let version = this.versionsOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.version
    )[0].game_version;
    await dispatchDeepPerformanceCpuCpuByFrame(store, {
      project: this.localProject,
      date: date,
      device_id: Number(this.dataConsumeOptions.device),
      scene_id: Number(this.dataConsumeOptions.scene),
      version: version,
      id_test: this.id_test,
      thread: this.trendOptions.thread,
    });
    this.timeline = this.cpu_by_frame.abs_times[
      this.cpu_by_frame.max_frame_index
    ]
      ? this.cpu_by_frame.abs_times[this.cpu_by_frame.max_frame_index]
      : this.cpu_by_frame.abs_times[this.cpu_by_frame.abs_times.length - 1];
    // await dispatchDeepPerformanceFrameProblem(store, {
    //   project: this.localProject,

    //   id_test: this.id_test,
    //   thread: this.trendOptions.thread,
    //   timelines: [this.timeline],

    //   frame_time: this.cpu_by_frame.series[this.cpu_by_frame.max_frame_index],
    // });
    this.labels;
    this.opacity = 1;
    this.frame_merge_size = this.cpu_by_frame?.chunk_size
      ? this.cpu_by_frame.chunk_size
      : 10;
    this.trendInex = this.cpu_by_frame?.max_frame_index
      ? this.cpu_by_frame.max_frame_index
      : 0;

    await this.series();
    this.getFramesInfo(this.trendInex, this.trendInex);
    this.selectData(this.trendInex);
    this.overall();
    await this.legendData();
    this.drawAnalyseTrend();
    await dispatchDeepPerformanceCpuStack(store, {
      project: this.localProject,
      id_test: Number(this.id_test),
      frame: this.trendInex,

      thread: this.threadOptions,
    });
    this.inputValue = "";
    this.serch = "";
    this.table_func();
    await this.tree_func();
    if (this.localProject === 7) {
      this.$nextTick(() => {
        (this.$refs.table as any).toggleRowExpansion(
          this.stackData_all[0],
          true
        );
      });
    }
    this.flame_thead_list = (this.stackData_obj as any).children.map(
      (v) => v.name
    );
    this.flame_thread = this.flame_thead_list.filter((v, index) => index == 0);

    if (this.$route.query.flame_thread) {
      this.flame_thread = (this.$route.query.flame_thread as any).split(",");
    }
    this.flame_thread.forEach((v) => {
      let obj = (this.stackData_obj as any).children.filter(
        (child) => child.name === v
      );

      this.$nextTick(() => {
        let newObj = {
          ...this.stackData_obj,
          children: obj,
        };
        this.renderFlame("#" + this.replaceSpacesWithHyphens(v), newObj);
      });
    });

    this.functionStack1 = false;
  }
  public flame_thead_list = [];
  // public async thread_options_creat() {
  //   await dispatchDeepPerformanceCpuCpuThreads(store, {
  //     project: this.localProject,

  //     id_test: this.id_test,
  //   });
  //   this.trendOptions.thread = this.threadOptions[0];
  //   await dispatchDeepPerformanceCpuFunctionCos(store, {
  //     project: this.localProject,
  //     thread: this.trendOptions.thread,
  //     id_test: this.id_test,
  //   });
  //   this.trendOptions.so = this.cpu_function_cos[0];
  // }
  public get cpu_function_cos() {
    return readGetdeepCpuFunctionCos(store).data;
  }
  public get detail_test() {
    return readDeepPerformancePageList(store).results;
  }
  public report_text_show = false;
  public flame_list = [];
  public functionStack1 = false;
  public async mounted() {
    this.report_text_show = true;
    await dispatchDeepPerformanceCpuCpuConfig(store, {
      project: this.localProject,
    });
    //  await dispatchGetDeepPerformanceSelectOptionsOld(store, {
    //       project: this.localProject,

    //     });
    if (this.$route.query.auto) {
      this.auto_query.push(Number(this.$route.query.auto));
      this.type_query = this.$route.query.type
        ? Number(this.$route.query.type)
        : "";
      this.subtype_query = this.$route.query.subtype
        ? this.$route.query.subtype
        : "";
    } else {
      this.auto_query.push(2);
    }

    await dispatchCpuFuncScenesOptions(store, {
      project: this.localProject,
      device_id: "",
      scene_id: "",
      is_auto: this.auto_query.length == 0 ? "" : this.auto_query,
      type: this.type_query,
      subtype: this.subtype_query,
    });
    this.dataConsumeOptions.scene = this.$route.query.scene_id
      ? Number(this.$route.query.scene_id)
      : this.scene_options[0].scene_id;
    await dispatchCpuFuncDeivceOptions(store, {
      project: this.localProject,
      device_id: "",
      scene_id: this.dataConsumeOptions.scene,
      is_auto: this.auto_query.length == 0 ? "" : this.auto_query,
      type: this.type_query,
      subtype: this.subtype_query,
    });
    this.dataConsumeOptions.device = this.$route.query.device_id
      ? Number(this.$route.query.device_id)
      : this.device_options[0].device_id;

    //  this.dataConsumeOptions.scene=this.device_options[0].device_id

    // this.dataConsumeOptions.version
    await dispatchDeepPerformanceCpuCpuVersions(store, {
      project: this.localProject,
      is_auto: this.auto_query.length == 0 ? "" : this.auto_query,
      type: this.type_query,
      subtype: this.subtype_query,
      device_id: this.dataConsumeOptions.device,
      scene_id: this.dataConsumeOptions.scene,
    });

    if (this.$route.query.id_test) {
      this.id_test = this.$route.query.id_test;
      this.dataConsumeOptions.version = this.versionsOptions.filter(
        (v) => v.id_test == this.$route.query.id_test
      )[0].chinese;
    } else {
      this.dataConsumeOptions.version = this.versionsOptions[0].chinese;
      this.id_test = this.versionsOptions[0].id_test;
    }

    await dispatchDeepPerformanceCpuDetail(store, {
      project: this.localProject,
      id_test: this.id_test,
    });

    // await this.thread_options_creat();

    this.configuration_form.scene_id = "All";
    this.configuration_form.moudle = "All";
    // await dispatchDeepPerformanceCputhreadByFrame(store, {
    //   project: this.localProject,
    //   id_test: this.id_test,
    // });
    // this.cpu_thread = this.cpu_thead_options[0];
    // if (this.cpu_thead_options.length > 0) {
    //   this.drawCpuThreadByFrame();
    // }

    await dispatchDeepPerformanceCpuCpuVersionsOld(store, {
      project: this.localProject,
      device_id: Number(this.dataConsumeOptions.device),
      scene_id: Number(this.dataConsumeOptions.scene),
      is_auto: this.auto_query,
      type: this.type_query,
      subtype: this.subtype_query,
    });
    if (this.versionsOldOptions.length == 1) {
      this.dataConsumeOptions.old_verson = this.versionsOldOptions[0].chinese;
    }
    if (this.versionsOldOptions.length > 1) {
      let index_num = 0;
      let index = this.versionsOldOptions.findIndex(
        (v) => v.chinese == this.dataConsumeOptions.version
      );
      if (index == this.versionsOldOptions.length - 1) {
        index_num = index - 1;
      } else {
        index_num = index + 1;
      }

      this.dataConsumeOptions.old_verson = this.versionsOldOptions[
        index_num
      ].chinese;
    }

    // this.func_time();
    let old_test: any = "";
    if (this.$route.query.old_test) {
      if (
        this.versionsOldOptions.filter(
          (v) => v.id_test == this.$route.query.old_test
        ).length > 0
      ) {
        this.dataConsumeOptions.old_verson = this.versionsOldOptions.filter(
          (v) => v.id_test == this.$route.query.old_test
        )[0].chinese;
      } else {
        ElMessage.error({
          message: "未找到被对比数据",
          showClose: true,
          type: "error",
        });
        return;
      }
      // this.dataConsumeOptions.old_verson = this.versionsOldOptions.filter(
      //   (v) => v.id_test == this.$route.query.old_test
      // )[0].chinese;
      old_test = this.$route.query.old_test;
    } else {
      old_test = this.versionsOldOptions.filter(
        (v) => v.chinese == this.dataConsumeOptions.old_verson
      )[0].id_test;
    }
    // await dispatchDeepPerformancefuncList(store, {
    //   project: this.localProject,
    //   id_test: this.id_test,
    //   old_test: old_test,
    // });
    // this.func_time();
    this.$router.push({
      query: {
        ...this.$route.query,
        auto: this.auto_query,
        type: this.type_query,
        subtype: this.subtype_query,
        scene_id: this.dataConsumeOptions.scene,
        device_id: this.dataConsumeOptions.device,
        id_test: this.id_test,
        old_test: old_test,
      },
    });
    //     const domain =window.location.href ;
    // console.log("当前页面域名:", domain);
    await dispatchDeepPerformanceCpuReport(store, {
      project: this.localProject,

      id_test: this.id_test,
      old_test: old_test,
    });
    this.report_text_show = false;
    if (this.localProject == 7) {
      await dispatchDeepPerformanceCpuCustomData(store, {
        project: this.localProject,

        id_test: this.id_test,
        old_test: old_test,
      });
    }
    this.cpu_index = "AppCPU";

    if (this.cpu_set_up.config) {
      this.fps_lt_params();
    }

    this.configuration_table(
      this.configuration_form.scene_id,
      this.configuration_form.moudle
    );
    await this.fps_detail_creat();
    this.cpuPerfTrend_creat();
    this.gpu_inside_api();
    // this.cpu_thread_trend_creat();
    // this.cpu_trend_creat();
    // this.cpu_thread_creat();
    // this.cpu_module_creat();

    // await this.thread_detail_creat();
    // await this.moudel_detail_creat();
  }
  public get_cpu_thread_trend(cpu_thread_trend) {
    let result = {};
    for (let core_num = 0; core_num < 8; core_num++) {
      let core_num_str = core_num.toString();
      let core_trend = cpu_thread_trend[core_num_str] || {};
      let thread_list = core_trend["params"] || [];
      let series = [];
      for (let thread of thread_list) {
        let data = (core_trend["series"] || {})[thread] || [];
        series.push(data);
      }
      result[core_num_str] = { thread_list: thread_list, series: series };
    }
    return result;
  }

  public get_cpu_trend(json_data) {
    let cpu_series = json_data["cpu_trend"]["series"];
    let cpu_thread_trend = this.get_cpu_thread_trend(
      json_data["cpu_thread_trend"]
    );
    let result = {};
    result["date_list"] = json_data["cpu_trend"]["date_list"];
    result["AppCPU"] = {
      chinese: ["FPS", "AppCPU[%]"],
      series: [cpu_series["avg_fps"], cpu_series["avg_cpu"]],
    };
    result["TotalCPU"] = {
      chinese: ["FPS", "TotalCPU[%]"],
      series: [cpu_series["avg_fps"], cpu_series["avg_cpu_total"]],
    };
    for (let core_num = 0; core_num < 8; core_num++) {
      let core_num_str = core_num.toString();
      result[`CPU${core_num}`] = {
        chinese: ["FPS", `CPU${core_num}[%]`, `CPU${core_num} Freq`].concat(
          cpu_thread_trend[core_num_str]["thread_list"]
        ),
        series: [
          cpu_series["avg_fps"],
          cpu_series[`cpu_usage_${core_num}`],
          cpu_series[`cpu_freq_${core_num}`],
        ].concat(cpu_thread_trend[core_num_str]["series"]),
      };
    }

    return result;
  }
  public cpu_index = "";
  public cpu_trend_index = [
    "AppCPU",
    "TotalCPU",
    "CPU0",
    "CPU1",
    "CPU2",
    "CPU3",
    "CPU4",
    "CPU5",
    "CPU6",
    "CPU7",
  ];
  public async cpu_trend_api() {
    await dispatchCpuTrend(store, {
      project: this.localProject,
      device_id: Number(this.dataConsumeOptions.device),
      scene_id: Number(this.dataConsumeOptions.scene),
      is_auto: this.auto_query,
      type: this.type_query,
      subtype: this.subtype_query,
      id_test: this.id_test,
    });

    this.drawCpuTrend_index();
  }
  public get cpu_by_frame() {
    return readGetdeepCpuByFrame(store);
  }
  // public async top_3_moudle_time() {
  //   let baseline: any = this.getThreshold(
  //     this.removeEmptyParentObjects(this.cpu_set_up.config),
  //     this.report_data_list,
  //     this.configuration_form.scene_id
  //   ).baseline;

  //   let threshold: any = this.getThreshold(
  //     this.removeEmptyParentObjects(this.cpu_set_up.config),
  //     this.report_data_list,
  //     this.configuration_form.scene_id
  //   ).threshold;

  //   let is_bad_risk = !this.getThreshold(
  //     this.removeEmptyParentObjects(this.cpu_set_up.config),
  //     this.report_data_list,
  //     this.configuration_form.scene_id
  //   ).is_bad_risk;
  //   if (baseline.frame_time) {
  //     this.findTop3ClosestIndexes(
  //       this.cpu_by_frame.series[0],
  //       baseline.frame_time
  //     );
  //     let frame_time = [];
  //     let times = [];
  //     this.findTop3ClosestIndexes(
  //       this.cpu_by_frame.series[0],
  //       baseline.frame_time
  //     ).forEach((v) => {
  //       times.push(this.cpu_by_frame.abs_times[v]);
  //       frame_time.push(this.cpu_by_frame.series[0][v]);
  //     });

  //     await dispatchDeepPerformanceFrameProblem(store, {
  //       project: this.localProject,

  //       id_test: this.id_test,
  //       thread: this.trendOptions.thread,
  //       timelines: times,

  //       frame_time: "",
  //     });
  //   } else {
  //     return;
  //   }
  // }
  public findTop3ClosestIndexes(list, num) {
    let indexesWithDifferences = list.map((value, index) => ({
      index: index,
      difference: Math.abs(value - num),
    }));

    indexesWithDifferences.sort((a, b) => a.difference - b.difference);

    let top3Indexes = indexesWithDifferences
      .slice(0, 3)
      .map((item) => item.index);

    // 对索引进行排序
    top3Indexes.sort((a, b) => a - b);

    return top3Indexes;
  }
  public series_list = [];
  public series() {
    this.series_list = [];
    let list = Object.keys(this.cpu_by_frame?.thread_list);
    let filter_list = ["FrameTime"];
    let merged_list = [];
    if (this.$route.query.flame_thread) {
      let flame_thread = (this.$route.query.flame_thread as any).split(",");
      merged_list = filter_list.concat(flame_thread);
    } else {
      merged_list = list;
    }
    merged_list.forEach((v, index) => {
      this.series_list.push({
        name: v,
        type: "line",

        showSymbol: false,

        itemStyle: {
          normal: {
            lineStyle: {
              width: 1,
            },
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
        },
        yAxisIndex: 0,
        id: this.cpu_by_frame?.thread_list[v],
        data: this.cpu_by_frame?.series[index],
      });
    });

    return this.series_list;
  }
  public trendInex = 0;
  public opacity = 1;
  public legend_data = {};
  public legendData() {
    this.legend_data = {};
    let list = Object.keys(this.cpu_by_frame?.thread_list);

    list.forEach((v, index) => {
      this.legend_data[v] = true;
    });

    return this.legend_data;
  }
  public drawCpuTrend_inside() {
    let series = [];
    let xData = [];
    let yaxis: any = [] || {};
    this.get_cpu_trend_by_sec(this.qf_inside, this.cpu_thread_by_frame)[
      this.cpu_index
    ]?.chinese.forEach((v, index) => {
      if (
        v.indexOf("FPS") != -1 ||
        v.indexOf("CPU") != -1 ||
        v.indexOf("TotalCPU") != -1 ||
        v.indexOf("AppCPU") != -1
      ) {
        series.push({
          name: v,
          type: "line",
          data: this.get_cpu_trend_by_sec(
            this.qf_inside,
            this.cpu_thread_by_frame
          )[this.cpu_index]?.series[index],

          symbol: "circle", //拐点设置为实心,
          smooth: true, // 平滑曲线

          // yAxisIndex: v === "avg_cpu_freq" ? 1 : 0,
        });
      } else {
        series.push({
          name: v,
          type: "line",
          stack: "Total",
          areaStyle: {},
          emphasis: {
            focus: "series",
          },
          data: this.get_cpu_trend_by_sec(
            this.qf_inside,
            this.cpu_thread_by_frame
          )[this.cpu_index]?.series[index],

          // yAxisIndex: v === "avg_cpu_freq" ? 1 : 0,
        });
      }
    });
    xData = this.get_cpu_trend_by_sec(this.qf_inside, this.cpu_thread_by_frame)
      ?.x;

    let performance_line: any = document.getElementById("cpu_side");
    echarts.dispose(performance_line);
    let PerformanceLineChart = echarts.init(performance_line);
    let option;
    option = {
      // color: [
      //   "#5470c6",
      //   "#91cc75",
      //   "#fac858",
      //   "#ee6666",
      //   "#73c0de",
      //   "#3ba272",
      //   "#fc8452",
      //   "#935bab",
      //   "#d872bc",
      //   "black", // 新颜色1，橙色
      //   "pink",
      // ],
      title: {
        left: "center",
        textStyle: {
          fontSize: 16,
          fontWeight: "normal",
        },
      },
      tooltip: {
        trigger: "axis",
        confine: true,
      },
      legend: {
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "20%",
        right: "4%",
        containLabel: true,
      },

      animation: false,
      xAxis: {
        type: "category",
        data: xData,
      },
      yAxis: {
        type: "value",
      },
      dataZoom: [
        //给x轴设置滚动条
        {
          // end: 100 - 1500 / 31, //默认为100
          type: "slider",
          show: true,
          xAxisIndex: [0],
          // handleSize: 0, //滑动条的 左右2个滑动条的大小
          height: 14, //组件高度
          left: 30, //左边的距离
          right: 40, //右边的距离
          bottom: 40, //右边的距离
          handleColor: "#ddd", //h滑动图标的颜色
          handleStyle: {
            borderColor: "#cacaca",
            borderWidth: "1",
            shadowBlur: 2,
            background: "#ddd",
            shadowColor: "#ddd",
          },
          fillerColor: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
            {
              //给颜色设置渐变色 前面4个参数，给第一个设置1，第四个设置0 ，就是水平渐变
              //给第一个设置0，第四个设置1，就是垂直渐变
              offset: 0,
              color: "#1eb5e5",
            },
            {
              offset: 1,
              color: "#5ccbb1",
            },
          ]),
          backgroundColor: "#ddd", //两边未选中的滑动条区域的颜色
          showDataShadow: false, //是否显示数据阴影 默认auto
          showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
          handleIcon:
            "M-292,322.2c-3.2,0-6.4-0.6-9.3-1.9c-2.9-1.2-5.4-2.9-7.6-5.1s-3.9-4.8-5.1-7.6c-1.3-3-1.9-6.1-1.9-9.3c0-3.2,0.6-6.4,1.9-9.3c1.2-2.9,2.9-5.4,5.1-7.6s4.8-3.9,7.6-5.1c3-1.3,6.1-1.9,9.3-1.9c3.2,0,6.4,0.6,9.3,1.9c2.9,1.2,5.4,2.9,7.6,5.1s3.9,4.8,5.1,7.6c1.3,3,1.9,6.1,1.9,9.3c0,3.2-0.6,6.4-1.9,9.3c-1.2,2.9-2.9,5.4-5.1,7.6s-4.8,3.9-7.6,5.1C-285.6,321.5-288.8,322.2-292,322.2z",
          filterMode: "filter",
        },
        //下面这个属性是里面拖到
        {
          type: "inside",
          show: true,
          xAxisIndex: [0],
          disabled: true, // 禁用鼠标滚动缩放
          //  start: 0,//默认为1
          //  end: 100-1500/31,//默认为100
        },
      ],

      series: series,
    };
    PerformanceLineChart.setOption(option);
    var res_base64 = PerformanceLineChart.getDataURL({
      excludeComponents: ["toolbox"],
    });
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = "cpu_iteration" + "-" + ".png";
    res.chinese = "CPU迭代趋势图";
    this.resBase64.push(res);
  }
  public framesInfo = {
    framesCount: 0,
    start: 0,
    end: 0,
    sumTime: 0,
    FPS: 0,

    ratelist: [],
    frameTime: 0,
  };
  public calculateAverage(arr) {
    let sum = 0;
    for (let i = 0; i < arr.length; i++) {
      sum += arr[i];
    }
    return sum / arr.length;
  }
  public labelTime = (d) => {
    return (
      d.data.name +
      "(" +
      (d.parent == null
        ? "100%"
        : ((d.value / (this.stackData_obj as any).value) * 100).toFixed(2) +
          "%") +
      "," +
      d.value +
      "ms" +
      ")" +
      "\n整局平均耗时:" +
      this.ms(this.tableList, d.data.name)[0] +
      "\n对比版本整局平均耗时:" +
      this.ms(this.tableList, d.data.name)[1]
    );
  };
  public flame_serch = "";
  public func_name = "";
  public func_rate = "";
  public calculateSum(arr) {
    let sum = 0;
    for (let i = 0; i < arr.length; i++) {
      sum += arr[i];
    }
    return sum;
  }
  public labelWallTime = (d, originalColor) => {
    if (this.flame_serch === "") {
      return originalColor;
    } else {
      return d.data.name
        .toUpperCase()
        .indexOf(this.flame_serch.toUpperCase()) != 0
        ? originalColor
        : "#E600E6";
    }
    // return  d.data.name.indexOf(this.flame_serch)!=0?originalColor : "#E600E6"
  };
  public resetAddForm() {
    this.operateShow = false;
  }
  public renderFlame(selector, data) {
    let flame: any = flamegraph();
    const scrollbarWidth = this.getScrollbarWidth();
    // (this.$refs.container as any).style.width = `calc(100% - ${scrollbarWidth}px)`;

    flame
      .width(1340 - scrollbarWidth)
      .label(this.labelTime)
      .setColorMapper(this.labelWallTime)
      .transitionDuration(1000)
      .inverted(true);
    // .inverted(true);

    flame.onHover((node) => {
      this.func_name = node.data.name;
      this.func_rate = node.data.rate + "%";
    });

    d3.select(selector).datum(data).call(flame);
  }
  public getScrollbarWidth() {
    const container = document.createElement("div");
    container.style.position = "absolute";
    container.style.top = "-9999px";
    container.style.width = "100px";
    container.style.height = "100px";
    container.style.overflowY = "scroll";
    document.body.appendChild(container);

    const containerWidth = container.offsetWidth;
    const contentWidth = container.clientWidth;
    const scrollbarWidth = containerWidth - contentWidth;

    document.body.removeChild(container);

    return scrollbarWidth;
  }
  public getFramesInfo(start, end) {
    let frameTimeList = this.cpu_by_frame.series[0].slice(start, end + 1);

    let frameTime = this.calculateAverage(frameTimeList);

    this.framesInfo.start = start;
    this.framesInfo.end = end;
    this.framesInfo.framesCount = frameTimeList.length;

    (this.framesInfo.sumTime as any) = this.calculateSum(frameTimeList).toFixed(
      2
    );
    (this.framesInfo.FPS as any) = (1000 / frameTime).toFixed(2);
    (this.framesInfo.frameTime as any) = frameTime.toFixed(2);
  }
  public coordRange = [];
  public selectList = [];
  public selectStart = 0;
  public selectEnd = 0;
  public selectData(item?) {
    let list = [];
    this.selectList = [];
    if (this.coordRange.length > 0) {
      this.selectStart = this.coordRange[0];
      this.selectEnd = this.coordRange[1];
      this.series_list.forEach((v) => {
        //   let num=0
        //   console.log( v.data.filter((i,index)=>index>=this.coordRange[0]&&index<=this.coordRange[1]))
        //  v.data.filter(i=>i>=this.coordRange[0]&&i<=this.coordRange[1]).forEach(k=>{
        //   num+=k

        //  })
        //   console.log(num)
        list.push({
          name: v.name,
          value: v.data.filter(
            (i, index) =>
              index >= this.coordRange[0] && index <= this.coordRange[1]
          ),
        });
      });
    } else {
      this.series_list.forEach((v) => {
        //   let num=0
        //   console.log( v.data.filter((i,index)=>index>=this.coordRange[0]&&index<=this.coordRange[1]))
        //  v.data.filter(i=>i>=this.coordRange[0]&&i<=this.coordRange[1]).forEach(k=>{
        //   num+=k

        //  })

        list.push({
          name: v.name,
          value: v.data.filter((i, index) => index == item),
        });
      });
    }

    this.selectList = list.map((obj) => ({
      name: obj.name,
      sum: obj.value.reduce((acc, cur) => acc + cur, 0) / obj.value.length,
    }));
  }
  public get cpu_by_frame_list() {
    let list = JSON.parse(JSON.stringify(readGetdeepCpuByFrame(store)));
    let list1 = [];
    list.labels.forEach((v, index) => {
      list1.push(v.map((k) => k + "-" + index));
    });

    return list1;
  }
  public get fps_by_frame_list() {
    let list = JSON.parse(JSON.stringify(readGetdeepFpsInsideTrend(store)));
    let list1 = [];
    list.labels.forEach((v, index) => {
      list1.push(v.map((k) => k + "-" + index));
    });

    return list1;
  }
  public cpuChange() {
    this.drawCpuTrend_index();
    this.drawCpuTrend_inside();
  }
  public get_cpu_thread_by_sec(cpu_second_trend) {
    let result = {};
    for (let core_num = 0; core_num < 8; core_num++) {
      let core_num_str = core_num.toString();
      let core_trend = (cpu_second_trend.data || {})[core_num_str] || {};
      let thread_list = Object.keys(core_trend);
      let series = [];
      for (let thread of thread_list) {
        let data = core_trend[thread] || [];
        series.push(data);
      }
      result[core_num_str] = { thread_list: thread_list, series: series };
    }
    return result;
  }
  public async gpu_inside_api() {
    await dispatchDeepPerformanceCpuUsageListQQ(store, {
      project: this.localProject,
      id_test: this.id_test,
    });
    this.gpu_labels;
    this.$nextTick(() => {
      this.drawGpuInsideTrendQF();
    });
  }
  public get gpu_labels() {
    this.gpu_list = [];
    let num = 0;

    this.qf_inside?.labels?.forEach((v) => {
      num += v.length;
    });
    this.qf_inside?.labels?.forEach((v, index) => {
      this.gpu_list.push({
        label: v[0] + "-" + index,
        width: (v.length / num) * 100 + "%",
        color: this.allColorList[index],
      });
    });

    return this.gpu_list;
  }
  public gpu_list = [];
  public get_cpu_trend_by_sec(cpu_second_trend, cpu_thread_by_frame) {
    let cpu_series = cpu_second_trend.cpu.rows;
    let cpu_thread_trend = this.get_cpu_thread_by_sec(cpu_thread_by_frame);
    let result: any = {};
    result.x = cpu_second_trend.cpu.rows.timeline;
    result.AppCPU = {
      chinese: ["FPS", "AppCPU[%]"],
      series: [cpu_series.FPS, cpu_series["AppCPU[%]"]],
    };
    result.TotalCPU = {
      chinese: ["FPS", "TotalCPU[%]"],
      series: [cpu_series.FPS, cpu_series["TotalCPU[%]"]],
    };
    for (let core_num = 0; core_num < 8; core_num++) {
      let core_num_str = core_num.toString();
      result["CPU" + core_num_str] = {
        chinese: [
          "FPS",
          "CPU" + core_num_str + "[%]",
          "CPU" + core_num_str + " Freq",
        ].concat(cpu_thread_trend[core_num_str].thread_list),
        series: [
          cpu_series.FPS,
          cpu_series["CPU" + core_num_str + "[%]"],
          cpu_series["CPU" + core_num_str + " Freq"],
        ].concat(cpu_thread_trend[core_num_str].series),
      };
    }

    return result;
  }
  public async handleSelectAll2(click, type) {
    if (type === "迭代") {
      if (click == "open") {
        this.moudle_iteration_model = this.moudleIterationList;
      } else {
        this.moudle_iteration_model = [];
      }
      this.drawMoTrend();
    } else {
      if (
        this.localProject !== 4 &&
        this.localProject !== 7 &&
        this.localProject !== 48
      ) {
        if (click == "open") {
          this.moudle_model = this.moudleList;

          this.moudle_inside_data = this.moudle_mounted().filter((item) =>
            this.moudle_model.includes(item.name)
          );
        } else {
          this.moudle_model = [];
          this.moudle_inside_data = this.moudle_mounted().filter((item) =>
            this.moudle_model.includes(item.name)
          );
        }
        this.drawModuleInsideTrend();
      } else {
        if (click == "open") {
          this.moudle_model = this.moudleList;
          this.moudle_inside_data = this.moudle_mounted_qf().filter((item) =>
            this.moudle_model.includes(item.name)
          );
        } else {
          this.moudle_model = [];
          this.moudle_inside_data = this.moudle_mounted_qf().filter((item) =>
            this.moudle_model.includes(item.name)
          );
        }
        this.drawModuleInsideTrendQF();
      }
    }
  }
  public moduleChange() {
    if (
      this.localProject !== 4 &&
      this.localProject !== 7 &&
      this.localProject !== 48
    ) {
      this.moudle_inside_data = this.moudle_mounted().filter((item) =>
        this.moudle_model.includes(item.name)
      );
      this.drawModuleInsideTrend();
    } else {
      this.moudle_inside_data = this.moudle_mounted_qf().filter((item) =>
        this.moudle_model.includes(item.name)
      );
      this.drawModuleInsideTrendQF();
    }
  }
  public startValue = 0;
  public endValue = 100;
  public frame_num = "";
  public async drawAnalyseTrend() {
    let performance_line: any = document.getElementById("analyse");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    let series = [];
    let xAxis = [];
    for (let i = 0; i < this.cpu_by_frame?.frame_index.length; i++) {
      xAxis.push(i);
    }

    this.series_list[0].markLine = {
      symbol: ["circle", "arrow"],
      data: [
        {
          silent: false,
          xAxis: this.trendInex,
          label: {
            position: "end",
            formatter: String(this.trendInex * this.frame_merge_size),
            show: true,
            color: "ED5664",
          },
          lineStyle: {
            type: "solid",
            color: "#ED5664",
            width: "1",
            opacity: this.opacity,
          },
        },
      ],
    };
    contrastChart.on("datazoom", (params: any) => {
      let xAxis = (contrastChart as any).getModel().option; // 获取x轴数据 我这个是时间
      let series = (contrastChart as any).getModel().option.series[0]; // 获取数据
      let start_rate = params.start;
      let end_rate = params.end;
      this.startValue = start_rate;
      this.endValue = end_rate;
      // console.log(series); // 这个是获取的数据
      //           console.log(series.data);
      //            console.log(xAxis.rangeStart);//滑动条左端对应在xAxis.data的索引
      //           console.log(xAxis.rangeEnd);//滑动条右端对应在xAxis.data的索引
      // let timeIndexStart =
      //   this.cpu_by_frame.frame_index.length * (params.start / 100);
      // let timeIndexEnd =
      //   this.cpu_by_frame.frame_index.length * (params.end / 100);
      let start = (contrastChart as any).getModel().option.dataZoom[0]
        .startValue;
      let end = (contrastChart as any).getModel().option.dataZoom[0].endValue;

      let arr = this.cpu_by_frame.frame_index.filter((v, i) => {
        if (start === this.cpu_by_frame.frame_index.length) {
          return i >= start - 1 && i < end;
        } else {
          return i >= start && i <= end;
        }
      });
      let newLabelName = this.cpu_by_frame_list.flat().filter((v, i) => {
        if (start === this.cpu_by_frame.frame_index.length) {
          return i >= start - 1 && i < end;
        } else {
          return i >= start && i <= end;
        }
      });
      var newArr = [],
        tempArr = [];
      for (var i = 0, j = newLabelName.length; i < j; i++) {
        if (newLabelName[i] == newLabelName[i + 1]) {
          tempArr.push(newLabelName[i]);
        } else {
          tempArr.push(newLabelName[i]);
          newArr.push(tempArr.slice(0));
          tempArr.length = 0;
        }
      }

      let c = newArr.flat();
      let n = Array.from(new Set(c));
      let nameArr = [];
      let name1Arr = [];
      this.labels.forEach((v) => {
        n.forEach((j) => {
          if (v.label === j) {
            nameArr.push(v);
          }
        });
      });

      newArr.forEach((v) => {
        name1Arr.push({
          label: v[0],
          width: (v.length / arr.length) * 100 + "%",
        });
      });

      nameArr.forEach((v) => {
        name1Arr.forEach((j) => {
          if (v.label == j.label) {
            v.width = j.width;
          }
        });
      });
      this.list = nameArr;
    });
    contrastChart.getZr().on("click", (params) => {
      var pointInPixel = [params.offsetX, params.offsetY];
      this.coordRange = [];

      if (contrastChart.containPixel("grid", pointInPixel)) {
        /*此处添加具体执行代码*/

        var pointInGrid = contrastChart.convertFromPixel(
          { seriesIndex: 0 },
          pointInPixel
        );
        //X轴序号
        var xIndex = pointInGrid[0];
        var rangeY = (contrastChart as any).getModel().getComponent("yAxis")
          .axis.scale._extent;

        //获取当前图表的option
        var op = contrastChart.getOption();

        //获得图表中我们想要的数据

        var month = op.xAxis[0].data[xIndex];
        this.trendInex = month;

        this.selectData(this.trendInex);
        this.overall();
        this.getFramesInfo(month, month);

        var value = op.series[0].data[xIndex];

        month = this.cpu_by_frame?.frame_index[xIndex];
        this.times = [this.cpu_by_frame?.abs_times[xIndex]];
        this.frame_num = this.cpu_by_frame.series[0][xIndex];
        this.opacity = 1;
        this.series_list[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: false,
              xAxis: month,
              label: {
                position: "end",
                formatter: month * this.frame_merge_size,
                show: true,
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
                opacity: this.opacity,
              },
            },
          ],
        };

        this.legend_data = op.legend[0].selected;

        // contrastChart.setOption({
        //   series: this.series_list,
        // });

        this.drawAnalyseTrend();

        // let c = (this.$refs.iframeDom as any).contentWindow;
        // let iframe: any = document.getElementById("bdIframe");
        // this.testShow = false;
        dispatchDeepPerformanceCpuStack(store, {
          project: this.localProject,
          id_test: this.id_test,
          frame: month,
          thread: this.threadOptions,
        }).then((res) => {
          // this.testShow = true;
          this.inputValue = "";
          this.serch = "";
          this.table_func();
          this.tree_func();
          this.$nextTick(() => {
            (this.$refs.table as any).toggleRowExpansion(
              this.stackData_all[0],
              true
            );
          });
          this.flame_thread.forEach((v) => {
            let obj = (this.stackData_obj as any).children.filter(
              (child) => child.name === v
            );

            this.$nextTick(() => {
              let newObj = {
                ...this.stackData_obj,
                children: obj,
              };
              this.renderFlame("#" + this.replaceSpacesWithHyphens(v), newObj);
            });
          });
        });
        //
        //
      }
    });
    contrastChart.on("brushEnd", (params: any) => {
      let list = [];

      var op = contrastChart.getOption();
      if (params.areas.length > 0) {
        let start = params.areas[0]?.coordRange[0];
        let end = params.areas[0]?.coordRange[1];

        this.coordRange = [start, end];
        this.selectShow = true;
        this.opacity = 0;
        for (
          let i = params.areas[0].coordRange[0];
          i <= params.areas[0].coordRange[1];
          i++
        ) {
          list.push(i);
        }
        let all_list = [];
        // list.forEach((v) => {
        //   let i = [];
        //   i.push(this.cpu_by_frame?.frame_index[v]);
        //   i.push(this.cpu_by_frame?.abs_time[v]);
        //   all_list.push(i);
        // });
        // contrastChart.setOption({
        //    title: {
        //       backgroundColor: '#333',
        //       	text: '铁损平均值:',

        //       	left: params.batch[0].areas[0].range[1],
        //       	textStyle: {
        //         	fontSize: 14,
        //         	color: '#fff',
        //         	fontWeight:'normal'
        //       	}
        //     }
        //   });

        //       dispatchDeepPerformanceFrameProblem(store, {
        //   project: this.localProject,

        //   id_test: this.id_test,
        //   thread: this.trendOptions.thread,
        //   timelines: [this.timeline],
        // });
        this.times = this.cpu_by_frame.abs_times.slice(
          params.areas[0].coordRange[0],
          params.areas[0].coordRange[1] + 1
        );
        this.frame_num = this.cpu_by_frame.series[0].slice(
          params.areas[0].coordRange[0],
          params.areas[0].coordRange[1] + 1
        );

        this.getFramesInfo(
          params.areas[0].coordRange[0],
          params.areas[0].coordRange[1]
        );

        this.selectData();
        this.legend_data = op.legend[0].selected;
        this.drawAnalyseTrend();
        // this.testShow = false;
        dispatchDeepPerformanceCpuStackMerge(store, {
          project: this.localProject,
          id_test: Number(readGetdeepCpuByFrame(store).id_test),
          frames: list,
          threads: this.threadOptions,
        }).then((res) => {
          this.inputValue = "";
          this.serch = "";
          this.table_func();
          this.tree_func();
          if (this.localProject === 7) {
            this.$nextTick(() => {
              (this.$refs.table as any).toggleRowExpansion(
                this.stackData_all[0],
                true
              );
            });
          }

          this.flame_thread.forEach((v) => {
            let obj = (this.stackData_obj as any).children.filter(
              (child) => child.name === v
            );

            this.$nextTick(() => {
              let newObj = {
                ...this.stackData_obj,
                children: obj,
              };
              this.renderFlame("#" + this.replaceSpacesWithHyphens(v), newObj);
            });
          });
        });
      }
    });
    contrastChart.setOption({
      title: {
        text: "",
        textStyle: {
          fontSize: 16,
          fontWeight: 700,
          color: "#333",
        },
      },

      yAxis: {
        type: "value",
      },
      series: this.series_list,
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: xAxis,
        axisLabel: {
          formatter: (value, index) => {
            return value * this.frame_merge_size;
          },
        },
      },

      dataZoom: [
        //给x轴设置滚动条
        {
          start: this.startValue,
          end: this.endValue,
          type: "slider",
          show: true,
          xAxisIndex: [0],
          // handleSize: 0, //滑动条的 左右2个滑动条的大小
          height: 14, //组件高度
          left: 50, //左边的距离
          right: 40, //右边的距离
          bottom: 40, //右边的距离
          handleColor: "#ddd", //h滑动图标的颜色
          handleStyle: {
            borderColor: "#cacaca",
            borderWidth: "1",
            shadowBlur: 2,
            background: "#ddd",
            shadowColor: "#ddd",
          },
          fillerColor: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
            {
              //给颜色设置渐变色 前面4个参数，给第一个设置1，第四个设置0 ，就是水平渐变
              //给第一个设置0，第四个设置1，就是垂直渐变
              offset: 0,
              color: "#1eb5e5",
            },
            {
              offset: 1,
              color: "#5ccbb1",
            },
          ]),
          backgroundColor: "#ddd", //两边未选中的滑动条区域的颜色
          showDataShadow: false, //是否显示数据阴影 默认auto
          showDetail: true, //即拖拽时候是否显示详细数值信息 默认true
          handleIcon:
            "M-292,322.2c-3.2,0-6.4-0.6-9.3-1.9c-2.9-1.2-5.4-2.9-7.6-5.1s-3.9-4.8-5.1-7.6c-1.3-3-1.9-6.1-1.9-9.3c0-3.2,0.6-6.4,1.9-9.3c1.2-2.9,2.9-5.4,5.1-7.6s4.8-3.9,7.6-5.1c3-1.3,6.1-1.9,9.3-1.9c3.2,0,6.4,0.6,9.3,1.9c2.9,1.2,5.4,2.9,7.6,5.1s3.9,4.8,5.1,7.6c1.3,3,1.9,6.1,1.9,9.3c0,3.2-0.6,6.4-1.9,9.3c-1.2,2.9-2.9,5.4-5.1,7.6s-4.8,3.9-7.6,5.1C-285.6,321.5-288.8,322.2-292,322.2z",
          filterMode: "filter",
        },
        //下面这个属性是里面拖到
        {
          type: "inside",
          show: true,
          xAxisIndex: [0],
          // zoomLock: false,
          disabled: true, // 禁用鼠标滚动缩放
          //  start: 0,//默认为1
          //  end: 100-1500/31,//默认为100
        },
      ],
      toolbox: {
        feature: {
          saveAsImage: {},
        },
        top: 20,
      },
      brush: {
        toolbox: ["lineX"],
        // brushType: "lineX",
        transformable: false,
        xAxisIndex: 0,
        // brushMode: "multiple",
        // throttleType: "debounce", //开启选中延迟后调用回调延迟
        // throttleDelay: 1000, //选中延迟后调用回调延迟时间
      },

      tooltip: {
        trigger: "axis",
        confine: true,
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: "line", // 默认为直线，可选为：'line' | 'shadow'
        },
        formatter: (params) => {
          {
            //  只粘贴formatter了

            let relVal =
              Number(params[0].axisValueLabel) * this.frame_merge_size +
              "-" +
              (Number(params[0].axisValueLabel) + 1) * this.frame_merge_size;
            for (let i = 0; i < params.length; i++) {
              relVal +=
                "<div  style='display:flex;align-items:center;' ><div style='width:120px'>" +
                params[i].marker +
                params[i].seriesName +
                '</div><div style="font-weight:bold">' +
                (params[i].value == undefined ? "-" : params[i].value) + //   不同点
                "</div></div>";
            }

            return relVal;
          }
        },
        extraCssText: "white-space: normal; word-break: break-all;",

        //  formatter: function (params) {
        //   if (params instanceof Array) {
        //     let str = '';
        //     str += `${params[0].axisValue}<br/>`;
        //     params.forEach((m, index) => {

        //       str +=  `<span class="chart-tooltip-color" style="display: inline-block; margin-right: 10px; background-color: ${m.color}; width: 10px; height: 10px; border-radius:100%; margin-right: 5px"></span>`;
        //       str += `${m.seriesName}：${m.data==null?'--':m.data}`;
        //       str += `${index % 4 === 0 ? '<br/>' : ''}`; //一排放几个可根据实际情况改变
        //     });
        //     return str;
        //   }
        // },
      },
      legend: {
        type: "scroll",
        y: "bottom",

        selected: this.legend_data,
        //     formatter: function(name) {
        //   // 根据需要返回不同的文本内容
        //   return name.split['_'][0]
        // }
      },
      grid: {
        left: "8%",
        right: "4%",
        bottom: "25%",
        top: "20%",
        // containLabel: true,
      },
      animation: false,
      itemStyle: {
        normal: {
          color: "#3ba272",
          lineStyle: {
            width: 1, // 正常时的折线宽度
          },
        },
        emphasis: {
          lineStyle: {
            width: 1, // hover时的折线宽度
          },
        },
      },
      itemStyle2: {
        normal: {
          lineStyle: {
            width: 1,
          },
        },
        emphasis: {
          lineStyle: {
            width: 1, // hover时的折线宽度
          },
        },
      },
    });
    contrastChart.dispatchAction({
      type: "brush",
      areas: [
        {
          brushType: "lineX",
          coordRange: this.coordRange,
          xAxisIndex: 0,
        },
      ],
    });
    contrastChart.dispatchAction({
      // 刷选模式的开关。使用此 action 可将当前鼠标变为可刷选状态。 事实上，点击 toolbox 中的 brush 按钮时，就是通过这个 action，将当前普通鼠标变为刷选器的。
      type: "takeGlobalCursor",
      // 如果想变为“可刷选状态”，必须设置。不设置则会关闭“可刷选状态”。
      key: "brush",
      brushOption: {
        // 参见 brush 组件的 brushType。如果设置为 false 则关闭“可刷选状态”。
        brushType: "lineX",
        // 参见 brush 组件的 brushMode。如果不设置，则取 brush 组件的 brushMode 设置。
        brushMode: "single",
      },
    });
  }
  public risk = "";
  public async confirm() {
    this.id_test = this.versionsOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.version
    )[0].id_test;
    let old_test = this.versionsOldOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.old_verson
    )[0].id_test;
    await dispatchDeepPerformanceCpuDetail(store, {
      project: this.localProject,
      id_test: this.id_test,
    });

    // await this.thread_options_creat();
    // await dispatchDeepPerformanceCputhreadByFrame(store, {
    //   project: this.localProject,
    //   id_test: this.id_test,
    // });
    // this.cpu_thread = this.cpu_thead_options[0];
    // if (this.cpu_thead_options.length > 0) {
    //   this.drawCpuThreadByFrame();
    // }
    // await dispatchDeepPerformancefuncList(store, {
    //   project: this.localProject,
    //   id_test: this.id_test,
    //   old_test: old_test,
    // });
    // this.func_time();
    this.$router.push({
      query: {
        ...this.$route.query,
        auto: this.auto_query,
        type: this.type_query,
        subtype: this.subtype_query,
        scene_id: this.dataConsumeOptions.scene,
        device_id: this.dataConsumeOptions.device,
        id_test: this.id_test,
        old_test: old_test,
      },
    });
    dispatchDeepPerformanceCpuReport(store, {
      project: this.localProject,

      id_test: this.id_test,
      old_test: old_test,
    });

    // await this.thread_options_creat();
    // this.dataConsumeOptions.device = this.$route.query.device_id
    //   ? Number(this.$route.query.device_id)
    //   : this.device_options[0].device_id;
    // this.dataConsumeOptions.scene = this.$route.query.scene
    //   ? Number(this.$route.query.scene)
    //   :this.scene_options[0].scene_id;

    this.cpu_index = "AppCPU";

    await this.fps_detail_creat();
    this.cpuPerfTrend_creat();
    this.gpu_inside_api();
  }
}
